<template>
    <div class="chat-app">
        <Navbar 
            :showBackButton="true" 
            @back="goBack"
        />
        <!-- نوار بارگذاری خطی حین دریافت اطلاعات گردش کار -->
        <div v-if="isPersonDocsLoading" class="top-linear-progress-bar">
        <div class="progress-bar-indeterminate"></div>
        </div>

        <!-- Modern Navbar -->
        <header class="app-navbar">
            <div class="navbar-inner">
                <div class="nav-left">
                      <button 
                        class="icon-btn toggle-view-btn" 
                        :class="{ 'active-view': isPersonView }" 
                        @click="togglePersonDocumentsView" 
                        :title="isPersonView ? 'بازگشت به لیست نامه‌های عادی' : 'نمایش گردش کار و نامه‌های من'"
                    >
                        <i class="fas" :class="isPersonView ? 'fa-list-ul' : 'fa-envelope-open-text'"></i>
                        <span class="btn-label">{{ isPersonView ? 'نامه‌های عادی' : 'نامه‌های من' }}</span>
                    </button>
                    <NotificationBell @notify="onNotify" />
                </div>
                <div class="nav-right">
                    <span class="letter-count-badge">{{ letters.length }}</span>
                    <button class="nav-btn" @click="showTutorial = true" title="راهنما" style="font-size: 18px;">
                        <i class="fas fa-question-circle"></i>
                    </button>
                    <button class="nav-btn primary-btn" @click="openNewChatModal('')" aria-label="نامه جدید">
                        <i class="fas fa-plus"></i>
                    </button>
                </div>
            </div>
        </header>

        <!-- Push notification invitation -->
        <div
            v-if="showPushPrompt"
            class="push-prompt-overlay"
            @click.self="dismissPushPrompt"
        >
            <div class="push-prompt-modal" role="dialog" aria-modal="true" dir="rtl">
                <div class="push-prompt-icon">
                    <i class="fas fa-bell"></i>
                </div>
                <h3 class="push-prompt-title">دریافت اعلان‌های نامه‌ها</h3>
                <p class="push-prompt-text">
                    برای اینکه از نامه‌ها و پیام‌های جدید باخبر شوید، اعلان‌ها را روشن کنید.
                </p>
                <p class="push-prompt-hint">
                    هر زمان خواستید می‌توانید اعلان‌ها را از طریق آیکون زنگوله بالای صفحه روشن یا خاموش کنید.
                </p>
                <p v-if="pushPromptError" class="push-prompt-error">
                    {{ pushPromptError }}
                </p>
                <div class="push-prompt-actions">
                    <button
                        type="button"
                        class="push-prompt-btn secondary"
                        :disabled="pushPromptBusy"
                        @click="dismissPushPrompt"
                    >
                        فعلاً نه
                    </button>
                    <button
                        type="button"
                        class="push-prompt-btn primary"
                        :disabled="pushPromptBusy"
                        @click="enablePushNotifications"
                    >
                        <i v-if="pushPromptBusy" class="fas fa-spinner fa-spin"></i>
                        <i v-else class="fas fa-bell"></i>
                        روشن کردن اعلان‌ها
                    </button>
                </div>
            </div>
        </div>

        <!-- Main Container -->
        <div class="chat-container">
            <div class="chat-layout">
                <!-- Sidebar -->
                <aside class="chat-sidebar" :class="{ 'sidebar-hidden': isMobile && showChat }">
                    <!-- ===== LETTERS TABS ===== -->
                    <div class="letters-tabs">
                        <button
                            v-for="tab in visibleLetterTabs"
                            :key="tab.id"
                            class="letters-tab-btn"
                            :class="{ active: activeLetterTab === tab.id }"
                            @click="activeLetterTab = tab.id"
                            type="button"
                        >
                            <i class="fas" :class="tab.icon"></i>
                            <span>{{ tab.label }}</span>
                            <span class="letters-tab-count" :class="{ zero: getLetterTabCount(tab.id) === 0 }" style="color: black;">
                            {{ getLetterTabCount(tab.id) }}
                            </span>
                        </button>
                    </div>
                    <div class="sidebar-search">
                        <div class="sidebar-search-row">
                        <div class="search-wrapper">
                            <i class="fas fa-search search-icon"></i>
                            <input
                            type="text"
                            v-model="searchQuery"
                            placeholder="جستجو در نامه‌ها..."
                            class="search-input"
                            />
                            <button v-if="searchQuery" class="clear-search" @click="searchQuery = ''">
                            <i class="fas fa-times-circle"></i>
                            </button>
                        </div>
                        <button
                            type="button"
                            class="letters-filter-toggle"
                            :class="{ active: showLettersFilter || filterAct || (!isCustomerOnly && filterAc) }"
                            :aria-expanded="showLettersFilter ? 'true' : 'false'"
                            aria-label="Toggle letter filters"
                            title="Letter filters"
                            @click="showLettersFilter = !showLettersFilter"
                        >
                            <i class="fas fa-filter"></i>
                            <span v-if="filterAct || (!isCustomerOnly && filterAc)" class="filter-active-dot"></span>
                        </button>
                        </div>

                            <!-- ===== AC / ACT FILTER ===== -->
                            <!-- Sidebar filter -->
                            <div v-if="showLettersFilter" class="letters-filter">
                            <!-- Hide AC dropdown for customer-only -->
                            <div class="filter-row">
                                <label class="filter-label">
                                <i class="fas fa-folder"></i>
                                <span>نوع</span>
                                </label>
                                <select
                                v-model="filterAc"
                                class="filter-select"
                                @change="onFilterAcChange"
                                >
                                <option v-if="!isCustomerOnly" :value="null">همه</option>
                                <option
                                    v-for="group in visibleActDocsGroupsFilter"
                                    :key="group.Ac_Title"
                                    :value="group.Ac"
                                >
                                    {{ group.Ac_Title }}
                                </option>
                                </select>
                            </div>

                            <div class="filter-row">
                                <label class="filter-label">
                                <i class="fas fa-tag"></i>
                                <span>موضوع</span>
                                </label>
                                <select
                                v-model="filterAct"
                                class="filter-select"
                                :disabled="!filterAc && !isCustomerOnly"
                                >
                                <option :value="null">همه</option>
                                <option
                                    v-for="item in filterActOptions"
                                    :key="item.Act"
                                    :value="item.Act"
                                >
                                    {{ item.Act_Title }}
                                </option>
                                </select>
                            </div>

                            <button
                                v-if="filterAct || (!isCustomerOnly && filterAc)"
                                type="button"
                                class="filter-clear-btn"
                                @click="clearLetterFilters"
                            >
                                <i class="fas fa-times"></i>
                                پاک کردن فیلتر
                            </button>
                            </div>
                        </div>

                    <!-- Letter List -->
                    <div class="letter-list">
                        <!-- Loading State for Documents -->
                        <div v-if="isLoadingDocs || isFilterRefetching" class="loading-state">
                            <div class="loading-spinner-container">
                                <div class="loading-spinner"></div>
                                <div class="loading-text">{{ loadingMessage }}</div>
                                <div class="loading-progress-bar">
                                    <div class="loading-progress-fill" :style="{ width: loadingProgress + '%' }"></div>
                                </div>
                            </div>
                        </div>

                        <div v-if="!isLoadingDocs">
                            <!-- Hint Box for Typ -->
                            <div class="typ-hint-box">
                                <div class="hint-item">
                                    <span class="hint-dot type-1"></span>
                                    <span class="hint-label">ارسال کننده</span>
                                </div>
                                <div class="hint-item">
                                    <span class="hint-dot type-2"></span>
                                    <span class="hint-label">گیرنده</span>
                                </div>
                                <div class="hint-item">
                                    <span class="hint-dot type-3"></span>
                                    <span class="hint-label">ارجاع داده</span>
                                </div>
                                <div class="hint-item">
                                    <span class="hint-dot type-4"></span>
                                    <span class="hint-label">بهش ارجاع شده</span>
                                </div>
                            </div>
                        </div>

                        <div
                        v-for="(item, index) in filteredLetters"
                        :key="item.IDDocItem || item.id || index"
                        class="letter-item"
                        style="margin-top: 5px;"
                        :class="{
                            active: selectedLetter && selectedLetter.IDDocItem === item.IDDocItem,
                            'type-1': item.typ === 1,
                            'type-2': item.typ === 2,
                            'type-3': item.typ === 3,
                            'type-4': item.typ === 4
                        }"
                        @click="selectLetter(index)"
                        >
                        <span v-if="item.MohalKar" class="letter-mohalkar">{{ item.MohalKar }}</span>

                        <div class="letter-avatar">
                            <span class="avatar-emoji">{{ item.IDDocItem }}</span>
                            <!-- NEW: unseen dot based on Seen -->
                            <span
                            v-if="isLetterUnseen(item)"
                            class="unread-dot"
                            :title="isLastActUnseen(item) ? 'پیام جدید' : 'نامه جدید'"
                            >
                            <i class="fas" :class="isLastActUnseen(item) ? 'fa-comment' : 'fa-envelope'"></i>
                        </span>
                    </div>
                    
                    <div class="letter-info">
                            <div class="letter-sender">
                                <span class="from">{{ item.Sender || 'فرستنده' }}</span>
                                <i class="fas fa-arrow-left"></i>
                                <span class="to">{{ item.Receiver || 'گیرنده' }}</span>
                                <i v-if="item.LastTake" class="fas fa-solid fa-ellipsis"></i>
                                <span v-if="item.LastTake" class="to">{{ item.LastTake || 'مقصد' }}</span>

                                <!-- NEW: "new message" pill -->
                                <span
                                    v-if="isLetterUnseen(item) && isLastActUnseen(item)"
                                    class="new-msg-pill"
                                >
                                    پیام جدید
                                </span>
                                <span
                                    v-else-if="isLetterUnseen(item)"
                                    class="new-doc-pill"
                                >
                                    نامه جدید
                                </span>
                            </div>
                            <div class="letter-preview">{{ item.summary || item.description || 'بدون توضیحات' }}</div>
                        </div>

                        <div class="letter-meta">
                            <span class="letter-date">{{ formatTime(item.LastDate) || formatTime(item.date) }}</span>
                            <span class="letter-type-badge" :class="'type-' + (item.typ || 0)">
                            {{ getTypLabel(item.typ) }}
                            </span>
                            <span v-if="item.status === 'sent'" class="status-sent"><i class="fas fa-check-double"></i></span>
                            <span v-else-if="item.status === 'delivered'" class="status-delivered"><i class="fas fa-check"></i></span>
                            <span v-else-if="item.status === 'pending'" class="status-pending"><i class="fas fa-clock"></i></span>

                            <!-- ✅ Close button (only if not already closed) -->
                            <button
                            v-if="isEmployee && !isLetterClosed(item)"
                            class="letter-done-toggle"
                            :class="{ 'is-done': isLetterDone(item) }"
                            type="button"
                            role="switch"
                            :aria-checked="isLetterDone(item)"
                            :disabled="isLetterDone(item) || completingLetterId === String(item.Doc_Auto || item.IDDocItem)"
                            :title="isLetterDone(item) ? 'پایان کار و منتظر تأیید مشتری است' : 'پایان کار'"
                            @click.stop="markLetterDone(item)"
                            >
                            <i :class="isLetterDone(item) ? 'fas fa-check-circle' : 'far fa-circle'" aria-hidden="true"></i>
                            <span>{{ completingLetterId === String(item.Doc_Auto || item.IDDocItem) ? 'در حال ثبت...' : (isLetterDone(item) ? 'انجام شد · منتظر مشتری' : 'پایان کار') }}</span>
                            </button>

                            <button
                            v-if="isCustomer && isLetterDone(item) && !isLetterClosed(item) && isUserTheCreator(item)"
                            class="letter-close-btn"
                            type="button"
                            title="بستن نامه"
                            @click.stop="closeLetter(item)"
                            >
                            <i class="fas fa-lock" aria-hidden="true"></i>
                            <span class="letter-close-label">بستن نامه</span>
                            </button>

                            <!-- Closed badge -->
                            <span v-else-if="isLetterClosed(item)" class="letter-closed-badge" title="بسته شده">
                            <i class="fas fa-star" aria-hidden="true"></i>
                            <span class="letter-closed-label">{{item.RateDoc}}</span>
                            </span>
                        </div>
                        </div>

                        <div v-if="!isLoadingDocs && filteredLetters.length === 0" class="empty-state">
                            <i class="fas fa-inbox empty-icon"></i>
                            <p class="empty-title">هیچ نامه‌ای وجود ندارد</p>
                            <p class="empty-sub">اولین نامه را ارسال کنید</p>
                        </div>
                    </div>
                </aside>

                <!-- Chat Area -->
                <section class="chat-area" :class="{ 'chat-active': showChat }">
                    <!-- Chat Header -->
                    <div class="chat-header" v-if="selectedLetter">
                        <div class="header-left" >
                            <div class="chat-avatar">
                                <i class="fas fa-envelope"></i>
                            </div>
                            <div class="chat-contact-info">
                                <button
                                    type="button"
                                    class="contact-name-button"
                                    :title="participantSummary"
                                    @click="showParticipantsModal = true"
                                >
                                    <h3 class="contact-name">{{ participantSummary }}</h3>
                                    <i class="fas fa-chevron-down" aria-hidden="true"></i>
                                </button>
                                <span class="contact-status">
                                    <span class="status-dot online"></span>
                                    {{ selectedLetter.status === 'sent' ? 'ارسال شده' : 'در انتظار' }}
                                </span>
                            </div>
                        </div>
                        <div class="header-actions">
                            <button class="action-btn" @click="viewLetterDetails" title="جزئیات">
                                <i class="fas fa-file-alt"></i>
                            </button>
                            <button class="action-btn" @click="openReferenceModal" title="ارجاع نامه">
                                <i class="fas fa-share"></i>
                            </button>
                        </div>
                    </div>

                    <div class="chat-header" v-else>
                        <div class="header-left">
                            <div class="chat-avatar">
                                <i class="fas fa-inbox"></i>
                            </div>
                            <div class="chat-contact-info">
                                <h3 class="contact-name">نامه‌ها</h3>
                                <span class="contact-status">یک نامه را انتخاب کنید</span>
                            </div>
                        </div>
                    </div>

                    <!-- Messages -->
                    <div class="chat-messages" ref="messagesContainer" @scroll="handleChatScroll">
                        <div v-if="isLoadingActivities" class="loading-state chat-loading">
                            <div class="loading-spinner-container">
                                <div class="loading-spinner"></div>
                                <div class="loading-text">{{ loadingMessage }}</div>
                                <div class="loading-progress-bar">
                                    <div class="loading-progress-fill" :style="{ width: loadingProgress + '%' }"></div>
                                </div>
                            </div>
                        </div>
                        <!-- Use filteredMessages directly -->
                        <div v-if="selectedLetter && filteredMessages.length > 0">
                            <div 
                                v-for="(msg, idx) in filteredMessages" 
                                :key="getMessageKey(msg, idx)" 
                                class="message-wrapper" 
                                :class="[
                                    msg.sender === 'user' ? 'sent' : 'received',
                                    { 'private-act-message': Number(msg.privateAct ?? msg.activityData?.PrivateAct) === 1 }
                                ]"
                            >
                                <!-- Sender Name -->
                                <div class="sender-name-wrapper">
                                    <span class="sender-name" :class="msg.sender === 'user' ? 'sender-name-right' : 'sender-name-left'">
                                        {{ msg.senderName || (msg.sender === 'user' ? 'شما' : 'کاربر') }}
                                    </span>
                                    <span class="message-time-separator">
                                        {{ formatTime(msg.timestamp) }}
                                    </span>
                                    <!-- Three dots menu for each message -->
                                    <button class="msg-menu-btn" style="color: var(--text);" @click.stop="openMessageActions(msg, idx)" title="عملیات">
                                        <i class="fas fa-ellipsis-v"></i>
                                    </button>
                                </div>

                                <div v-if="msg.isTwoPersonHistory && msg.receiverName" class="message-recipient">
                                    به: {{ msg.receiverName }}
                                </div>

                                <div
                                    v-if="Number(msg.privateAct ?? msg.activityData?.PrivateAct) === 1"
                                    class="private-act-indicator"
                                    :class="msg.sender === 'user' ? 'private-act-indicator-sent' : 'private-act-indicator-received'"
                                >
                                    <i class="fas fa-lock"></i>
                                    <span>خصوصی · قابل مشاهده برای</span>
                                    <strong>{{ msg.giveName || msg.activityData?.Give || 'فرستنده' }}</strong>
                                    <span>و</span>
                                    <strong>{{ msg.takeName || msg.activityData?.Take || 'گیرنده' }}</strong>
                                </div>

                                <!-- Forward Context - Special UI for TypAct: 2 -->
                                <div v-if="msg.isForwarded && msg.typAct === 2" class="forwarded-context" :class="msg.sender === 'user' ? 'forwarded-context-sent' : 'forwarded-context-received'">
                                    <div class="forwarded-header">
                                        <i class="fas fa-share forwarded-icon"></i>
                                        <span class="forwarded-label">بازارسال شده</span>
                                    </div>
                                    <div class="forwarded-info">
                                        <span class="forwarded-from">
                                            <i class="fas fa-user"></i>
                                            از: {{ msg.forwardFrom || 'نامشخص' }}
                                        </span>
                                        <span class="forwarded-to">
                                            <i class="fas fa-user-check"></i>
                                            به: {{ msg.forwardTo || 'نامشخص' }}
                                        </span>
                                    </div>
                                    <!-- Original Message Preview - Clickable -->
                                    <div v-if="msg.originalMessagePreview" 
                                        class="original-message-preview" 
                                        @click="scrollToOriginalForwardedMessage(msg.originalDocActAuto)">
                                        <div class="preview-text">
                                            {{ truncateText(msg.originalMessagePreview.text, 40) || 'پیام' }}
                                        </div>
                                        <div v-if="msg.originalMessagePreview.hasFile" class="preview-file">
                                            <i class="fas fa-paperclip"></i>
                                            <span>فایل ضمیمه</span>
                                        </div>
                                    </div>
                                    <div v-else class="original-message-not-found">
                                        <i class="fas fa-info-circle"></i>
                                        <span>پیام اصلی موجود نیست</span>
                                    </div>
                                </div>

                                <!-- Reply Context -->
                                <div v-if="msg.replyTo" class="reply-context" :class="msg.sender === 'user' ? 'reply-context-sent' : 'reply-context-received'">
                                    <div class="reply-context-header">
                                        <i class="fas fa-reply"></i>
                                        <span class="reply-context-sender">{{ msg.replyToSender || 'کاربر' }}</span>
                                    </div>
                                    <div class="reply-context-text">
                                        {{ msg.replyToText || 'پیام' }}
                                    </div>
                                    <div v-if="msg.replyToHasFile" class="reply-context-file">
                                        <i class="fas fa-paperclip"></i>
                                        <span>فایل ضمیمه</span>
                                    </div>
                                </div>
                                
                                <div class="message-bubble-wrapper">
                                    <div class="message-bubble" :class="msg.sender === 'user' ? 'bubble-sent' : 'bubble-received'" 
                                        :style="msg.sender === 'user' ? 'background-color: var(--primary); color: white;' : 'background-color: var(--subtext-opposite);'">
                                        <div class="message-content">
                                            <!-- File Preview based on type -->
                                            <div v-if="msg.image || msg.file_url" class="message-file">
                                                <!-- IMAGE -->
                                                <div v-if="msg.file_type === 'image' || msg.file_type === 'عکس' || (msg.image && isImageUrl(msg.image))" class="message-image" @click="previewImage(getProxiedImage(msg.image || msg.file_url))">
                                                    <img :src="getProxiedImage(msg.image || msg.file_url)" alt="تصویر نامه" @error="handleImageError" />
                                                    <div class="image-overlay">
                                                        <i class="fas fa-expand"></i>
                                                    </div>
                                                </div>
                                                <!-- AUDIO / VOICE -->
                                                <div v-else-if="msg.file_type === 'audio' || msg.file_type === 'voice' || msg.file_type === 'صدا' || (msg.image && isAudioUrl(msg.image))" class="message-audio">
                                                    <div class="audio-player">
                                                        <i class="fas fa-music audio-icon"></i>
                                                        <div class="audio-wrapper">
                                                            <audio controls preload="metadata">
                                                                <source :src="getProxiedImage(msg.image || msg.file_url)" :type="msg.mime_type || getAudioMimeType(msg.image || msg.file_url)" />
                                                                مرورگر شما از پخش صوت پشتیبانی نمی‌کند
                                                            </audio>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- VIDEO -->
                                                <div v-else-if="msg.file_type === 'video' || msg.file_type === 'ویدئو' || (msg.image && isVideoUrl(msg.image))" class="message-video">
                                                    <video controls preload="metadata">
                                                        <source :src="getProxiedImage(msg.image || msg.file_url)" :type="msg.mime_type || 'video/mp4'" />
                                                        مرورگر شما از پخش ویدئو پشتیبانی نمی‌کند
                                                    </video>
                                                </div>
                                                <!-- PDF -->
                                                <div v-else-if="msg.file_type === 'pdf' || (msg.image && isPdfUrl(msg.image))" class="message-document">
                                                    <a :href="getProxiedImage(msg.image || msg.file_url)" target="_blank" class="document-link" :style="msg.sender === 'user' ? 'color: white;' : ''" download>
                                                        <i class="fas fa-file-pdf doc-icon"></i>
                                                        <span class="doc-name">{{ msg.file_name || 'مشاهده PDF' }}</span>
                                                        <i class="fas fa-download"></i>
                                                    </a>
                                                </div>
                                                <!-- DOCUMENT -->
                                                <div v-else-if="msg.file_type === 'document' || msg.file_type === 'فایل'" class="message-document">
                                                    <a :href="getProxiedImage(msg.image || msg.file_url)" target="_blank" class="document-link" :style="msg.sender === 'user' ? 'color: white;' : ''" download>
                                                        <i class="fas" :class="msg.icon || 'fa-file-word'"></i>
                                                        <span class="doc-name">{{ msg.file_name || 'مشاهده فایل' }}</span>
                                                        <i class="fas fa-download"></i>
                                                    </a>
                                                </div>
                                                <!-- ARCHIVE -->
                                                <div v-else-if="msg.file_type === 'archive'" class="message-document">
                                                    <a :href="getProxiedImage(msg.image || msg.file_url)" target="_blank" class="document-link" :style="msg.sender === 'user' ? 'color: white;' : ''" download>
                                                        <i class="fas fa-file-archive doc-icon"></i>
                                                        <span class="doc-name">{{ msg.file_name || 'دانلود فایل' }}</span>
                                                        <i class="fas fa-download"></i>
                                                    </a>
                                                </div>
                                                <!-- OTHER FILES -->
                                                <div v-else class="message-file-other">
                                                    <a :href="getProxiedImage(msg.image || msg.file_url)" target="_blank" class="file-link" :style="msg.sender === 'user' ? 'color: white;' : ''" download>
                                                        <i class="fas fa-file"></i>
                                                        <span class="file-name">{{ msg.file_name || 'مشاهده فایل' }}</span>
                                                        <i class="fas fa-download"></i>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="message-text" :class="msg.sender === 'user' ? 'text-sent' : 'text-received'" v-if="msg.text && msg.text.trim()">{{ msg.text }}</div>
                                        </div>
                                        <div class="message-footer" :style="msg.sender === 'user' ? 'color: rgba(255,255,255,0.8);' : 'color: white;'">
                                            <span v-if="msg.sender === 'user' && msg.status" class="msg-status">
                                                <i v-if="msg.status === 'sent'" class="fas fa-check-double" style="color: rgba(255,255,255,0.8);"></i>
                                                <i v-else-if="msg.status === 'pending'" class="fas fa-clock" style="color: rgba(255,255,255,0.5);"></i>
                                                <i v-else-if="msg.status === 'error'" class="fas fa-exclamation-circle" style="color: #EF4444;"></i>
                                                <i v-else-if="msg.status === 'delivered'" class="fas fa-check-double" style="color: #22C55E;"></i>
                                                <i v-else-if="msg.status === 'read'" class="fas fa-check-double" style="color: #3B82F6;"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Empty states -->
                        <div v-else-if="!isLoadingActivities && selectedLetter" class="empty-chat">
                            <i class="fas fa-comment-dots empty-icon" style="color: var(--text-muted);"></i>
                            <p style="color: var(--text);">هنوز پیامی ارسال نشده است</p>
                            <span class="empty-hint" style="color: var(--text-muted);">اولین پیام را بنویسید</span>
                        </div>
                        <div v-else-if="!isLoadingActivities && !selectedLetter" class="empty-chat">
                            <i class="fas fa-envelope-open-text empty-icon" style="color: var(--text-muted);"></i>
                            <p style="color: var(--text);">یک نامه را انتخاب کنید</p>
                            <span class="empty-hint" style="color: var(--text-muted);">از لیست سمت چپ یک نامه انتخاب کنید</span>
                        </div>
                        <!-- دکمه شناور اسکرول به پایین (Scroll to bottom) -->
                        <transition name="fade-slide">
                        <button 
                            v-if="showScrollBottomBtn" 
                            class="scroll-bottom-floating-btn" 
                            @click="scrollToBottomSmooth" 
                            title="پرش به آخرین پیام"
                        >
                            <i class="fas fa-chevron-down"></i>
                            <span v-if="unreadScrollCount > 0" class="scroll-unread-badge">{{ unreadScrollCount }}</span>
                        </button>
                        </transition>
                    </div>



                    <!-- Reply Indicator -->
                    <div v-if="isReplying && replyToMessage" class="reply-indicator">
                        <div class="reply-indicator-content">
                            <div class="reply-indicator-header">
                                <i class="fas fa-reply reply-icon"></i>
                                <span class="reply-indicator-label">پاسخ به</span>
                                <span class="reply-indicator-sender">{{ replyToMessage.senderName || 'کاربر' }}</span>
                                <button class="reply-indicator-cancel" @click="cancelReply">
                                    <i class="fas fa-times"></i>
                                </button>
                            </div>
                            <label class="private-reference-option reply-private-option">
                                <input v-model="isPrivateReplying" type="checkbox">
                                <span style="color: var(--text);">این پاسخ خصوصی باشد</span>
                            </label>
                            <div class="reply-indicator-text">{{ truncateText(replyToMessage.text, 40) || 'بدون متن' }}</div>
                            <div v-if="replyToMessage.file_url" class="reply-indicator-file">
                                <i class="fas fa-paperclip"></i>
                                <span>{{ truncateText(replyToMessage.file_name, 20) || 'فایل ضمیمه' }}</span>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Chat Input -->
                    <div class="chat-input-area" v-if="selectedLetter">
                        <div class="input-actions">
                            <button class="tool-btn" @click="attachImage" title="ضمیمه تصویر">
                                <i class="fas fa-paperclip"></i>
                            </button>
                            <button class="tool-btn" @click="toggleRecording" title="ضبط صدا" :class="{ 'recording': isRecording }">
                                <i class="fas" :class="isRecording ? 'fa-stop' : 'fa-microphone'"></i>
                            </button>
                            <input 
                                type="file" 
                                ref="fileInput" 
                                accept="image/*,audio/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip,.rar"
                                @change="handleFileUpload"
                                style="display: none"
                            />
                        </div>
                        <div class="input-wrapper" style="padding: 0px;">
                            <!-- Recording indicator -->
                            <div v-if="isRecording" class="recording-indicator">
                                <span class="recording-dot"></span>
                                <span class="recording-text">در حال ضبط...</span>
                                <span class="recording-timer">{{ recordingTime }}</span>
                            </div>
                            
                            <!-- Textarea -->
                            <textarea 
                                v-else
                                v-model="newMessage" 
                                @input="autoResizeTextarea"
                                placeholder="پیام خود را بنویسید..."
                                class="message-input"
                                rows="1"
                                ref="messageInput"
                                style="padding: 10px; background-color: var(--bg);"
                            ></textarea>
                            
                            <!-- Pending File Display -->
                            <div v-if="pendingFile" class="pending-file">
                                <i class="fas" :class="pendingFile.icon || 'fa-file'"></i>
                                <span class="file-name" :title="pendingFile.name">{{ truncateFileName(pendingFile.name, 20) }}</span>
                                <span class="file-type-badge">{{ pendingFile.displayType }}</span>
                                <button class="remove-pending" @click="pendingFile = null">
                                    <i class="fas fa-times"></i>
                                </button>
                            </div>
                        </div>
                        <button 
                            class="send-btn" 
                            @click="sendMessage"
                            :disabled="(!newMessage.trim() && !pendingFile) || isRecording"
                        >
                            <i class="fas fa-paper-plane"></i>
                        </button>
                    </div>
                </section>
            </div>
        </div>

        <!-- Reference Modal -->
        <div v-if="showReferenceModal" class="modal-overlay" @click="closeReferenceModal">
            <div class="modal1" @click.stop>
                <div class="modal-header">
                    <h3 class="modal-title">
                        <i :class="referenceIsPrivate ? 'fas fa-user-shield' : 'fas fa-share'"></i>
                        {{ referenceIsPrivate ? 'ارجاع خصوصی پیام' : 'ارجاع نامه' }}
                    </h3>
                    <button class="modal-close1" @click="closeReferenceModal">
                        <i class="fas fa-times"></i>
                    </button>
                </div>

                <div class="modal-body">
                    <!-- Customer Search for Reference -->
                    <div class="form-group">
                        <label class="form-label required">انتخاب گیرنده برای ارجاع</label>
                        <div class="customer-search">
                            <i class="fas fa-search search-indicator"></i>
                            <input 
                                type="text" 
                                v-model="referenceSearchQuery" 
                                @input="onReferenceSearchInput"
                                @click="searchReferenceCustomers('')"
                                placeholder="جستجوی گیرنده..."
                                class="customer-input"
                            />
                            <button v-if="referenceSearchQuery" class="clear-search-btn" @click="referenceSearchQuery = ''">
                                <i class="fas fa-times-circle"></i>
                            </button>
                        </div>

                        <select
                            v-if="letterParticipants.length"
                            v-model="referenceParticipantId"
                            class="form-select reference-participant-select"
                            @change="selectReferenceParticipant"
                        >
                            <option value="">انتخاب از افراد این نامه...</option>
                            <option v-for="person in selectableLetterParticipants" :key="person.SubCodeId" :value="String(person.SubCodeId)">
                                {{ participantDisplayName(person) }}
                            </option>
                        </select>
                        
                        <div v-if="referenceSearchResults.length > 0" class="customer-results">
                            <div 
                                v-for="customer in referenceSearchResults" 
                                :key="customer.id"
                                class="customer-result"
                                :class="{ selected: selectedReferenceCustomer?.id === customer.id }"
                                @click="selectReferenceCustomer(customer)"
                            >
                                <div class="customer-avatar">
                                    {{ getCustomerInitial(customer) }}
                                </div>
                                <div class="customer-details">
                                    <div class="customer-name">{{ getCustomerDisplayName(customer) }}</div>
                                </div>
                                <i v-if="selectedReferenceCustomer?.id === customer.id" class="fas fa-check-circle selected-check"></i>
                            </div>
                        </div>

                        <label class="private-reference-option">
                            <input v-model="referenceIsPrivate" type="checkbox">
                            <span>ارجاع خصوصی</span>
                        </label>
                        
                        <!-- <div v-if="selectedReferenceCustomer" class="selected-customer-tag">
                            <i class="fas fa-user-check"></i>
                            <span class="tag-name">{{ getCustomerDisplayName(selectedReferenceCustomer) }}</span>
                            <button class="tag-remove" @click="selectedReferenceCustomer = null">
                                <i class="fas fa-times"></i>
                            </button>
                        </div> -->
                    </div>

                    <!-- Reference Text -->
                    <div class="form-group">
                        <label class="form-label required">متن ارجاع</label>
                        <textarea 
                            v-model="referenceText" 
                            class="form-textarea"
                            placeholder="متن ارجاع را وارد کنید..."
                            rows="4"
                        ></textarea>
                    </div>

                    <!-- File Upload for Reference -->
                    <div class="form-group">
                        <label class="form-label">ضمیمه فایل برای ارجاع</label>
                        <div class="upload-zone" @click="referenceFileInput.click()">
                            <div v-if="pendingReferenceFile" class="upload-preview" :class="pendingReferenceFile.fileType">
                                <i class="fas" :class="pendingReferenceFile.icon || 'fa-file'"></i>
                                <span class="file-name">{{ pendingReferenceFile.name }}</span>
                                <span class="file-type-label">{{ pendingReferenceFile.displayType }}</span>
                                <button class="remove-upload" @click.stop="pendingReferenceFile = null">
                                    <i class="fas fa-times"></i>
                                </button>
                            </div>
                            <div v-else class="upload-placeholder">
                                <i class="fas fa-cloud-upload-alt upload-icon"></i>
                                <span>برای آپلود فایل کلیک کنید</span>
                                <span class="upload-hint">حداکثر ۲۰ مگابایت</span>
                            </div>
                            <input 
                                type="file" 
                                ref="referenceFileInput" 
                                accept="image/*,audio/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip,.rar"
                                @change="handleReferenceFileUpload"
                                style="display: none"
                            />
                        </div>
                    </div>
                </div>

                <div class="modal-footer" style="display: flex; gap: 12px; justify-content: flex-end; flex-wrap: nowrap;">
                    <button class="btn btn-secondary" @click="closeReferenceModal">انصراف</button>
                    <button class="btn btn-primary" @click="submitReference" :disabled="!selectedReferenceCustomer || !referenceText.trim() || loadingSubmitReference">
                        <i :class="referenceIsPrivate ? 'fas fa-user-shield' : 'fas fa-share'"></i>
                        {{ referenceIsPrivate ? 'ارسال ارجاع خصوصی' : 'ارجاع نامه' }}
                    </button>
                </div>
            </div>
        </div>

        <!-- Recipient picker for private replies -->
        <div v-if="showPrivateRecipientModal" class="modal-overlay" @click.self="cancelPrivateRecipientSelection">
            <div class="modal1 private-recipient-modal" role="dialog" aria-modal="true" dir="rtl" @click.stop>
                <div class="modal-header">
                    <h3 class="modal-title"><i class="fas fa-user-shield"></i> گیرنده پاسخ خصوصی</h3>
                    <button class="modal-close1" type="button" aria-label="بستن" @click="cancelPrivateRecipientSelection">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <p class="private-recipient-help">این پاسخ فقط برای شما و گیرنده انتخاب‌شده نمایش داده می‌شود.</p>
                    <div class="form-group">
                        <label class="form-label required">انتخاب از افراد این نامه</label>
                        <select v-model="privateRecipientParticipantId" class="form-select" @change="selectPrivateLetterParticipant">
                            <option value="">انتخاب از افراد نامه...</option>
                            <option v-for="person in selectableLetterParticipants" :key="person.SubCodeId" :value="String(person.SubCodeId)">
                                {{ participantDisplayName(person) }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label class="form-label">یا جستجو در مخاطبان</label>
                        <div class="customer-search">
                            <i class="fas fa-search search-indicator"></i>
                            <input
                                v-model="privateRecipientSearchQuery"
                                type="text"
                                class="customer-input"
                                placeholder="نام یا شماره تماس را جستجو کنید..."
                                @input="onPrivateRecipientSearchInput"
                                @click="searchPrivateRecipients('')"
                            >
                        </div>
                        <div v-if="privateRecipientSearchResults.length" class="customer-results">
                            <div
                                v-for="person in privateRecipientSearchResults"
                                :key="person.id_subcode"
                                class="customer-result"
                                :class="{ selected: String(selectedPrivateRecipient?.id_subcode) === String(person.id_subcode) }"
                                @click="selectPrivateSearchRecipient(person)"
                                style="max-height: 220px; overflow-y: auto;"
                            >
                                <div class="customer-avatar">
                                    {{ getCustomerInitial(person) }}
                                </div>
                                <div class="customer-details">
                                    <div class="customer-name">{{ getCustomerDisplayName(person) }}</div>
                                </div>
                                <i v-if="String(selectedPrivateRecipient?.id_subcode) === String(person.id_subcode)"
                                class="fas fa-check-circle selected-check"></i>
                            </div>
                        </div>
                    </div>
                    <p v-if="selectedPrivateRecipient" class="private-recipient-selected">
                        گیرنده انتخاب‌شده: <strong>{{ getCustomerDisplayName(selectedPrivateRecipient) }}</strong>
                    </p>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-secondary" type="button" @click="cancelPrivateRecipientSelection">انصراف</button>
                    <button class="btn btn-primary" type="button" :disabled="!selectedPrivateRecipient?.id_subcode" @click="continuePrivateReply">
                        ادامه و نوشتن پاسخ
                    </button>
                </div>
            </div>
        </div>

        <!-- New Chat Modal -->
        <div v-if="showNewChatModal" class="modal-overlay" @click="closeNewChatModal">
            <div class="modal1" @click.stop>
                <div class="modal-header">
                    <h3 class="modal-title"><i class="fas fa-pen-fancy"></i> نامه جدید</h3>
                    <button class="modal-close1" @click="closeNewChatModal">
                        <i class="fas fa-times"></i>
                    </button>
                </div>

                <div class="modal-body">
                    <!-- ===== AC / ACT SELECTORS ===== -->
                    <div class="form-group">
                        <label class="form-label required">نوع نامه</label>
                        <select
                        id="new-letter-ac-select"
                        v-model="newLetterAc"
                        class="form-select"
                        :disabled="actDocsLoading"
                        @change="onNewLetterAcChange"
                        >
                        <option :value="null" disabled>انتخاب کنید...</option>
                        <option
                            v-for="group in visibleActDocsGroupsNewMsg"
                            :key="group.Ac_Title"
                            :value="group.Ac"
                        >
                            {{ group.Ac_Title }}
                        </option>
                        </select>
                        <span v-if="actDocsLoading" class="form-hint">در حال بارگذاری...</span>
                        <span v-else-if="actDocsError" class="form-hint error">{{ actDocsError }}</span>
                    </div>

                    <div class="form-group">
                        <label class="form-label required">موضوع نامه</label>
                        <select
                        id="new-letter-act-select"
                        v-model="newLetterAct"
                        class="form-select"
                        :disabled="!newLetterAc"
                        >
                        <option :value="null" disabled>انتخاب کنید...</option>
                        <option
                            v-for="item in newLetterActOptions"
                            :key="item.Act"
                            :value="item.Act"
                        >
                            {{ item.Act_Title }}
                        </option>
                        </select>
                        <span v-if="newLetterAc && newLetterActOptions.length === 0" class="form-hint">
                        موضوعی برای این نوع یافت نشد
                        </span>
                    </div>
                    <!-- Customer Search -->
                    <div class="form-group">
                        <label class="form-label required">گیرنده</label>
                        <div class="customer-search">
                            <i class="fas fa-search search-indicator"></i>
                            <input 
                                type="text" 
                                @click="searchCustomers"
                                v-model="customerSearchQuery" 
                                @input="onSearchInput"
                                placeholder="جستجوی مشتری..."
                                class="customer-input"
                            />
                            <button v-if="customerSearchQuery" class="clear-search-btn" @click="customerSearchQuery = ''">
                                <i class="fas fa-times-circle"></i>
                            </button>
                        </div>
                        
                        <div v-if="customerSearchResults.length > 0" class="customer-results">
                            <div 
                                v-for="customer in customerSearchResults" 
                                :key="customer.id"
                                class="customer-result"
                                :class="{ selected: selectedCustomer?.id === customer.id }"
                                @click="selectCustomer(customer)"
                            >
                                <div class="customer-avatar">
                                    {{ getCustomerInitial(customer) }}
                                </div>
                                <div class="customer-details">
                                    <div class="customer-name">{{ getCustomerDisplayName(customer) }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Letter Summary -->
                    <!-- <div class="form-group">
                        <label class="form-label required">خلاصه نامه</label>
                        <div class="customer-search">
                            <input 
                                type="text" 
                                v-model="letterSummary" 
                                placeholder="خلاصه نامه..."
                                class="customer-input"
                            />
                        </div>
                    </div>       -->

                    <!-- Message -->
                    <div class="form-group">
                        <label class="form-label required">متن نامه</label>
                        <textarea 
                            v-model="newLetterMessage" 
                            class="form-textarea"
                            placeholder="متن نامه را وارد کنید..."
                            rows="4"
                        ></textarea>
                    </div>

                    <!-- File Upload -->
                    <div class="form-group">
                        <label class="form-label">ضمیمه فایل</label>
                        <div class="upload-zone" @click="newChatFileInput.click()">
                            <div v-if="newChatFile" class="upload-preview" :class="newChatFile.fileType">
                                <i class="fas" :class="newChatFile.icon || 'fa-file'"></i>
                                <span class="file-name">{{ newChatFile.name }}</span>
                                <span class="file-type-label">{{ newChatFile.displayType }}</span>
                                <button class="remove-upload" @click.stop="newChatFile = null">
                                    <i class="fas fa-times"></i>
                                </button>
                            </div>
                            <div v-else class="upload-placeholder">
                                <i class="fas fa-cloud-upload-alt upload-icon"></i>
                                <span>برای آپلود فایل کلیک کنید</span>
                                <span class="upload-hint">حداکثر ۲۰ مگابایت</span>
                            </div>
                            <input 
                                type="file" 
                                ref="newChatFileInput" 
                                accept="image/*,audio/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip,.rar"
                                @change="handleNewChatFile"
                                style="display: none"
                            />
                        </div>
                        <div class="upload-actions">
                            <button class="btn-voice" @click="startVoiceRecording" :class="{ recording: isRecordingVoice }">
                                <i class="fas" :class="isRecordingVoice ? 'fa-stop' : 'fa-microphone'"></i>
                                {{ isRecordingVoice ? 'توقف ضبط' : 'ضبط صدا' }}
                            </button>
                            <span v-if="voiceRecordingTime" class="voice-timer">{{ voiceRecordingTime }}</span>
                        </div>
                    </div>
                </div>

                <div class="modal-footer" style="display: flex; gap: 12px; justify-content: flex-end; flex-wrap: nowrap;">
                    <button class="btn btn-secondary" @click="closeNewChatModal">انصراف</button>
                    <button
                    class="btn btn-primary"
                    @click="createNewChat"
                    :disabled="
                        !selectedCustomer ||
                        !newLetterAc ||
                        !newLetterAct ||
                        (!newLetterMessage.trim() && !newChatFile)
                    "
                    >
                    <i class="fas fa-paper-plane"></i> ارسال نامه
                    </button>
                </div>
            </div>
        </div>

        <!-- Image Preview Modal -->
        <div v-if="previewImageUrl" class="image-preview-modal" @click="previewImageUrl = null">
            <div class="preview-content" @click.stop>
                <img :src="previewImageUrl" alt="پیش‌نمایش" class="preview-image" />
                <button class="preview-close" @click="previewImageUrl = null">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </div>

        <!-- Registration Modal -->
        <div v-if="showRegistrationModal" class="registration-modal-overlay" @click="closeRegistrationModal">
            <div class="registration-modal-content" @click.stop>
                <div class="registration-modal-header">
                    <h3>📝 ثبت نام مشتری جدید</h3>
                    <button class="close-modal-btn" @click="closeRegistrationModal">×</button>
                </div>

                <div class="registration-modal-body">
                    <div class="registration-message">
                        <p>⚠️ شما در این سیستم ثبت نام نشده‌اید.</p>
                        <p>لطفاً اطلاعات زیر را برای ثبت نام وارد کنید:</p>
                    </div>

                    <form @submit.prevent="submitRegistration" class="registration-form" novalidate>

                        <!-- نام و نام خانوادگی -->
                        <div class="form-group">
                            <label for="customerName">نام و نام خانوادگی *</label>
                            <input
                                id="customerName"
                                type="text"
                                v-model="registrationData.name"
                                placeholder="مثال: علی محمدی"
                                class="form-input"
                                :class="{ 'input-error': registrationErrors.name }"
                                @input="registrationErrors.name = ''"
                            />
                            <small v-if="registrationErrors.name" class="form-error">{{ registrationErrors.name }}</small>
                        </div>

                        <!-- شماره تلفن -->
                        <div class="form-group">
                            <label for="customerPhone">شماره تلفن *</label>
                            <input
                                id="customerPhone"
                                type="tel"
                                v-model="registrationData.phone"
                                placeholder="مثال: 09123456789"
                                class="form-input"
                                readonly
                            />
                            <small class="form-hint">شماره تلفن شما به صورت خودکار از حساب کاربری گرفته شده است</small>
                        </div>

                        <!-- کد ملی -->
                        <div class="form-group">
                            <label for="customerNationalCode">کد ملی *</label>
                            <input
                                id="customerNationalCode"
                                type="text"
                                inputmode="numeric"
                                maxlength="10"
                                v-model="registrationData.national_code"
                                placeholder="۱۰ رقم، مثال: 1234567890"
                                class="form-input"
                                :class="{ 'input-error': registrationErrors.national_code }"
                                @input="onNationalCodeInput"
                            />
                            <small v-if="registrationErrors.national_code" class="form-error">
                                {{ registrationErrors.national_code }}
                            </small>
                        </div>

                        <!-- آدرس -->
                        <div class="form-group">
                            <label for="customerAddress">آدرس *</label>
                            <textarea
                                id="customerAddress"
                                v-model="registrationData.address"
                                placeholder="آدرس کامل خود را وارد کنید"
                                class="form-textarea"
                                :class="{ 'input-error': registrationErrors.address }"
                                rows="3"
                                @input="registrationErrors.address = ''"
                            ></textarea>
                            <small v-if="registrationErrors.address" class="form-error">
                                {{ registrationErrors.address }}
                            </small>
                        </div>

                        <!-- محل کار -->
                        <div class="form-group">
                            <label for="customerMohalKar">محل کار *</label>
                            <input
                                id="customerMohalKar"
                                type="text"
                                v-model="registrationData.mohal_kar"
                                placeholder="مثال: شرکت الف"
                                class="form-input"
                                :class="{ 'input-error': registrationErrors.mohal_kar }"
                                @input="registrationErrors.mohal_kar = ''"
                            />
                            <small v-if="registrationErrors.mohal_kar" class="form-error">{{ registrationErrors.mohal_kar }}</small>
                        </div>

                        <!-- کد پستی -->
                        <div class="form-group">
                            <label for="customerPostalCode">کد پستی *</label>
                            <input
                                id="customerPostalCode"
                                type="text"
                                inputmode="numeric"
                                maxlength="10"
                                v-model="registrationData.postal_code"
                                placeholder="مثال: 1234567890"
                                class="form-input"
                                :class="{ 'input-error': registrationErrors.postal_code }"
                                @input="registrationErrors.postal_code = ''"
                            />
                            <small v-if="registrationErrors.postal_code" class="form-error">{{ registrationErrors.postal_code }}</small>
                        </div>

                        <div class="form-actions">
                            <button type="button" class="cancel-btn" @click="closeRegistrationModal">انصراف</button>
                            <button type="submit" class="register-btn" :disabled="registrationLoading">
                                {{ registrationLoading ? 'در حال ثبت...' : 'ثبت نام' }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- ============ RATING MODAL ============ -->
        <div v-if="showRatingModal" class="rating-overlay" @click.self="closeRatingModal">
        <div class="rating-modal" @click.stop>
            <div class="rating-header">
            <h3>
                <i class="fas fa-star"></i>
                تجربه خود را ثبت کنید
            </h3>
            <button class="rating-close" type="button" @click="closeRatingModal">
                <i class="fas fa-times"></i>
            </button>
            </div>

            <div class="rating-body">
            <p class="rating-question">
                چقدر از فرایند این نامه راضی بودید؟
            </p>

            <!-- 5 emoji rating -->
            <div class="rating-emojis">
                <button
                v-for="opt in ratingOptions"
                :key="opt.value"
                type="button"
                class="rating-emoji-btn"
                :class="{ active: ratingValue === opt.value }"
                :title="opt.label"
                @click="selectRating(opt.value)"
                >
                <span class="rating-emoji">{{ opt.emoji }}</span>
                <span class="rating-label">{{ opt.label }}</span>
                </button>
            </div>

            <!-- Conditional feedback textarea (scores 1..3) -->
            <transition name="fade">
                <div v-if="needsRatingFeedback" class="rating-feedback">
                <label class="rating-feedback-label">
                    لطفاً دلیل خود را بنویسید <span class="required-star">*</span>
                </label>
                <textarea
                    v-model="ratingFeedback"
                    class="rating-textarea"
                    rows="3"
                    placeholder="چه چیزی می‌توانست بهتر باشد؟"
                ></textarea>
                <span v-if="ratingSubmitAttempted && !ratingFeedback.trim()" class="rating-error">
                    لطفاً دلیل را وارد کنید
                </span>
                </div>
            </transition>
            </div>

            <div class="rating-footer">
            <button
                type="button"
                class="btn btn-secondary"
                @click="closeRatingModal"
            >
                انصراف
            </button>
            <button
                type="button"
                class="btn btn-primary"
                :disabled="!canSubmitRating"
                @click="submitRating"
            >
                <i class="fas fa-paper-plane"></i>
                ثبت امتیاز
            </button>
            </div>
        </div>
        </div>

        <!-- ============ LETTER PARTICIPANTS MODAL ============ -->
        <div
            v-if="showParticipantsModal"
            class="participants-overlay"
            @click.self="showParticipantsModal = false"
        >
            <section class="participants-modal" style="background-color: var(--bg);" role="dialog" aria-modal="true" aria-labelledby="participants-title" dir="rtl">
                <header class="participants-header">
                    <div>
                        <h3 id="participants-title">افراد این نامه</h3>
                        <p>فرستندگان و گیرندگان پیام‌های این گفتگو</p>
                    </div>
                    <button type="button" class="participants-close" aria-label="بستن" @click="showParticipantsModal = false">
                        <i class="fas fa-times"></i>
                    </button>
                </header>
                <div class="participants-list">
                    <article v-for="person in letterParticipants" :key="person.SubCodeId" class="participant-card">
                        <div class="participant-avatar"><i class="fas fa-user"></i></div>
                        <div class="participant-details">
                            <strong>{{ participantDisplayName(person) }}</strong>
                            <div v-if="phoneNumbers(person).length" class="participant-phones">
                                <a
                                    v-for="phone in phoneNumbers(person)"
                                    :key="phone"
                                    class="participant-phone"
                                    :href="`tel:${phone}`"
                                    :aria-label="`تماس با ${participantDisplayName(person)}، ${phone}`"
                                >
                                    <i class="fas fa-phone" aria-hidden="true"></i>
                                    <span dir="ltr">{{ phone }}</span>
                                </a>
                            </div>
                            <span v-else class="participant-no-phone">شماره تماسی ثبت نشده است</span>
                        </div>
                    </article>
                    <p v-if="!letterParticipants.length" class="participants-empty">اطلاعات افراد این نامه در دسترس نیست.</p>
                </div>
            </section>
        </div>

        <!-- ============ UNCLOSED LETTERS WARNING ============ -->
        <div
        v-if="showUnclosedLettersWarning"
        class="close-confirm-overlay"
        @click.self="cancelUnclosedLettersWarning"
        >
        <div class="close-confirm-modal" role="dialog" aria-modal="true" dir="rtl" @click.stop>
            <div class="close-confirm-icon" style="background: rgba(245, 158, 11, 0.12); color: #f59e0b;">
            <i class="fas fa-exclamation-triangle"></i>
            </div>
            <h3 class="close-confirm-title">نامه‌های باز دارید</h3>
            <p class="close-confirm-message">
                شما {{ unclosedLettersCount }} نامه باز دارید. بهتر است پیش از ایجاد نامه جدید، آن‌ها را ببندید.
                آیا می‌خواهید با این حال ادامه دهید؟
            </p>
            <div class="close-confirm-actions">
            <button
                type="button"
                class="close-confirm-btn cancel"
                @click="cancelUnclosedLettersWarning"
            >
                انصراف
            </button>
            <button
                type="button"
                class="close-confirm-btn confirm"
                style="background: #f59e0b;"
                @click="continueCreateNewChat"
            >
                ادامه و ایجاد نامه
            </button>
            </div>
        </div>
        </div>

        <!-- ============ CLOSE CONFIRMATION MODAL ============ -->
        <div
        v-if="showCloseConfirmModal"
        class="close-confirm-overlay"
        @click.self="closeCloseConfirmModal"
        >
        <div class="close-confirm-modal" @click.stop>
            <div class="close-confirm-icon">
            <i class="fas fa-lock"></i>
            </div>

            <h3 class="close-confirm-title">بستن نامه</h3>

            <p class="close-confirm-message">
            آیا از بستن این نامه اطمینان دارید؟
            </p>

            <p
            v-if="pendingCloseLetter"
            class="close-confirm-detail"
            >
            <span class="close-confirm-detail-label">موضوع:</span>
            <span class="close-confirm-detail-value">
                {{ pendingCloseLetter.summary || pendingCloseLetter.Expl || 'بدون عنوان' }}
            </span>
            </p>

            <p class="close-confirm-note">
            <i class="fas fa-info-circle"></i>
            پس از بستن، نامه به بایگانی منتقل می‌شود و امکان بازگشت آن وجود ندارد.
            </p>

            <div class="close-confirm-actions">
            <button
                type="button"
                class="close-confirm-btn cancel"
                :disabled="isClosingLetter"
                @click="closeCloseConfirmModal"
            >
                انصراف
            </button>
            <button
                type="button"
                class="close-confirm-btn confirm"
                :disabled="isClosingLetter"
                @click="confirmCloseLetter"
            >
                <i v-if="isClosingLetter" class="fas fa-spinner fa-spin"></i>
                <i v-else class="fas fa-lock"></i>
                {{ isClosingLetter ? 'در حال بستن...' : 'بله، ببند' }}
            </button>
            </div>
        </div>
        </div>

        <!-- Message Actions Modal -->
        <div v-if="showMessageActions" class="letter-actions-overlay" @click="closeMessageActions">
            <div class="letter-actions-modal" @click.stop>
                <div class="letter-actions-header">
                    <div class="letter-actions-title">
                        <i class="fas fa-comment-dots"></i>
                        <span>عملیات روی پیام</span>
                    </div>
                    <button class="letter-actions-close" @click="closeMessageActions">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <div class="letter-actions-body">
                    <button class="letter-action-btn" @click="handleMessageReply(false)">
                        <i class="fas fa-reply"></i>
                        <span>پاسخ</span>
                    </button>
                    <button class="letter-action-btn" @click="handleMessageForward">
                        <i class="fas fa-share"></i>
                        <span>ارجاع</span>
                    </button>
                    <button class="letter-action-btn" @click="handleMessageCopy">
                        <i class="fas fa-copy"></i>
                        <span>رونوشت</span>
                    </button>
                    <button class="letter-action-btn" @click="handleMessagePendingActions">
                        <i class="fas fa-tasks"></i>
                        <span>انتقال به ...</span>
                    </button>
                    <button class="letter-action-btn" @click="handleMessageDownload">
                        <i class="fas fa-download"></i>
                        <span>دانلود</span>
                    </button>
                    <button class="letter-action-btn danger" @click="handleMessageDelete">
                        <i class="fas fa-trash-alt"></i>
                        <span>حذف</span>
                    </button>
                </div>
                <!-- ===== Seen-by section ===== -->
                <div class="seen-by-block">
                    <div class="seen-by-title">
                        <i class="fas fa-eye"></i>
                        <span>دیده شده توسط</span>
                    </div>

                    <!-- Loading -->
                    <div v-if="seenByLoading" class="seen-by-loading">
                        <span class="mini-spinner"></span>
                        <span>در حال بارگذاری...</span>
                    </div>

                    <!-- Error -->
                    <div v-else-if="seenByError" class="seen-by-error">
                        <i class="fas fa-exclamation-circle"></i>
                        <span>{{ seenByError }}</span>
                    </div>

                    <!-- List -->
                    <div v-else-if="seenByTitles.length > 0" class="seen-by-list">
                        <div
                            v-for="row in seenByTitles"
                            :key="row.SubCode"
                            class="seen-by-item"
                        >
                            <span class="seen-by-avatar">
                                {{ (row.Title || '?').charAt(0) }}
                            </span>
                            <span class="seen-by-name">
                                {{ row.Title || `کاربر ${row.SubCode}` }}
                            </span>
                        </div>
                    </div>

                    <!-- Empty -->
                    <div v-else class="seen-by-empty">
                        <i class="fas fa-user-slash"></i>
                        <span>هنوز کسی این پیام را ندیده است</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tooltip/Tutorial System -->
        <div v-if="showTutorial" class="tutorial-overlay" @click="closeTutorial">
            <div class="tutorial-container">
                <div class="tutorial-header">
                    <h3>🎯 راهنمای سریع</h3>
                    <button class="tutorial-close" @click="closeTutorial">✕</button>
                </div>
                <div class="tutorial-body">
                    <div class="tutorial-step" v-for="(step, index) in tutorialSteps" :key="index">
                        <div class="step-number">{{ index + 1 }}</div>
                        <div class="step-content">
                            <div class="step-title">{{ step.title }}</div>
                            <div class="step-description">{{ step.description }}</div>
                            <div class="step-icon">{{ step.icon }}</div>
                        </div>
                    </div>
                </div>
                <div class="tutorial-footer">
                    <button class="tutorial-btn skip-btn" @click="closeTutorial">رد کردن</button>
                    <button class="tutorial-btn next-btn" @click="nextTutorialStep" v-if="currentStep < tutorialSteps.length - 1">
                        بعدی
                    </button>
                    <button class="tutorial-btn done-btn" @click="closeTutorial" v-else>
                        شروع کنید 🚀
                    </button>
                </div>
                <div class="tutorial-dots">
                    <span 
                        v-for="(step, index) in tutorialSteps" 
                        :key="index"
                        class="tutorial-dot"
                        :class="{ active: index === currentStep }"
                        @click="currentStep = index"
                    ></span>
                </div>
            </div>
        </div>

        <!-- Tooltip Popups -->
        <div v-if="showTooltip" class="tooltip-popup" :style="tooltipStyle">
            <div class="tooltip-content">
                <span class="tooltip-text">{{ tooltipText }}</span>
                <button class="tooltip-close" @click="closeTooltip">✕</button>
            </div>
            <div class="tooltip-arrow"></div>
        </div>

        <!-- Toast -->
        <div v-if="showToast" class="toast" :class="toastType">
            <div class="toast-content">
                <i class="toast-icon" :class="toastIconClass"></i>
                <span class="toast-message">{{ toastMessage }}</span>
                <button class="toast-close" @click="showToast = false">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, reactive, onMounted, onUnmounted, computed, nextTick, watch } from 'vue'
import Navbar from '@/components/Navbar.vue'
import NotificationBell from '@/components/NotificationBell.vue'
import { useRouter } from 'vue-router'
import { officeService, authService } from '@/services/api'
import { useAuthStore } from '@/stores/auth'
import { usePushNotifications } from '@/composables/usePushNotifications'
import moment from 'moment-jalaali'

export default {
    name: 'ChatLetter',
    components:{
        Navbar,
        NotificationBell
    },
    setup() {
        const router = useRouter()
        const authStore = useAuthStore()
        const {
            permission: pushPermission,
            isSupported: pushSupported,
            subscribe: subscribeToPush,
            refreshSubscriptionState,
        } = usePushNotifications()

        const showPushPrompt = ref(false)
        const pushPromptBusy = ref(false)
        const pushPromptError = ref('')
        const pushPromptDismissedKey = 'office-letters-push-prompt-dismissed'
        const pushPromptTimer = ref(null)
        const fileInput = ref(null)
        const newChatFileInput = ref(null)
        const referenceFileInput = ref(null)
        const messageInput = ref(null)
        const messagesContainer = ref(null)
        const selectedLetterIndex = ref(null)
        const twoPersonMessages = ref([])
        const twoPersonViewLetterId = ref(null)
        const newMessage = ref('')
        const pendingFile = ref(null)
        const pendingReferenceFile = ref(null)
        const searchQuery = ref('')
        const showChat = ref(false)
        const previewImageUrl = ref(null)
        const isMobile = ref(window.innerWidth < 768)
        const isLoading = ref(false)

        // Voice Recording
        const isRecording = ref(false)
        const isRecordingVoice = ref(false)
        const recordingTime = ref('00:00')
        const voiceRecordingTime = ref('')
        const mediaRecorder = ref(null)
        const audioChunks = ref([])
        const recordingTimer = ref(null)
        
        // Reference Modal
        const showReferenceModal = ref(false)
        const referenceSearchQuery = ref('')
        const referenceSearchResults = ref([])
        const selectedReferenceCustomer = ref(null)
        const referenceParticipantId = ref('')
        const referenceIsPrivate = ref(false)
        const loadingSubmitReference = ref(false)
        const referenceText = ref('')
        const referenceSearchTimeout = ref(null)
        const referencingMessage = ref(null)
        const referenceAct = ref(null)

        const seenByCache = ref({})         
        const seenByLoading = ref(false)
        const seenByError = ref(null)
        
        // Registration Modal
        const showRegistrationModal = ref(false)
        const registrationLoading = ref(false)
        const registrationData = ref({
            name: '',
            phone: '',
            national_code: '',
            address: '',
            postal_code: '',
            mohal_kar: '',
        })
        const registrationErrors = ref({
            name: '',
            national_code: '',
            address: '',
            postal_code: '',
            mohal_kar: '',
        })
        
        const showNewChatModal = ref(false)
        const showParticipantsModal = ref(false)
        const showUnclosedLettersWarning = ref(false)
        const unclosedLettersCount = ref(0)
        const customerSearchQuery = ref('')
        const customerSearchResults = ref([])
        const selectedCustomer = ref(null)
        const newLetterMessage = ref('')
        const pendingNewChatPrefill = ref('')
        const pendingNewChatPicDocAct = ref('')
        const pendingNewChatFile = ref(null)
        const letterSummary = ref('')
        const newChatFile = ref(null)
        const customers = ref([])

        const firstMessageText = ref('')
        const firstMessageFile = ref('')
        
        const showToast = ref(false)
        const toastMessage = ref('')
        const toastType = ref('success')
        const toastIconClass = ref('fas fa-check-circle')

        const searchTimeout = ref(null)

// ==========================================
// وضعیت‌های مربوط به نمای تجمیعی اقدامات شخص
// ==========================================
const isPersonView = ref(false);
const isPersonDocsLoading = ref(false);
const cachedNormalLetters = ref([]); // برای بازگشت سریع به لیست عادی بدون لودینگ غیرضروری

/**
 * دریافت تمام اقدامات کاربر و تجمیع همه آن‌ها در قالب یک چت واحد
 */
const fetchPersonDocuments = async () => {
  const userId = authStore.user?.subCodeId || authStore.user?.id;
  if (!userId) {
    showToast('کد کاربر یافت نشد', 'warning');
    return;
  }

  isPersonDocsLoading.value = true;
  try {
    const res = await officeService.getPersonDocuments(userId);
    if (res && res.data && res.data.success) {
      const rows = res.data.documents || [];

      if (rows.length === 0) {
        showToast('هیچ اقدامی برای شما ثبت نشده است', 'info');
        letters.value = [];
        selectedLetterIndex.value = null;
        showChat.value = false;
        return;
      }

      // تبدیل تمام اکت‌های دریافتی به عنوان پیام‌های چت
      const allMessages = rows.map((row, index) => {
        const actId = row.act_id ?? row.IDDocAct ?? row.DocActAuto ?? (index + 1);
        const actSenderId = row.act_sender_id ?? row.sender_id ?? row.SenderId;
        const actSenderName = row.act_sender_name ?? row.sender_name ?? row.Sender ?? 'نامشخص';
        const actReceiverName = row.act_receiver_name ?? row.receiver_name ?? row.Receiver ?? '';
        const actDate = row.act_date ?? row.dates ?? row.Dates ?? '';
        const actTime = row.act_time ?? row.times ?? row.Tim ?? '';
        const docAuto = row.doc_auto ?? row.Doc_Auto ?? row.doc_number ?? '';
        
        // متن پیام همراه با اشاره به شماره نامه برای وضوح بیشتر
        const baseText = row.act_text ?? row.Paraf ?? row.expl ?? row.Expl ?? 'بدون شرح';
        const formattedText = docAuto ? `[نامه شماره ${docAuto}]\n${baseText}` : baseText;

        const isUserMsg = String(actSenderId) === String(userId);

        return {
          id: actId,
          docActAuto: actId,
          sender: isUserMsg ? 'user' : 'other',
          senderName: actSenderName,
          text: formattedText,
          timestamp: actTime ? `${actDate} ${actTime}`.trim() : actDate,
          status: 'sent',
          image: null,
          file_url: row.file_url ?? row.PicDocAct ?? null,
          file_name: row.file_name ?? null,
          isReference: (row.typ_act ?? row.TypAct) === 3,
          isForwarded: (row.typ_act ?? row.TypAct) === 2,
          receiverName: actReceiverName,
          rawDate: actDate,
          rawTime: actTime,
          docAuto: docAuto,
          activityData: row
        };
      });

      // مرتب‌سازی پیام‌ها بر اساس تاریخ و شناسه (از قدیمی به جدید برای جریان درست چت)
      allMessages.sort((a, b) => {
        const d1 = `${a.rawDate || ''} ${a.rawTime || ''}`;
        const d2 = `${b.rawDate || ''} ${b.rawTime || ''}`;
        if (d1 && d2 && d1 !== d2) {
          return d1.localeCompare(d2);
        }
        return (Number(a.id) || 0) - (Number(b.id) || 0);
      });

      // ساخت فقط یک نامه واحد حاوی کل پیام‌ها
      const singleCombinedLetter = {
        id: 'person-stream-doc',
        Doc_Auto: 'تمام اقدامات',
        documentId: 'person-stream-doc',
        IDDocItem: 'person-stream-doc',
        IDDocAct: 0,
        customerId: userId,
        customerName: 'جریان کلی اقدامات من',
        summary: `مجموعاً ${allMessages.length} اقدام و ارجاع ثبت شده`,
        description: 'تاریخچه کلیه فعالیت‌ها و نامه‌های دریافتی/ارسالی شما',
        Expl: 'تاریخچه کلیه فعالیت‌ها و نامه‌های دریافتی/ارسالی شما',
        Dates: rows[0]?.dates || '',
        date: rows[0]?.dates ? `${rows[0].dates} ${rows[0].times || ''}`.trim() : new Date().toISOString(),
        LastDate: rows[0]?.dates || '',
        status: 'sent',
        unread: 0,
        closeDoc: 1, // جهت جلوگیری از ارسال پیام جدید درون این ویو اگر نیاز نیست
        CloseDoc: 1,
        Sender: 'سیستم',
        SenderId: 0,
        Receiver: authStore.user?.name || 'من',
        ReceiverId: userId,
        docStatusTitle: 'گزارش تجمیعی',
        messages: allMessages,
        activities: [],
        activityLoaded: true, // مانع از لود مجدد listDocAct می‌شود
        participants: []
      };

      // قرار دادن تنها همین یک نامه و باز کردن مستقیم آن در چت
      letters.value = [singleCombinedLetter];
      selectedLetterIndex.value = 0;
      showChat.value = true;

    } else {
      showToast(res.data?.message || 'خطا در واکشی اطلاعات اقدامات', 'error');
    }
  } catch (error) {
    console.error('Error fetching person documents:', error);
    showToast('خطا در ارتباط با سرور', 'error');
  } finally {
    isPersonDocsLoading.value = false;
  }
};

/**
 * سوئیچ بین حالت تک‌نامه‌ای تمام اقدامات و بازگشت به لیست عادی
 */
const togglePersonDocumentsView = async () => {
  isPersonView.value = !isPersonView.value;

  if (isPersonView.value) {
    if (letters.value && letters.value.length > 0) {
      cachedNormalLetters.value = [...letters.value];
    }
    await fetchPersonDocuments();
    // اسکرول به آخرین پیام بعد از رندر
    nextTick(() => {
      scrollToBottomSmooth();
    });
  } else {
    // بازگشت به حالت لیست عادی
    if (cachedNormalLetters.value.length > 0) {
      letters.value = [...cachedNormalLetters.value];
      selectedLetterIndex.value = null;
      showChat.value = false;
    } else {
      selectedLetterIndex.value = null;
      showChat.value = false;
      await fetchDocuments();
    }
  }
};

        function dismissPushPrompt() {
            localStorage.setItem(pushPromptDismissedKey, '1')
            showPushPrompt.value = false
            pushPromptError.value = ''
        }

        async function checkPushNotificationSubscription() {
            if (!pushSupported.value) return

            await refreshSubscriptionState()

            const wasDismissed = localStorage.getItem(pushPromptDismissedKey) === '1'
            console.log(wasDismissed)
            if (!wasDismissed) {
                console.log(wasDismissed)
                // Let the letters page finish rendering before showing the prompt.
                pushPromptTimer.value = window.setTimeout(() => {
                    showPushPrompt.value = true
                }, 500)
            }
        }

        async function enablePushNotifications() {
            pushPromptBusy.value = true
            pushPromptError.value = ''
            try {
                await subscribeToPush()
                dismissPushPrompt()
                showToastMessage('اعلان‌های نامه‌ها با موفقیت روشن شد', 'success')
            } catch (error) {
                if (pushPermission.value === 'denied' || Notification.permission === 'denied') {
                    dismissPushPrompt()
                    showToastMessage('اجازه اعلان داده نشد. می‌توانید بعداً از تنظیمات مرورگر یا زنگوله آن را فعال کنید.', 'error')
                } else {
                    pushPromptError.value = error?.message || 'فعال‌سازی اعلان‌ها انجام نشد.'
                }
            } finally {
                pushPromptBusy.value = false
            }
        }
        
        const letter = reactive({
            date: '',
            number: '',
            reference: '',
            rowNumber: '',
            summary: '',
            description: '',
            type: 'عکس',
            image: null,
            imageName: '',
            activityId: null,
            documentId: null,
            actDoc1: null
        })

        const letters = ref([])

        // Add these with your other refs
        const isLoadingDocs = ref(false)
        const isLoadingActivities = ref(false)
        const isFirstLoad = ref(true)

        // Also add these for better UX
        const loadingMessage = ref('در حال بارگذاری نامه‌ها...')
        const loadingProgress = ref(0)

        // Reply state
        const replyToMessage = ref(null)
        const replyToMessageIndex = ref(null)
        const isReplying = ref(false)
        const isPrivateReplying = ref(false)
        const showPrivateRecipientModal = ref(false)
        const privateReplySourceMessage = ref(null)
        const privateReplySourceIndex = ref(null)
        const selectedPrivateRecipient = ref(null)
        const privateRecipientParticipantId = ref('')
        const privateRecipientSearchQuery = ref('')
        const privateRecipientSearchResults = ref([])
        const privateRecipientSearchTimer = ref(null)

        // ============ ROLE HELPERS ============
        const userRoles = computed(() => {
        // `getAvailableRoles` might be a getter/computed or a plain array.
        const raw = authStore.getAvailableRoles
        let arr = []
        if (Array.isArray(raw)) arr = raw
        else if (raw && Array.isArray(raw.value)) arr = raw.value
        else if (typeof raw === 'string') arr = [raw]

        // Normalize to lowercase strings
        return arr
            .map(r => (typeof r === 'string' ? r : r?.name || r?.role || ''))
            .filter(Boolean)
            .map(r => String(r).toLowerCase())
        })

        // Convert Persian/Arabic digits to English
        const toEnglishDigits = (str) => {
            if (!str && str !== 0) return ''
            const s = String(str)
            const persian = '۰۱۲۳۴۵۶۷۸۹'
            const arabic  = '٠١٢٣٤٥٦٧٨٩'
            return s
                .split('')
                .map(ch => {
                    const pi = persian.indexOf(ch)
                    if (pi !== -1) return String(pi)
                    const ai = arabic.indexOf(ch)
                    if (ai !== -1) return String(ai)
                    return ch
                })
                .join('')
        }

        // Strip non-digits and clamp to 10 chars, live as the user types
        const onNationalCodeInput = (event) => {
            const raw = event?.target?.value ?? registrationData.value.national_code ?? ''
            const digitsOnly = toEnglishDigits(raw).replace(/\D/g, '').slice(0, 10)
            registrationData.value.national_code = digitsOnly
            registrationErrors.value.national_code = ''
        }

        const hasRole = (role) => userRoles.value.includes(String(role).toLowerCase())

        const isAdmin    = computed(() => hasRole('admin'))
        const isEmployer = computed(() => hasRole('employer'))
        const isOffice   = computed(() => hasRole('office'))
        const isStore    = computed(() => hasRole('store'))
        const isCustomer = computed(() => hasRole('customer'))
        const isEmployee = computed(() => hasRole('employee'))

        // "Only customer" = no employer/admin/office/store — just a plain customer
        const isCustomerOnly = computed(() =>
        isCustomer.value && !isEmployer.value && !isAdmin.value  && !isEmployee.value
        )

        const isEmployeeOnly = computed(() =>
        isEmployee.value && !isEmployer.value && !isAdmin.value
        )

        // The raw groups (from the API) — unchanged
        const actDocsGroups = computed(() => {
        const items = Array.isArray(actDocItems.value) ? actDocItems.value : []
        const map = new Map()
        for (const item of items) {
            const key = item.Ac_Title || 'سایر'
            if (!map.has(key)) {
            map.set(key, { Ac_Title: key, Ac: item.Ac, items: [] })
            }
            map.get(key).items.push(item)
        }
        return Array.from(map.values())
        })

        // ============ ROLE-FILTERED GROUPS ============
        // Customer-only → only "نامه های وارده" (Ac === 16)
        // Employer / Office / Store / Admin → all
        const visibleActDocsGroupsFilter = computed(() => {
        const all = actDocsGroups.value

        if (isCustomerOnly.value) {
            // Only allow "نامه های وارده" (Ac 16)
            return all.filter(g => Number(g.Ac) === 16)
        }

        // if (isEmployeeOnly.value) {
        //     return all.filter(g => Number(g.Ac) === 17 || Number(g.Ac) === 18)
        // }

        return all
        })

        const visibleActDocsGroupsNewMsg = computed(() => {
        const all = actDocsGroups.value

        if (isCustomerOnly.value) {
            // Only allow "نامه های وارده" (Ac 16)
            return all.filter(g => Number(g.Ac) === 16)
        }

        if (isEmployeeOnly.value) {
            return all.filter(g => Number(g.Ac) === 17 || Number(g.Ac) === 18)
        }

        return all
        })

        // ============ LETTER TABS ============
        const activeLetterTab = ref('open')   // 'open' | 'closed' | 'all'

        const letterTabs = [
        { id: 'open',   label: 'نامه‌های جاری',       icon: 'fa-folder-open' },
        { id: 'closed', label: 'نامه‌های بایگانی',    icon: 'fa-archive' },
        { id: 'all',    label: 'همه نامه‌ها',         icon: 'fa-inbox' },
        ]

        const visibleLetterTabs = computed(() =>
            isCustomerOnly.value
                ? letterTabs.filter(tab => tab.id === 'open')
                : letterTabs
        )

        const isLetterClosed = (letter) => {
            if (!letter) return false
            // Accept 1, "1", true
            const v = letter.closeDoc ?? letter.CloseDoc ?? 0
            return v === 1 || v === '1' || v === true
        }

        const isLetterDone = (letter) => {
            const value = letter?.closeDoc ?? letter?.CloseDoc ?? 0
            return Number(value) === 2
        }

        const selectedLetter = computed(() => {
            if (selectedLetterIndex.value === null || !letters.value[selectedLetterIndex.value]) {
                return null
            }
            return letters.value[selectedLetterIndex.value]
        })

        const moveLetterToTop = (targetLetter, activityTime = new Date()) => {
            if (!targetLetter) return
            const targetId = targetLetter.IDDocItem
            const index = letters.value.findIndex(letter => letter.IDDocItem === targetId)
            if (index < 0) return
            const wasSelected = selectedLetter.value?.IDDocItem === targetId

            targetLetter.LastDate = activityTime instanceof Date
                ? activityTime.toISOString()
                : activityTime
            targetLetter.date = targetLetter.LastDate
            if (index > 0) {
                letters.value.splice(index, 1)
                letters.value.unshift(targetLetter)
            }
            if (wasSelected) selectedLetterIndex.value = 0
        }

        const letterParticipants = computed(() => {
            const currentUserId = authStore.user?.subCodeId
            return [...(selectedLetter.value?.participants || [])].sort((a, b) =>
                Number(String(b.SubCodeId) === String(currentUserId)) -
                Number(String(a.SubCodeId) === String(currentUserId))
            )
        })
        const selectableLetterParticipants = computed(() =>
            letterParticipants.value.filter(person =>
                String(person.SubCodeId) !== String(authStore.user?.subCodeId)
            )
        )
        const participantDisplayName = (person) => {
            const accountTitle = String(person?.Title || '').trim()
            const fullName = [person?.Name, person?.Family].filter(Boolean).join(' ').trim()
            return String(person?.SubCodeId) === String(authStore.user?.subCodeId)
                ? 'شما'
                : (accountTitle || fullName || 'کاربر')
        }
        const participantSummary = computed(() => {
            const names = letterParticipants.value.map(participantDisplayName)
            if (!names.length) return selectedLetter.value?.Receiver || 'گیرنده'
            if (names.length <= 2) return names.join('، ')
            return `${names.slice(0, 2).join('، ')} و ${names.length - 2} نفر دیگر`
        })
        const phoneNumbers = (person) =>
            [...new Set([person?.Tel1, person?.Tel2, person?.Tel3]
                .map(phone => String(phone || '').trim())
                .filter(Boolean))]

        const filteredLetters = computed(() => {
        let list = letters.value

        // 1. Tab filter
        const selectedTab = isCustomerOnly.value ? 'open' : activeLetterTab.value
        if (selectedTab === 'open') {
            list = list.filter(l => !isLetterClosed(l))
        } else if (activeLetterTab.value === 'closed') {
            list = list.filter(l => isLetterClosed(l))
        }

        // 3. Search query
        if (searchQuery.value) {
            const q = searchQuery.value.toLowerCase()
            list = list.filter(item =>
            item.customerName?.toLowerCase().includes(q) ||
            item.summary?.toLowerCase().includes(q) ||
            item.description?.toLowerCase().includes(q) ||
            item.Expl?.toLowerCase().includes(q) ||
            item.Sender?.toLowerCase().includes(q) ||
            item.Receiver?.toLowerCase().includes(q)
            )
        }

        return list
        })

        const getLetterTabCount = (tabId) => {
        const all = letters.value
        if (tabId === 'open')   return all.filter(l => !isLetterClosed(l)).length
        if (tabId === 'closed') return all.filter(l => isLetterClosed(l)).length
        return all.length
        }

        // Helper functions for file types
        const getFileTypeInfo = (mimeType, fileName) => {
            const ext = fileName ? fileName.split('.').pop().toLowerCase() : ''
            
            // Image files
            if (mimeType?.startsWith('image/') || ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'ico'].includes(ext)) {
                return { type: 'image', displayType: 'تصویر', icon: 'fa-image', persianType: 'عکس' }
            }
            // Audio files
            if (mimeType?.startsWith('audio/') || ['mp3', 'wav', 'ogg', 'm4a', 'aac', 'flac', 'webm', 'opus'].includes(ext)) {
                return { type: 'audio', displayType: 'صوت', icon: 'fa-music', persianType: 'صدا' }
            }
            // Video files
            if (mimeType?.startsWith('video/') || ['mp4', 'avi', 'mov', 'wmv', 'mkv', 'flv', 'webm', 'm4v', '3gp'].includes(ext)) {
                return { type: 'video', displayType: 'ویدئو', icon: 'fa-video', persianType: 'ویدئو' }
            }
            // PDF
            if (ext === 'pdf' || mimeType === 'application/pdf') {
                return { type: 'pdf', displayType: 'PDF', icon: 'fa-file-pdf', persianType: 'فایل' }
            }
            // Office documents
            if (['doc', 'docx'].includes(ext) || mimeType === 'application/msword' || mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
                return { type: 'document', displayType: 'Word', icon: 'fa-file-word', persianType: 'فایل' }
            }
            if (['xls', 'xlsx'].includes(ext) || mimeType === 'application/vnd.ms-excel' || mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                return { type: 'document', displayType: 'Excel', icon: 'fa-file-excel', persianType: 'فایل' }
            }
            if (['ppt', 'pptx'].includes(ext) || mimeType === 'application/vnd.ms-powerpoint' || mimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
                return { type: 'document', displayType: 'PowerPoint', icon: 'fa-file-powerpoint', persianType: 'فایل' }
            }
            // Archive files
            if (['zip', 'rar', '7z', 'tar', 'gz', 'bz2'].includes(ext)) {
                return { type: 'archive', displayType: 'بسته', icon: 'fa-file-archive', persianType: 'فایل' }
            }
            // Text files
            if (['txt', 'rtf'].includes(ext) || mimeType === 'text/plain') {
                return { type: 'document', displayType: 'متن', icon: 'fa-file-alt', persianType: 'فایل' }
            }
            // Default
            return { type: 'other', displayType: 'فایل', icon: 'fa-file', persianType: 'فایل' }
        }

        const showScrollBottomBtn = ref(false);
        const unreadScrollCount = ref(0);

        const handleChatScroll = () => {
        const el = messagesContainer.value;
        if (!el) return;
        
        // فاصله از پایین کانتینر
        const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
        
        // اگر کاربر بیشتر از ۱۵۰ پیکسل به بالا اسکرول کرد، دکمه را نشان بده
        showScrollBottomBtn.value = distanceFromBottom > 150;
        };

        const scrollToBottomSmooth = () => {
        if (messagesContainer.value) {
            messagesContainer.value.scrollTo({
            top: messagesContainer.value.scrollHeight,
            behavior: 'smooth'
            });
            unreadScrollCount.value = 0;
        }
        };

        const goBack = async () => {
        // ۱. اگر در حالت نامه‌های من (GetPersonDocuments) هستیم
        if (isPersonView.value) {
            isPersonView.value = false;
            
            // اگر لیست قبلی در کش موجود بود، فورا جایگزین کن
            if (cachedNormalLetters.value && cachedNormalLetters.value.length > 0) {
            letters.value = [...cachedNormalLetters.value];
            selectedLetterIndex.value = null;
            showChat.value = false;
            } else {
            // در غیر این صورت لیست عادی را دوباره از سرور بگیر تا صفحه خالی نماند
            selectedLetterIndex.value = null;
            showChat.value = false;
            await fetchDocuments();
            }
            return;
        }

        // ۲. اگر نامه‌ای انتخاب شده بود، نامه را ببند
        if (selectedLetterIndex.value !== null) {
            selectedLetterIndex.value = null;
            showChat.value = false;
            return;
        }

        // ۳. در غیر این صورت خروج و بازگشت به داشبورد
        router.push('/office/dashboard');
        };

        const toggleSidebar = () => {
            if (isMobile.value) {
                showChat.value = !showChat.value
            }
        }

        // ============ FETCH DOCUMENTS USING ListDoc2 ============
        const fetchDocuments = async () => {
            try {
                isLoadingDocs.value = true
                isLoading.value = true
                loadingMessage.value = 'در حال بارگذاری نامه‌ها...'
                loadingProgress.value = 30
                
                const userId = authStore.user?.subCodeId
                
                if (!userId) {
                    openRegistrationModal()
                    showToastMessage('شناسه کاربر یافت نشد', 'error')
                    isLoadingDocs.value = false
                    isLoading.value = false
                    return
                }

                loadingProgress.value = 60
                const response = await officeService.listDoc2(
                    userId,
                    filterAc.value ?? 0,
                    filterAct.value ?? 0,
                )
                loadingProgress.value = 80
                
                if (response.data.success && response.data.documents) {
                    const transformedLetters = response.data.documents.map((doc, index) => {
                        return {
                            id: doc.Doc_Auto || doc.IDDocItem || Date.now() + index,
                            customerId: doc.SenderId || doc.ReceiverId || 'unknown',
                            customerName: doc.Sender || doc.Receiver || 'مشتری',
                            summary: doc.Expl?.substring(0, 50) || 'نامه',
                            description: doc.Expl || '',
                            date: parseDocumentDate(doc.Dates, doc.Tim),
                            status: 'sent',
                            unread: 0,
                            messages: [],
                            activityId: doc.IDDocItem || null,
                            documentId: doc.Doc_Auto || doc.IDDocAct || null,
                            IDDocItem: doc.IDDocItem,
                            IDDocAct: doc.Doc_Auto || doc.IDDocAct,
                            Doc_Auto: doc.Doc_Auto,
                            docData: doc,
                            Sender: doc.Sender,
                            Receiver: doc.Receiver,
                            SenderId: doc.SenderId,
                            ReceiverId: doc.ReceiverId,
                            typ: doc.typ,
                            Tim: doc.Tim,
                            Expl: doc.Expl,
                            Dates: doc.Dates,
                            LastTake: doc.LastTake,
                            LastTakeId: doc.LastTakeId,
                            LastActDate: doc.LastActDate || doc.Dates,
                            LastActTime: doc.LastActTime || doc.Tim,
                            LastDate: parseDocumentDate(
                                doc.LastActDate || doc.Dates,
                                doc.LastActTime || doc.Tim
                            ),
                            docItemData: null,
                            type: null,
                            marbot: null,
                            comment: null,
                            atf: null,
                            bed: null,
                            bes: null,
                            picName: null,
                            activities: [],
                            participants: null,
                            activityLoaded: false,
                            closeDoc: doc.closeDoc ?? doc.CloseDoc ?? 0,
                            Seen: doc.Seen ?? '',
                            SeenA: doc.SeenA ?? '',
                            MohalKar: doc.MohalKar ?? '',
                            RateDoc: doc.RateDoc ?? 0
                        }
                    })
                    
                    transformedLetters.sort((a, b) => {
                        const dateA = parseDocumentDate(a.LastActDate, a.LastActTime)
                        const dateB = parseDocumentDate(b.LastActDate, b.LastActTime)
                        if (dateA && dateB) {
                            return new Date(dateB).getTime() - new Date(dateA).getTime()
                        }
                        return 0
                    })
                    
                    letters.value = transformedLetters
                    loadingProgress.value = 100
                    
                    if (transformedLetters.length > 0) {
                        showToastMessage(`${transformedLetters.length} نامه یافت شد`, 'success')
                    } else {
                        showToastMessage('هیچ نامه‌ای یافت نشد', 'info')
                    }
                } else {
                    loadingProgress.value = 100
                    if (response.data.message && 
                        (response.data.message.includes('not registered') || 
                        response.data.message.includes('Please register first'))) {
                        openRegistrationModal()
                        showToastMessage('لطفاً ابتدا ثبت نام کنید', 'warning', '⚠️')
                    } else {
                        showToastMessage(response.data.message || 'خطا در دریافت نامه‌ها', 'error')
                    }
                }
            } catch (error) {
                console.error('Error fetching documents:', error)
                loadingProgress.value = 100
                let errorMessage = 'خطا در ارتباط با سرور'
                
                if (error.response?.data?.detail) {
                    errorMessage = error.response.data.detail
                    if (errorMessage.includes('not registered') || errorMessage.includes('User not registered')) {
                        openRegistrationModal()
                        showToastMessage('لطفاً ابتدا ثبت نام کنید', 'warning', '⚠️')
                        isLoadingDocs.value = false
                        isLoading.value = false
                        return
                    }
                }
                
                showToastMessage(errorMessage, 'error', '❌')
            } finally {
                isLoadingDocs.value = false
                isLoading.value = false
                isFirstLoad.value = false
            }
        }

        // ============ SELECT LETTER AND FETCH ACTIVITIES ============
        const selectLetter = async (index) => {
            try {
                twoPersonViewLetterId.value = null
                twoPersonMessages.value = []
                isLoading.value = true
                isLoadingActivities.value = true
                loadingMessage.value = 'در حال بارگذاری پیام‌ها...'
                loadingProgress.value = 30
                
                const filtered = filteredLetters.value
                const letter = filtered[index]
                
                if (!letter) return

                // Find its real index in the master array
                const realIndex = letters.value.findIndex(l => l.IDDocItem === letter.IDDocItem)
                if (realIndex === -1) return

                selectedLetterIndex.value = realIndex
                showChat.value = true

                // Use `letter` (the object), not `letters.value[index]`
                if (letter.unread) letter.unread = 0
                
                // Load both activities and participant contacts if either is missing.
                if (letter && (!letter.activityLoaded || !Array.isArray(letter.participants)) && letter.Doc_Auto) {
                    const docCode = letter.Doc_Auto
                    console.log(`Fetching activities for DocCode: ${docCode}`)
                    loadingProgress.value = 50
                    
                    const response = await officeService.listDocAct(docCode)
                    loadingProgress.value = 80
                    
                    if (response.data.success && response.data.activities) {
                        const userId = authStore.user?.subCodeId
                        const activities = response.data.activities
                        letter.activities = activities
                        letter.participants = response.data.participants || []
                        letter.activityLoaded = true
                        
                        // Build messages from activities
                        const messages = []
                        let firstMessage = null
                        const restMessages = []
                        
                        // Create a map for quick lookup of activities by DocActAuto
                        const activityMap = {}
                        activities.forEach(act => {
                            activityMap[act.DocActAuto] = act
                        })
                        
                        // Process first activity separately as the "first message"
                        if (activities.length > 0) {
                            const firstAct = activities[0]
                            
                            const firstText = firstAct.Comment || firstAct.Marbot || firstAct.Paraf || ''
                            const firstFileUrl = firstAct.PicDocItem || null
                            const firstFileName = firstFileUrl ? firstFileUrl.split('/').pop() : ''
                            const isFirstMessageUser = String(letter.SenderId) === String(userId)
                            
                            let firstFileType = 'other'
                            if (firstFileUrl) {
                                const urlLower = firstFileUrl.toLowerCase()
                                if (urlLower.match(/\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i)) {
                                    firstFileType = 'image'
                                } else if (urlLower.match(/\.(mp3|wav|ogg|m4a|aac|flac|webm)$/i)) {
                                    firstFileType = 'audio'
                                } else if (urlLower.match(/\.(mp4|avi|mov|wmv|mkv|flv)$/i)) {
                                    firstFileType = 'video'
                                } else if (urlLower.match(/\.pdf$/i)) {
                                    firstFileType = 'pdf'
                                } else if (urlLower.match(/\.(doc|docx|xls|xlsx|ppt|pptx|txt|rtf)$/i)) {
                                    firstFileType = 'document'
                                } else if (urlLower.match(/\.(zip|rar|7z|tar|gz)$/i)) {
                                    firstFileType = 'archive'
                                }
                            }
                            
                            firstMessage = {
                                giveId: letter.SenderId,
                                takeId: letter.ReceiverId,
                                firstId: letter.SenderId,
                                giveName: letter.Sender || 'کاربر',
                                takeName: letter.Receiver || 'کاربر',
                                sender: isFirstMessageUser ? 'user' : 'other',
                                senderName: isFirstMessageUser ? 'شما' : (letter.Sender || 'کاربر'),
                                text: firstText,
                                image: firstFileUrl,
                                file_url: firstFileUrl,
                                timestamp: parseDocumentDate(firstAct.FDates, firstAct.FTimes),
                                status: 'sent',
                                file_type: firstFileType,
                                file_name: firstFileName || 'فایل',
                                icon: getFileTypeInfo('', firstFileName).icon,
                                displayType: getFileTypeInfo('', firstFileName).displayType,
                                mime_type: '',
                                isFirstMessage: true,
                                activityData: firstAct,
                                privateAct: 0,
                                __order: 0,
                                isForwarded: false,
                                typAct: firstAct.TypAct || 1,
                                forwardFrom: null,
                                forwardTo: null,
                                originalDocActAuto: null,
                                SeenA: firstAct.SeenA ?? '',
                            }
                            console.log('first msg ' + firstMessage.giveId)
                        }
                        
                        // Process remaining activities
                        for (let i = 0; i < activities.length; i++) {
                            const act = activities[i]
                            const isUser = String(act.GiveId) === String(userId)
                            const text = act.Paraf || ''
                            let fileUrl = act.PicDocAct || null
                            let fileName = fileUrl ? fileUrl.split('/').pop() : ''
                            
                            let fileType = 'other'
                            if (fileUrl) {
                                const urlLower = fileUrl.toLowerCase()
                                if (urlLower.match(/\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i)) {
                                    fileType = 'image'
                                } else if (urlLower.match(/\.(mp3|wav|ogg|m4a|aac|flac|webm)$/i)) {
                                    fileType = 'audio'
                                } else if (urlLower.match(/\.(mp4|avi|mov|wmv|mkv|flv)$/i)) {
                                    fileType = 'video'
                                } else if (urlLower.match(/\.pdf$/i)) {
                                    fileType = 'pdf'
                                } else if (urlLower.match(/\.(doc|docx|xls|xlsx|ppt|pptx|txt|rtf)$/i)) {
                                    fileType = 'document'
                                } else if (urlLower.match(/\.(zip|rar|7z|tar|gz)$/i)) {
                                    fileType = 'archive'
                                }
                            }
                            
                            let senderName = act.Give || 'کاربر'
                            if (isUser) {
                                senderName = 'شما'
                            }
                            
                            const isReference = act.ATF && act.ATF > 0
                            const isForwarded = act.TypAct === 2
                            
                            let forwardFrom = null
                            let forwardTo = null
                            let originalDocActAuto = null
                            let originalMessagePreview = null
                            
                            if (isForwarded && act.AtfAct !== undefined && act.AtfAct !== null) {
                                // Two cases mean "the target is the first message":
                                //   1. The SP returned AtfAct === 0 (older server versions)
                                //   2. The SP returned AtfAct === IDDocItem (current behavior)
                                const isRootReference =
                                    Number(act.AtfAct) === 0 ||
                                    doesActReferenceFirstMessage(act)

                                originalDocActAuto = isRootReference ? 0 : act.AtfAct

                                const originalAct = isRootReference
                                    ? activities[0]
                                    : activityMap[act.AtfAct]

                                if (originalAct) {
                                    forwardFrom = act.Give || 'کاربر'
                                    forwardTo = act.Take || 'کاربر'
                                    originalMessagePreview = {
                                        text: isRootReference ? originalAct.Comment : originalAct.Paraf,
                                        sender: originalAct.Give || 'کاربر',
                                        hasFile: !!(originalAct.PicDocAct || originalAct.PicDocItem),
                                        fileUrl: originalAct.PicDocAct || originalAct.PicDocItem || null,
                                        docActAuto: isRootReference ? 0 : originalAct.DocActAuto,
                                        timestamp: parseDocumentDate(
                                            originalAct.Dates || originalAct.FDates,
                                            originalAct.Times || originalAct.FTimes
                                        )
                                    }
                                }
                            }
                            
                            const message = {
                                sender: isUser ? 'user' : 'other',
                                senderName: senderName,
                                text: text,
                                image: fileUrl,
                                file_url: fileUrl,
                                timestamp: parseDocumentDate(act.Dates, act.Times),
                                status: 'sent',
                                file_type: fileType,
                                file_name: fileName || 'فایل',
                                icon: getFileTypeInfo('', fileName).icon,
                                displayType: getFileTypeInfo('', fileName).displayType,
                                mime_type: '',
                                isFirstMessage: false,
                                activityData: act,
                                giveId: act.GiveId,
                                takeId: act.TakeId,
                                firstId: act.FirstId,
                                docActAuto: act.DocActAuto,
                                bed: act.Bed,
                                bes: act.Bes,
                                atf: act.ATF,
                                isReference: isReference,
                                __order: i,
                                isForwarded: isForwarded,
                                typAct: act.TypAct || 1,
                                forwardFrom: forwardFrom,
                                forwardTo: forwardTo,
                                originalDocActAuto: originalDocActAuto,
                                originalMessagePreview: originalMessagePreview,
                                giveName: act.Give || 'کاربر',
                                takeName: act.Take || 'کاربر',
                                privateAct: Number(act.PrivateAct) === 1 ? 1 : 0,
                                scrollTarget: isForwarded ? originalDocActAuto : null,
                                SeenA: act.SeenA ?? '',
                            }
                            
                            restMessages.push(message)
                        }
                        
                        restMessages.sort((a, b) => {
                            const dateA = new Date(a.timestamp)
                            const dateB = new Date(b.timestamp)
                            return dateA - dateB
                        })
                        
                        if (firstMessage) {
                            messages.push(firstMessage)
                        }
                        messages.push(...restMessages)
                        if (firstMessage) {
                            firstMessage.__order = 0
                        }
                        
                        letter.messages = messages

                        markSeenForLetter(letter)
                        loadingProgress.value = 100
                        console.log(`Loaded ${messages.length} messages for document ${docCode}`)
                    } else {
                        letter.messages = []
                        letter.activityLoaded = true
                    }
                }
                
                nextTick(() => {
                    scrollToBottom()
                })
            } catch (error) {
                console.error('Error fetching document details:', error)
                showToastMessage('خطا در دریافت جزئیات نامه', 'error')
            } finally {
                isLoading.value = false
                isLoadingActivities.value = false
                lastFetchedLetterId.value = letter.IDDocItem
            }
        }

        // Scroll to original message when clicking on forwarded preview
        const scrollToOriginalForwardedMessage = (originalDocActAuto) => {
            if (!selectedLetter.value || !selectedLetter.value.messages) {
                showToastMessage('پیام اصلی پیدا نشد', 'info')
                return
            }

            // 0 or null → the first message
            if (
                originalDocActAuto === 0 ||
                originalDocActAuto === '0' ||
                originalDocActAuto === null ||
                originalDocActAuto === undefined
            ) {
                // The first message is the first item in the message list
                scrollToMessage(0)
                showToastMessage('پیام اصلی', 'info')
                return
            }

            // Otherwise look up by docActAuto
            const index = selectedLetter.value.messages.findIndex(
                msg => msg.docActAuto === originalDocActAuto
            )

            if (index !== -1) {
                scrollToMessage(index)
                showToastMessage('پیام اصلی', 'info')
            } else {
                showToastMessage('پیام اصلی پیدا نشد', 'info')
            }
        }

        // Scroll to a specific message by index with highlight
        const scrollToMessage = (index) => {
            if (!messagesContainer.value) return
            
            const messageElements = messagesContainer.value.querySelectorAll('.message-wrapper')
            if (messageElements[index]) {
                const element = messageElements[index]
                element.scrollIntoView({ 
                    behavior: 'smooth', 
                    block: 'center' 
                })
                
                // Highlight the message
                element.style.transition = 'background 0.5s ease, box-shadow 0.5s ease'
                element.style.background = 'rgba(108, 92, 231, 0.15)'
                element.style.boxShadow = '0 0 20px rgba(108, 92, 231, 0.2)'
                element.style.borderRadius = '8px'
                element.style.padding = '4px 8px'
                
                setTimeout(() => {
                    element.style.background = ''
                    element.style.boxShadow = ''
                    element.style.padding = ''
                }, 2000)
            }
        }

        // Registration Modal Functions
        const openRegistrationModal = () => {
            registrationErrors.value = { name: '', national_code: '', address: '', postal_code: '', mohal_kar: '' }
            showRegistrationModal.value = true
            const user = JSON.parse(localStorage.getItem('user') || '{}')
            registrationData.value.phone = user.phone || ''
            registrationData.value.name = user.name || ''
        }

        const closeRegistrationModal = () => {
            showRegistrationModal.value = false
            registrationData.value = {
                name: '',
                phone: '',
                national_code: '',
                address: '',
                postal_code: '',
                mohal_kar: '',
            }
            registrationErrors.value = { name: '', national_code: '', address: '', postal_code: '', mohal_kar: '' }
        }

    const submitRegistration = async () => {
        // Reset errors
        registrationErrors.value = { name: '', national_code: '', address: '', postal_code: '', mohal_kar: '' }

        let hasError = false

        // ---------- Name ----------
        const nameClean = (registrationData.value.name || '').trim()
        if (!nameClean) {
            registrationErrors.value.name = 'لطفاً نام و نام خانوادگی را وارد کنید'
            hasError = true
        } else if (nameClean.length < 2) {
            registrationErrors.value.name = 'نام باید حداقل ۲ کاراکتر باشد'
            hasError = true
        }

        // ---------- Phone (sanity check; it's readonly anyway) ----------
        const phoneClean = (registrationData.value.phone || '').trim()
        if (!phoneClean) {
            showToastMessage('شماره تلفن یافت نشد. لطفاً دوباره وارد شوید', 'error', '❌')
            return
        }

        // ---------- National code ----------
        const nationalClean = toEnglishDigits(registrationData.value.national_code || '').trim()
        // Persist the normalized version so the user sees what we validated
        registrationData.value.national_code = nationalClean

        if (!nationalClean) {
            registrationErrors.value.national_code = 'کد ملی الزامی است'
            hasError = true
        } else if (!/^\d{10}$/.test(nationalClean)) {
            registrationErrors.value.national_code = 'کد ملی باید دقیقاً ۱۰ رقم باشد'
            hasError = true
        }

        const postalClean = toEnglishDigits(registrationData.value.postal_code || '').replace(/\D/g, '')
        registrationData.value.postal_code = postalClean
        if (!/^\d{10}$/.test(postalClean)) {
            registrationErrors.value.postal_code = 'کد پستی باید دقیقاً ۱۰ رقم باشد'
            hasError = true
        }

        if (!(registrationData.value.mohal_kar || '').trim()) {
            registrationErrors.value.mohal_kar = 'لطفاً محل کار را وارد کنید'
            hasError = true
        }

        // ---------- Address ----------
        const addressClean = (registrationData.value.address || '').trim()
        if (!addressClean) {
            registrationErrors.value.address = 'لطفاً آدرس را وارد کنید'
            hasError = true
        } else if (addressClean.length < 5) {
            registrationErrors.value.address = 'آدرس بسیار کوتاه است'
            hasError = true
        }

        if (hasError) {
            showToastMessage('لطفاً خطاهای فرم را برطرف کنید', 'error', '❌')
            return
        }

        // ---------- Submit ----------
        registrationLoading.value = true

        try {
            const payload = {
                name: nameClean,
                phone: phoneClean,
                national_code: nationalClean,
                address: addressClean,
                postal_code: postalClean,
                mohal_kar: (registrationData.value.mohal_kar || '').trim(),
            }

            const response = await authService.registerCustomer(payload)

            if (response.data.success) {
                showToastMessage('ثبت نام با موفقیت انجام شد!', 'success', '✅')
                closeRegistrationModal()
                stopPolling()
                authStore.logout()
                location.reload()
            } else {
                showToastMessage(response.data.message || 'خطا در ثبت نام', 'error', '❌')
            }
        } catch (error) {
            console.error('Registration error:', error)
            let errorMessage = 'خطا در ثبت نام. لطفاً دوباره تلاش کنید.'

            if (error.response?.data?.detail) {
                errorMessage = error.response.data.detail
            } else if (error.message) {
                errorMessage = error.message
            }

            showToastMessage(errorMessage, 'error', '❌')
        } finally {
            registrationLoading.value = false
        }
    }

        // Reference Modal Functions
        const toRecipientChoice = (person) => ({
            id: person.SubCodeId ?? person.id_subcode ?? person.id,
            id_subcode: person.SubCodeId ?? person.id_subcode ?? person.id,
            full_name: person.Title || person.full_name || person.title ||
                [person.Name, person.Family].filter(Boolean).join(' ').trim() || 'کاربر',
            title: person.Title || person.title || '',
            phone_number: person.Tel2 || person.tel2 || person.phone_number || '',
            tel2: person.Tel2 || person.tel2 || person.phone_number || '',
        })

        const defaultRecipientForMessage = (message) => {
            const currentUserId = authStore.user?.subCodeId
            let targetId = message?.giveId ?? message?.activityData?.GiveId ?? message?.senderId ?? message?.firstId
            let rootField = 'Sender'

            if (targetId != null && String(targetId) === String(currentUserId)) {
                const senderId = selectedLetter.value?.SenderId
                const receiverId = selectedLetter.value?.ReceiverId
                if (senderId != null && String(senderId) !== String(currentUserId)) {
                    targetId = senderId
                    rootField = 'Sender'
                } else if (receiverId != null && String(receiverId) !== String(currentUserId)) {
                    targetId = receiverId
                    rootField = 'Receiver'
                }
            }

            const participant = letterParticipants.value.find(person =>
                String(person.SubCodeId) === String(targetId)
            )
            if (participant) return toRecipientChoice(participant)

            const rootName = selectedLetter.value?.[rootField]
            return {
                id: targetId,
                id_subcode: targetId,
                full_name: rootName || message?.giveName || message?.senderName || 'کاربر',
                title: rootName || '',
            }
        }

        const openReferenceModal = () => {
            if (!selectedLetter.value) {
                showToastMessage('لطفاً ابتدا یک نامه را انتخاب کنید', 'error')
                return
            }
            showReferenceModal.value = true
            referenceSearchQuery.value = ''
            referenceSearchResults.value = []
            selectedReferenceCustomer.value = null
            referenceParticipantId.value = ''
            referenceIsPrivate.value = false
            referenceText.value = ''
            pendingReferenceFile.value = null
            referencingMessage.value = null
        }

        const openReferenceModalForMessage = (msg) => {
            if (!selectedLetter.value) {
                showToastMessage('لطفاً ابتدا یک نامه را انتخاب کنید', 'error')
                return
            }
            showReferenceModal.value = true
            referenceSearchQuery.value = ''
            referenceSearchResults.value = []
            selectedReferenceCustomer.value = null
            referenceParticipantId.value = ''
            referenceIsPrivate.value = false
            referenceText.value = ''
            pendingReferenceFile.value = null
            referencingMessage.value = msg
        }

        const closeReferenceModal = () => {
            showReferenceModal.value = false
            referenceSearchQuery.value = ''
            referenceSearchResults.value = []
            selectedReferenceCustomer.value = null
            referenceParticipantId.value = ''
            referenceIsPrivate.value = false
            referenceText.value = ''
            pendingReferenceFile.value = null
            referencingMessage.value = null
        }

        const onReferenceSearchInput = () => {
            clearTimeout(referenceSearchTimeout.value)
            const delay = window.innerWidth < 768 ? 50 : 300
            
            referenceSearchTimeout.value = setTimeout(() => {
                const query = referenceSearchQuery.value.trim()
                if (query) {
                    searchReferenceCustomers()
                } else {
                    referenceSearchResults.value = []
                }
            }, delay)
        }

        const searchReferenceCustomers = async () => {
            const query = referenceSearchQuery.value.trim()

            try {
                isLoading.value = true
                const response = await officeService.searchParents(query)
                
                if (response.data.success) {
                    const parents = (response.data.parents || []).filter(parent =>
                        !referenceIsPrivate.value ||
                        String(parent.id_subcode) !== String(authStore.user?.subCodeId)
                    )
                    
                    referenceSearchResults.value = parents.map(parent => ({
                        id: parent.id_subcode || 0,
                        phone_number: parent.tel2 || '',
                        first_name: parent.title || '',
                        last_name: '',
                        full_name: parent.title || 'کاربر بدون نام',
                        sub_code_id: parent.id_subcode,
                        id_subcode: parent.id_subcode,
                        title: parent.title,
                        tel2: parent.tel2
                    }))
                    
                    if (referenceSearchResults.value.length === 0) {
                        showToastMessage('مشتریی یافت نشد', 'info')
                    }
                } else {
                    showToastMessage('خطا در جستجوی مشتریان', 'error')
                }
            } catch (error) {
                console.error('Error searching reference customers:', error)
                showToastMessage('خطا در ارتباط با سرور', 'error')
            } finally {
                isLoading.value = false
            }
        }

        const selectReferenceCustomer = (customer) => {
            if (referenceIsPrivate.value && String(customer.id_subcode ?? customer.id) === String(authStore.user?.subCodeId)) {
                showToastMessage('نمی‌توانید خودتان را به‌عنوان گیرنده ارجاع خصوصی انتخاب کنید', 'warning')
                return
            }
            selectedReferenceCustomer.value = customer
            const matchingParticipant = letterParticipants.value.find(person =>
                String(person.SubCodeId) === String(customer.id_subcode ?? customer.id)
            )
            referenceParticipantId.value = matchingParticipant ? String(matchingParticipant.SubCodeId) : ''
            referenceSearchQuery.value = customer.full_name || customer.title || customer.phone_number || ''
            referenceSearchResults.value = []
        }

        const selectReferenceParticipant = () => {
            if (!referenceParticipantId.value) return
            const person = letterParticipants.value.find(item =>
                String(item.SubCodeId) === String(referenceParticipantId.value)
            )
            if (person) {
                selectedReferenceCustomer.value = toRecipientChoice(person)
                referenceSearchQuery.value = selectedReferenceCustomer.value.full_name
                referenceSearchResults.value = []
            }
        }

        // Handle file upload for reference
        const handleReferenceFileUpload = (event) => {
            const file = event.target.files[0]
            if (file) {
                const maxSize = file.type.startsWith('image/') ? 5 * 1024 * 1024 : 20 * 1024 * 1024
                if (file.size > maxSize) {
                    showToastMessage(`حجم فایل نباید بیشتر از ${maxSize / 1024 / 1024} مگابایت باشد`, 'error')
                    return
                }

                const reader = new FileReader()
                reader.onload = (e) => {
                    const fileInfo = getFileTypeInfo(file.type, file.name)
                    pendingReferenceFile.value = {
                        data: e.target.result,
                        file: file,
                        name: file.name,
                        type: file.type,
                        file_type: fileInfo.type,
                        displayType: fileInfo.displayType,
                        icon: fileInfo.icon,
                        persianType: fileInfo.persianType,
                        mime_type: file.type
                    }
                    showToastMessage(`فایل ${fileInfo.displayType} برای ارجاع آماده شد`, 'success')
                }
                reader.readAsDataURL(file)
            }
            event.target.value = ''
        }

        const onSearchInput = () => {
            clearTimeout(searchTimeout.value)
            const delay = window.innerWidth < 768 ? 50 : 300
            
            searchTimeout.value = setTimeout(() => {
                const query = customerSearchQuery.value.trim()
                if (query) {
                    searchCustomers()
                } else {
                    customerSearchResults.value = []
                }
            }, delay)
        }

        const onClearCustomerSearch = () => {
            customerSearchResults.value = []
        }

        const parseDocumentDate = (persianDate, time) => {
            if (!persianDate) {
                return new Date().toISOString()
            }
            
            try {
                const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']
                const arabicNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩']
                
                const convertToEnglish = (str) => {
                    let result = str
                    persianNumbers.forEach((p, i) => {
                        result = result.replace(new RegExp(p, 'g'), String(i))
                    })
                    arabicNumbers.forEach((a, i) => {
                        result = result.replace(new RegExp(a, 'g'), String(i))
                    })
                    return result
                }
                
                const englishDate = convertToEnglish(persianDate)
                const dateParts = englishDate.split('/')
                
                if (dateParts.length === 3) {
                    const jy = parseInt(dateParts[0])
                    const jm = parseInt(dateParts[1])
                    const jd = parseInt(dateParts[2])
                    
                    const gregorian = moment(`${jy}/${jm}/${jd}`, 'jYYYY/jMM/jDD').toDate()
                    
                    if (time) {
                        const timeParts = time.split(':')
                        if (timeParts.length >= 2) {
                            gregorian.setHours(parseInt(timeParts[0]) || 0)
                            gregorian.setMinutes(parseInt(timeParts[1]) || 0)
                            if (timeParts.length >= 3) {
                                gregorian.setSeconds(parseInt(timeParts[2]) || 0)
                            }
                        }
                    }
                    
                    if (!isNaN(gregorian.getTime())) {
                        return gregorian.toISOString()
                    }
                }
                
                return new Date().toISOString()
                
            } catch (error) {
                console.warn('Error parsing date:', persianDate, error)
                return new Date().toISOString()
            }
        }

        const openNewChatModal = (initialMessage = '', initialPicDocAct = '', initialFile = null) => {
            pendingNewChatPrefill.value = initialMessage
            pendingNewChatPicDocAct.value = initialPicDocAct || ''
            pendingNewChatFile.value = initialFile || null
            
            const unclosedCount = letters.value.filter(letter => !isLetterClosed(letter)).length
            if (unclosedCount > 0) {
                unclosedLettersCount.value = unclosedCount
                showUnclosedLettersWarning.value = true
                return
            }

            prepareNewChatModal(initialMessage, initialPicDocAct, initialFile)
        }

        const prepareNewChatModal = (initialMessage = '', initialPicDocAct = '', initialFile = null) => {
            showNewChatModal.value = true
            customerSearchQuery.value = ''
            customerSearchResults.value = []
            selectedCustomer.value = null
            newLetterMessage.value = initialMessage
            newChatFile.value = initialFile || null  // <-- Set the file
            pendingNewChatPicDocAct.value = initialPicDocAct || ''

            // Role-based defaults
            if (isCustomerOnly.value) {
                const incoming = visibleActDocsGroupsFilter.value.find(g => Number(g.Ac) === 16)
                newLetterAc.value = incoming ? incoming.Ac : null
                newLetterAct.value = null
            } else {
                newLetterAc.value = null
                newLetterAct.value = null
            }

            nextTick(() => {
                const input = isCustomerOnly.value
                    ? document.getElementById('new-letter-act-select')
                    : document.getElementById('new-letter-ac-select')
                if (input) input.focus()
            })
        }

        const closeNewChatModal = () => {
            showNewChatModal.value = false
            pendingNewChatPrefill.value = ''
            pendingNewChatPicDocAct.value = ''
            pendingNewChatFile.value = null
        }

        const cancelUnclosedLettersWarning = () => {
            showUnclosedLettersWarning.value = false
            pendingNewChatPrefill.value = ''
            pendingNewChatPicDocAct.value = ''
            pendingNewChatFile.value = null
        }

        const continueCreateNewChat = () => {
            showUnclosedLettersWarning.value = false
            const initialMessage = pendingNewChatPrefill.value
            const initialPicDocAct = pendingNewChatPicDocAct.value
            const initialFile = pendingNewChatFile.value
            pendingNewChatPrefill.value = ''
            pendingNewChatPicDocAct.value = ''
            pendingNewChatFile.value = null
            prepareNewChatModal(initialMessage, initialPicDocAct, initialFile)
        }

        const applyRoleFilterDefaults = () => {
        if (isCustomerOnly.value) {
            filterAc.value = 16
            filterAct.value = null
        }
        }

        const searchCustomers = async () => {
            const query = customerSearchQuery.value.trim()

            try {
                isLoading.value = true
                const selectedLetterType = visibleActDocsGroupsNewMsg.value.find(
                    group => Number(group.Ac) === Number(newLetterAc.value)
                )?.Ac_Title || ''
                const isOutgoingLetter = /صادره|صادر/.test(selectedLetterType)
                const response = isOutgoingLetter
                    ? await officeService.searchParentsAll(query)
                    : await officeService.searchParents(query)
                
                if (response.data.success) {
                    const parents = response.data.parents || []
                    
                    customerSearchResults.value = parents.map(parent => ({
                        id: parent.id_subcode || 0,
                        phone_number: parent.tel2 || '',
                        first_name: parent.title || '',
                        last_name: '',
                        full_name: parent.title || 'کاربر بدون نام',
                        sub_code_id: parent.id_subcode,
                        id_subcode: parent.id_subcode,
                        title: parent.title,
                        tel2: parent.tel2
                    }))
                    
                    customers.value = customerSearchResults.value
                    
                    if (customerSearchResults.value.length === 0) {
                        showToastMessage('مشتریی یافت نشد', 'info')
                    }
                } else {
                    showToastMessage('خطا در جستجوی مشتریان', 'error')
                }
            } catch (error) {
                console.error('Error searching customers:', error)
                showToastMessage('خطا در ارتباط با سرور', 'error')
            } finally {
                isLoading.value = false
            }
        }

        watch(customerSearchQuery, (newQuery) => {
            clearTimeout(searchTimeout.value)
            searchTimeout.value = setTimeout(() => {
                if (newQuery.trim()) {
                    searchCustomers()
                } else {
                    customerSearchResults.value = []
                }
            }, 300)
        })

        const selectCustomer = (customer) => {
            selectedCustomer.value = customer
            customerSearchQuery.value = customer.full_name || customer.title || customer.phone_number || ''
            customerSearchResults.value = []
        }

        const attachImage = () => {
            fileInput.value.click()
        }

        const previewImage = (imageUrl) => {
            previewImageUrl.value = imageUrl
        }

        const showLegacyLetterDetails = () => {
            if (selectedLetter.value) {
                const doc = selectedLetter.value.docData
                
                let details = `📋 جزئیات نامه\n`
                details += `─────────────────\n`
                details += `شماره: ${doc?.Doc_Auto || selectedLetter.value.IDDocAct || 'نامشخص'}\n`
                details += `فرستنده: ${doc?.Sender || selectedLetter.value.Sender || 'نامشخص'}\n`
                details += `گیرنده: ${doc?.Receiver || selectedLetter.value.Receiver || 'نامشخص'}\n`
                details += `تاریخ: ${doc?.Dates || selectedLetter.value.Dates || 'نامشخص'}\n`
                details += `زمان: ${doc?.Tim || selectedLetter.value.Tim || 'نامشخص'}\n`
                details += `نوع: ${doc?.typ || selectedLetter.value.typ || 'نامشخص'}\n`
                details += `─────────────────\n`
                details += `خلاصه: ${selectedLetter.value.summary || 'بدون خلاصه'}\n`
                details += `توضیحات: ${selectedLetter.value.description || 'بدون توضیحات'}\n`
                
                if (doc?.LastTake) {
                    details += `─────────────────\n`
                    details += `آخرین گیرنده: ${doc.LastTake}\n`
                    details += `تاریخ آخرین اقدام: ${doc.LastActDate || 'نامشخص'}\n`
                    details += `زمان آخرین اقدام: ${doc.LastActTime || 'نامشخص'}\n`
                }
                
                showToastMessage(details, 'info')
            }
        }

        void showLegacyLetterDetails

        const viewLetterDetails = async () => {
            const letter = selectedLetter.value
            if (!letter) return

            const ownId = authStore.user?.subCodeId || authStore.user?.id
            const linkedIds = [letter.customerId, letter.SenderId, letter.ReceiverId]
                .filter(id => id !== null && id !== undefined && String(id).trim() !== '')
            const otherId = linkedIds.find(id => String(id) !== String(ownId))
            if (!ownId || !otherId) {
                showToastMessage('کد طرفین نامه برای دریافت جزئیات پیدا نشد', 'warning')
                return
            }

            const letterId = letter.IDDocItem ?? letter.Doc_Auto ?? letter.id
            isLoadingActivities.value = true
            loadingMessage.value = 'در حال دریافت سوابق نامه...'
            try {
                const response = await officeService.getTwoPersonDocuments(otherId, ownId)
                if (!response?.data?.success) {
                    showToastMessage(response?.data?.message || 'دریافت سوابق نامه ناموفق بود', 'error')
                    return
                }

                const rows = response.data.documents || []
                twoPersonMessages.value = rows.map((row, index) => {
                    const hasAct = row.act_id !== null && row.act_id !== undefined
                    const senderId = hasAct ? (row.act_sender_id ?? row.sender_id) : row.sender_id
                    const messageDate = hasAct && row.act_date ? row.act_date : (row.dates || '')
                    const messageTime = hasAct && row.act_time ? row.act_time : (row.times || '')
                    const fileUrl = row.file_url || row.pic_doc_act || null
                    return {
                        id: row.act_id ?? row.doc_auto ?? index,
                        docActAuto: row.act_id ?? row.doc_auto ?? index,
                        sender: String(senderId) === String(ownId) ? 'user' : 'other',
                        senderName: row.act_sender_name || row.sender_name || row.sender || 'نامشخص',
                        text: row.act_text || row.expl || '',
                        timestamp: parseDocumentDate(messageDate, messageTime),
                        rawDate: messageDate,
                        rawTime: messageTime,
                        status: 'sent',
                        image: fileUrl,
                        file_url: fileUrl,
                        receiverName: (hasAct ? row.act_receiver_name : null) || row.receiver_name || row.receiver || '',
                        isTwoPersonHistory: true,
                        activityData: row,
                    }
                }).sort((a, b) => {
                    const timeDifference = new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
                    if (Number.isFinite(timeDifference) && timeDifference !== 0) return timeDifference
                    return (Number(a.id) || 0) - (Number(b.id) || 0)
                })
                twoPersonViewLetterId.value = letterId
                showChat.value = true
                if (!rows.length) showToastMessage('بین این دو نفر سابقه‌ای پیدا نشد', 'info')
                await nextTick()
                scrollToBottomSmooth()
            } catch (error) {
                console.error('Failed to fetch two-person letter history:', error)
                showToastMessage(error.response?.data?.detail || 'خطا در دریافت سوابق نامه', 'error')
            } finally {
                isLoadingActivities.value = false
            }
        }

        const deleteLetter = () => {
            if (selectedLetterIndex.value !== null && confirm('آیا از حذف این نامه اطمینان دارید؟')) {
                letters.value.splice(selectedLetterIndex.value, 1)
                selectedLetterIndex.value = null
                showChat.value = false
                showToastMessage('نامه حذف شد', 'success')
            }
        }

        const scrollToBottom = () => {
            if (messagesContainer.value) {
                messagesContainer.value.scrollTop = messagesContainer.value.scrollHeight
            }
        }

        const rtf = new Intl.RelativeTimeFormat('fa-IR', { numeric: 'auto' })

        const formatTime = (timestamp) => {
            if (!timestamp) return ''
            const date = new Date(timestamp)
            const now = new Date()
            const diffMs = now - date

            const diffMinutes = Math.floor(diffMs / (1000 * 60))
            const diffHours = Math.floor(diffMs / (1000 * 60 * 60))

            if (diffMinutes < 1) return 'چند لحظه پیش'
            if (diffMinutes < 60) return rtf.format(-diffMinutes, 'minute') // مثلا: «۱۰ دقیقه پیش»

            const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            const startOfYesterday = new Date(startOfToday)
            startOfYesterday.setDate(startOfYesterday.getDate() - 1)

            if (date >= startOfToday) {
                return rtf.format(-diffHours, 'hour') // مثلا: «۳ ساعت پیش»
            }

            if (date >= startOfYesterday) {
                return rtf.format(-1, 'day') // خروجی خودکار: «دیروز»
            }

            return date.toLocaleDateString('fa-IR', {
                month: 'short',
                day: 'numeric'
            })
        }


        const showToastMessage = (message, type = 'success') => {
            toastMessage.value = message
            toastType.value = type
            
            switch(type) {
                case 'success': toastIconClass.value = 'fas fa-check-circle'; break
                case 'error': toastIconClass.value = 'fas fa-exclamation-circle'; break
                case 'info': toastIconClass.value = 'fas fa-info-circle'; break
                default: toastIconClass.value = 'fas fa-check-circle'
            }
            
            showToast.value = true
            setTimeout(() => {
                showToast.value = false
            }, 4000)
        }

        const handleResize = () => {
            isMobile.value = window.innerWidth < 768
        }

        watch(selectedLetter, () => {
            nextTick(() => {
                scrollToBottom()
            })
        })

        const getCustomerInitial = (customer) => {
            if (!customer) return '?'
            if (customer.full_name) return customer.full_name.charAt(0)
            if (customer.title) return customer.title.charAt(0)
            if (customer.first_name) return customer.first_name.charAt(0)
            if (customer.last_name) return customer.last_name.charAt(0)
            if (customer.phone_number) return customer.phone_number.charAt(0)
            return '?'
        }

        const getCustomerDisplayName = (customer) => {
            if (!customer) return 'مشتری'
            if (customer.full_name) return customer.full_name
            if (customer.title) return customer.title
            const firstName = customer.first_name || ''
            const lastName = customer.last_name || ''
            const combined = `${firstName} ${lastName}`.trim()
            if (combined) return combined
            if (customer.phone_number) return customer.phone_number
            return 'مشتری'
        }

        const removeSelectedCustomer = () => {
            selectedCustomer.value = null
            customerSearchQuery.value = ''
        }

        // Voice Recording Functions
        const toggleRecording = async () => {
            if (isRecording.value) {
                stopRecording()
            } else {
                await startRecording()
            }
        }

        const startRecording = async () => {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
                mediaRecorder.value = new MediaRecorder(stream)
                audioChunks.value = []
                
                mediaRecorder.value.ondataavailable = (event) => {
                    if (event.data.size > 0) {
                        audioChunks.value.push(event.data)
                    }
                }
                
                mediaRecorder.value.onstop = () => {
                    const audioBlob = new Blob(audioChunks.value, { type: 'audio/webm' })
                    const file = new File([audioBlob], `voice_${Date.now()}.webm`, { type: 'audio/webm' })
                    
                    const fileInfo = getFileTypeInfo('audio/webm', file.name)
                    pendingFile.value = {
                        data: URL.createObjectURL(audioBlob),
                        file: file,
                        name: file.name,
                        type: file.type,
                        file_type: fileInfo.type,
                        displayType: fileInfo.displayType,
                        icon: fileInfo.icon,
                        persianType: fileInfo.persianType
                    }
                    showToastMessage('صدای شما ضبط شد', 'success')
                    
                    audioChunks.value = []
                    recordingTime.value = '00:00'
                    stream.getTracks().forEach(track => track.stop())
                }
                
                mediaRecorder.value.start()
                isRecording.value = true
                
                let seconds = 0
                recordingTimer.value = setInterval(() => {
                    seconds++
                    const mins = String(Math.floor(seconds / 60)).padStart(2, '0')
                    const secs = String(seconds % 60).padStart(2, '0')
                    recordingTime.value = `${mins}:${secs}`
                }, 1000)
                
            } catch (error) {
                console.error('Error accessing microphone:', error)
                showToastMessage('دسترسی به میکروفون امکان‌پذیر نیست', 'error')
            }
        }

        const stopRecording = () => {
            if (mediaRecorder.value && isRecording.value) {
                mediaRecorder.value.stop()
                isRecording.value = false
                if (recordingTimer.value) {
                    clearInterval(recordingTimer.value)
                    recordingTimer.value = null
                }
            }
        }

        // Voice Recording for New Chat Modal
        const startVoiceRecording = async () => {
            if (isRecordingVoice.value) {
                if (mediaRecorder.value) {
                    mediaRecorder.value.stop()
                    isRecordingVoice.value = false
                    if (recordingTimer.value) {
                        clearInterval(recordingTimer.value)
                        recordingTimer.value = null
                    }
                    voiceRecordingTime.value = ''
                }
                return
            }
            
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
                mediaRecorder.value = new MediaRecorder(stream)
                audioChunks.value = []
                
                mediaRecorder.value.ondataavailable = (event) => {
                    if (event.data.size > 0) {
                        audioChunks.value.push(event.data)
                    }
                }
                
                mediaRecorder.value.onstop = () => {
                    const audioBlob = new Blob(audioChunks.value, { type: 'audio/webm' })
                    const reader = new FileReader()
                    reader.onload = (e) => {
                        const file = new File([audioBlob], `voice_${Date.now()}.webm`, { type: 'audio/webm' })
                        const fileInfo = getFileTypeInfo('audio/webm', file.name)
                        newChatFile.value = {
                            data: e.target.result,
                            file: file,
                            name: file.name,
                            type: file.type,
                            file_type: fileInfo.type,
                            displayType: fileInfo.displayType,
                            icon: fileInfo.icon,
                            persianType: fileInfo.persianType
                        }
                        showToastMessage('صدای شما ضبط شد', 'success')
                    }
                    reader.readAsDataURL(audioBlob)
                    
                    audioChunks.value = []
                    voiceRecordingTime.value = ''
                    stream.getTracks().forEach(track => track.stop())
                }
                
                mediaRecorder.value.start()
                isRecordingVoice.value = true
                
                let seconds = 0
                recordingTimer.value = setInterval(() => {
                    seconds++
                    const mins = String(Math.floor(seconds / 60)).padStart(2, '0')
                    const secs = String(seconds % 60).padStart(2, '0')
                    voiceRecordingTime.value = `${mins}:${secs}`
                }, 1000)
                
            } catch (error) {
                console.error('Error accessing microphone:', error)
                showToastMessage('دسترسی به میکروفون امکان‌پذیر نیست', 'error')
            }
        }

        // Handle file upload for chat
        const handleFileUpload = (event) => {
            const file = event.target.files[0]
            if (file) {
                const maxSize = file.type.startsWith('image/') ? 5 * 1024 * 1024 : 20 * 1024 * 1024
                if (file.size > maxSize) {
                    showToastMessage(`حجم فایل نباید بیشتر از ${maxSize / 1024 / 1024} مگابایت باشد`, 'error')
                    return
                }

                const reader = new FileReader()
                reader.onload = (e) => {
                    const fileInfo = getFileTypeInfo(file.type, file.name)
                    pendingFile.value = {
                        data: e.target.result,
                        file: file,
                        name: file.name,
                        type: file.type,
                        file_type: fileInfo.type,
                        displayType: fileInfo.displayType,
                        icon: fileInfo.icon,
                        persianType: fileInfo.persianType,
                        mime_type: file.type
                    }
                    showToastMessage(`فایل ${fileInfo.displayType} برای ارسال آماده شد`, 'success')
                }
                reader.readAsDataURL(file)
            }
            event.target.value = ''
        }

        // Handle file upload for new chat modal
        const handleNewChatFile = (event) => {
            const file = event.target.files[0]
            if (file) {
                const maxSize = file.type.startsWith('image/') ? 5 * 1024 * 1024 : 20 * 1024 * 1024
                if (file.size > maxSize) {
                    showToastMessage(`حجم فایل نباید بیشتر از ${maxSize / 1024 / 1024} مگابایت باشد`, 'error')
                    return
                }

                const reader = new FileReader()
                reader.onload = (e) => {
                    const fileInfo = getFileTypeInfo(file.type, file.name)
                    newChatFile.value = {
                        data: e.target.result,
                        file: file,
                        name: file.name,
                        type: file.type,
                        file_type: fileInfo.type,
                        displayType: fileInfo.displayType,
                        icon: fileInfo.icon,
                        persianType: fileInfo.persianType,
                        mime_type: file.type
                    }
                }
                reader.readAsDataURL(file)
            }
            event.target.value = ''
        }

        // Helper functions to detect file types from URLs
        const isImageUrl = (url) => {
            if (!url) return false
            const ext = url.split('.').pop().toLowerCase()
            return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'ico'].includes(ext) ||
                url.includes('image') ||
                url.match(/\.(jpg|jpeg|png|gif|webp|bmp|svg|ico)$/i) !== null
        }

        const isAudioUrl = (url) => {
            if (!url) return false
            const ext = url.split('.').pop().toLowerCase()
            return ['mp3', 'wav', 'ogg', 'm4a', 'aac', 'flac', 'webm', 'opus'].includes(ext) ||
                url.includes('audio') ||
                url.match(/\.(mp3|wav|ogg|m4a|aac|flac|webm|opus)$/i) !== null
        }

        const isVideoUrl = (url) => {
            if (!url) return false
            const ext = url.split('.').pop().toLowerCase()
            return ['mp4', 'avi', 'mov', 'wmv', 'mkv', 'flv', 'webm', 'm4v', '3gp'].includes(ext) ||
                url.includes('video') ||
                url.match(/\.(mp4|avi|mov|wmv|mkv|flv|webm|m4v|3gp)$/i) !== null
        }

        const isPdfUrl = (url) => {
            if (!url) return false
            return url.toLowerCase().endsWith('.pdf') || 
                url.includes('.pdf') ||
                url.includes('pdf') && !url.includes('image')
        }

        const getAudioMimeType = (url) => {
            if (!url) return 'audio/webm'
            const ext = url.split('.').pop().toLowerCase()
            const mimeTypes = {
                'mp3': 'audio/mpeg',
                'wav': 'audio/wav',
                'ogg': 'audio/ogg',
                'm4a': 'audio/mp4',
                'aac': 'audio/aac',
                'flac': 'audio/flac',
                'webm': 'audio/webm'
            }
            return mimeTypes[ext] || 'audio/webm'
        }

        const handleImageError = (event) => {
            console.warn('Image failed to load:', event.target.src)
            event.target.style.display = 'none'
            const parent = event.target.parentElement
            if (parent) {
                const fallback = document.createElement('div')
                fallback.className = 'image-fallback'
                fallback.innerHTML = '<i class="fas fa-image"></i><span>در حال آپلود فایل ...</span>'
                parent.appendChild(fallback)
            }
        }

        const sendMessage = async () => {
            const text = newMessage.value.trim()
            const file = pendingFile.value

            if (!text && !file) return
            if (isRecording.value) {
                showToastMessage('لطفاً ابتدا ضبط صدا را متوقف کنید', 'info')
                return
            }
            if (!selectedLetter.value) {
                showToastMessage('لطفاً یک نامه را انتخاب کنید', 'error')
                return
            }

            let fileObj = null
            let picName = ''
            let actualFileType = 'image'
            let fileData = null
            
            if (file) {
                fileObj = file.file || null
                picName = file.name || 'file.bin'
                actualFileType = file.file_type || 'other'
                fileData = file.data || null
            }

            // Determine if this is a reply and get the target ID
            let targetId = null
            let replyText = text
            let isReply = false
            const privateReply = isPrivateReplying.value
            let originalDocActAuto = null
            let originalMessageData = null
            let forwardFromName = null
            let forwardToName = null
            
            if (isReplying.value && replyToMessage.value) {
                // For replies, the target is the original message's sender (GiveId)
                let senderId = replyToMessage.value.giveId ||
                                replyToMessage.value.activityData?.GiveId ||
                                replyToMessage.value.senderId ||
                                replyToMessage.value.firstId

                // If the selected message was sent by the current user, do not
                // reply to ourselves. Resolve the other participant from the
                // first/original message in the letter.
                const currentUserId = authStore.user?.subCodeId
                const sameAsCurrentUser = senderId && currentUserId &&
                    String(senderId) === String(currentUserId)
                console.log('currentUserId ' + currentUserId)
                console.log('senderId ' + senderId)
                console.log('sameAsCurrentUser ' + sameAsCurrentUser)
                console.log('selectedLetter.value.SenderId ' + selectedLetter.value.SenderId)
                console.log('selectedLetter.value.ReceiverId ' + selectedLetter.value.ReceiverId)
                
                
                if (sameAsCurrentUser) {
                    //const firstMessage = (selectedLetter.value.messages || [])[0]
                    const firstSenderId = selectedLetter.value.SenderId 
                    const firstReceiverId = selectedLetter.value.ReceiverId

                    if (firstSenderId && String(firstSenderId) !== String(currentUserId)) {
                        senderId = firstSenderId
                    } else if (firstReceiverId && String(firstReceiverId) !== String(currentUserId)) {
                        senderId = firstReceiverId
                    }
                }
                
                // The originalDocActAuto should be the DocActAuto of the message we're replying to
                originalDocActAuto = getReferenceIdForMessage(replyToMessage.value)
                
                // The new act is sent by the current user to targetId. Keep the
                // optimistic forward labels consistent with Give/Take from the API.
                const participantMessages = selectedLetter.value.messages || []
                const currentUserMessage = participantMessages.find(msg => {
                    const giveId = msg.giveId ?? msg.activityData?.GiveId
                    return giveId != null && String(giveId) === String(currentUserId)
                })
                forwardFromName = currentUserMessage?.giveName ||
                    currentUserMessage?.activityData?.Give || 'شما'
                const targetMessage = participantMessages.find(msg => {
                    const giveId = msg.giveId ?? msg.activityData?.GiveId
                    const takeId = msg.takeId ?? msg.activityData?.TakeId
                    return (giveId != null && String(giveId) === String(senderId)) ||
                        (takeId != null && String(takeId) === String(senderId))
                })
                const targetGiveId = targetMessage?.giveId ?? targetMessage?.activityData?.GiveId
                const targetName = targetGiveId != null && String(targetGiveId) === String(senderId)
                    ? (targetMessage?.giveName || targetMessage?.activityData?.Give)
                    : (targetMessage?.takeName || targetMessage?.activityData?.Take)
                forwardToName = targetName ||
                    (String(replyToMessage.value.giveId ?? replyToMessage.value.activityData?.GiveId ?? '') === String(senderId)
                        ? (replyToMessage.value.giveName || replyToMessage.value.activityData?.Give)
                        : (replyToMessage.value.takeName || replyToMessage.value.activityData?.Take)) ||
                    'گیرنده'
                
                // Store original message data for the forwarded context
                originalMessageData = {
                    text: replyToMessage.value.text || 
                        replyToMessage.value.Paraf || 
                        replyToMessage.value.activityData?.Paraf || 
                        '',
                    sender: replyToMessage.value.giveName ||
                        replyToMessage.value.activityData?.Give ||
                        replyToMessage.value.senderName || 'کاربر',
                    hasFile: !!(replyToMessage.value.file_url || 
                            replyToMessage.value.PicDocAct || 
                            replyToMessage.value.activityData?.PicDocAct || 
                            replyToMessage.value.PicDocItem || 
                            replyToMessage.value.activityData?.PicDocItem),
                    fileUrl: replyToMessage.value.file_url || 
                            replyToMessage.value.PicDocAct || 
                            replyToMessage.value.activityData?.PicDocAct || 
                            replyToMessage.value.PicDocItem || 
                            replyToMessage.value.activityData?.PicDocItem || 
                            null,
                    docActAuto: originalDocActAuto,
                    timestamp: replyToMessage.value.timestamp
                }
                
                if (senderId) {
                    // Replies always go to the original message sender.
                    targetId = senderId
                    isReply = true
                    replyText = text
                } else {
                    showToastMessage('شناسه فرستنده برای پاسخ یافت نشد', 'error')
                    return
                }
            }

            // Create message with unique ID
            const messageId = Date.now()
            const message = {
                id: messageId,
                sender: 'user',
                text: replyText,
                image: fileData,
                file_url: fileData,
                timestamp: new Date().toISOString(),
                status: 'pending',
                file_type: actualFileType,
                file_name: picName,
                mime_type: file?.type || null,
                displayType: file?.displayType || 'فایل',
                isPending: true,
                // Reply context for UI display
                isReply: isReply,
                replyTo: isReply ? replyToMessage.value.id : null,
                replyToSender: isReply ? (replyToMessage.value.senderName || 'کاربر') : null,
                replyToText: isReply ? (replyToMessage.value.text || '') : null,
                replyToHasFile: isReply ? !!(replyToMessage.value.file_url) : false,
                // Store for forward/reply chain
                typAct: isReply ? 2 : 1,
                privateAct: privateReply ? 1 : 0,
                originalDocActAuto: isReply ? originalDocActAuto : null,
                
                // FORWARDED CONTEXT FIELDS - This is what shows the "بازارسال شده" section
                isForwarded: isReply ? true : false,
                forwardFrom: isReply ? forwardFromName : null,
                forwardTo: isReply ? forwardToName : null,
                originalMessagePreview: isReply ? originalMessageData : null,
                giveName: 'شما',
                takeName: isReply ? (forwardToName || 'گیرنده') : 'گیرنده',
                giveId: authStore.user?.subCodeId,
                takeId: targetId,
                // Store the original message's sender name for display
                forwardedFromName: isReply ? forwardFromName : null,
                forwardedToName: isReply ? forwardToName : null,
            }

            // Add message to chat
            if (!selectedLetter.value.messages) {
                selectedLetter.value.messages = []
            }
            selectedLetter.value.messages.push(message)

            // Update UI
            if (text) {
                selectedLetter.value.summary = text.substring(0, 50)
            }
            selectedLetter.value.date = new Date().toISOString()
            selectedLetter.value.status = 'pending'

            // Clear input and reply state
            newMessage.value = ''
            pendingFile.value = null
            if (isReplying.value) {
                cancelReply()
            }

            await nextTick()
            scrollToBottom()

            try {
                const userId = authStore.user?.subCodeId
                
                // For replies, the receiver is the sender of the original message
                // For non-replies, find the last message where the user was the receiver
                let receiver_tmp = null
                
                // Loop through messages from last to first (reverse order)
                const messages = selectedLetter.value.messages || []
                for (let i = messages.length - 1; i >= 0; i--) {
                    const msg = messages[i]
                    // Check if the current user is the receiver of this message
                    const isUserReceiver = msg.takeId === userId || 
                                        msg.activityData?.TakeId === userId ||
                                        (msg.sender === 'other' && msg.takeId === userId)
                    
                    if (isUserReceiver) {
                        // Get the sender of this message (who the user should reply to)
                        receiver_tmp = msg.giveId || 
                                    msg.activityData?.GiveId || 
                                    msg.senderId ||
                                    msg.firstId
                        
                        // Also store the sender name for potential use
                        if (receiver_tmp) {
                            // Found the last message where user was receiver
                            console.log('Found last received message from:', msg.giveName || msg.senderName)
                            break
                        }
                    }
                }
                
                // If no message found where user was receiver, use the customerId from the letter
                if (receiver_tmp == null) {
                    receiver_tmp = selectedLetter.value.customerId || 
                                selectedLetter.value.ReceiverId || 
                                0
                }
                console.log('targetId ' + targetId)
                console.log('receiver_tmp ' + receiver_tmp)
                
                // Determine the receiver ID
                const receiverId = isReply ? targetId : receiver_tmp
                
                // Determine the IDDocAct
                const docActId = isReply ? originalDocActAuto : (selectedLetter.value.IDDocItem || 0)
                
                const payload = {
                    IDDocItem: selectedLetter.value.IDDocItem || 0,
                    IDDocAct: docActId,
                    Paraf: replyText || '',
                    PicAdres: picName || '',
                    takeId: receiverId || 0,
                    Sender: userId || 0,
                    typAct: isReply ? 2 : 1,
                    privateAct: privateReply ? 1 : 0
                }

                console.log('Sending message payload:', payload)
                console.log('isReply:', isReply)
                console.log('receiverId:', receiverId)

                const response = await officeService.referenceDocument(payload, fileObj)
                
                if (response.data.success) {
                    const index = selectedLetter.value.messages.findIndex(m => m.id === messageId)

                    if (index !== -1) {
                        const original = selectedLetter.value.messages[index]

                        // Server's activity (if any) — but we prefer our local intent for
                        // the "reference to first message" case so the UI stays consistent.
                        const serverActivity = response.data.activity || {}
                        const serverAtfAct = serverActivity.AtfAct

                        // Was this reply/forward aimed at the first message?
                        const wasFirstMessageRef =
                            isReply && (
                                originalDocActAuto === 0 ||
                                String(serverAtfAct) === String(selectedLetter.value.IDDocItem)
                            )

                        const updatedMessage = {
                            ...original,
                            status: 'sent',
                            isPending: false,

                            file_url: response.data.file_url || original.file_url,
                            image: response.data.file_url || original.image,

                            // Reply context
                            isReply: isReply,
                            replyTo: isReply ? replyToMessage.value?.id : null,
                            replyToSender: isReply ? replyToMessage.value?.senderName : null,
                            replyToText: isReply ? replyToMessage.value?.text : null,
                            replyToHasFile: isReply ? !!(replyToMessage.value?.file_url) : false,

                            // Reference chain
                            typAct: isReply ? 2 : 1,
                            // 🔒 Preserve local intent — 0 for first-message references
                            originalDocActAuto: isReply
                                ? (wasFirstMessageRef ? 0 : originalDocActAuto)
                                : null,

                            docActAuto: serverActivity.DocActAuto || original.docActAuto,
                            activityData: serverActivity || original.activityData,
                            giveId: serverActivity.GiveId || userId,
                            takeId: serverActivity.TakeId || receiverId,
                            firstId: serverActivity.FirstId || userId,

                            // Forwarded context — keep exactly as the local send built it
                            isForwarded: isReply ? true : false,
                            forwardFrom: isReply ? forwardFromName : null,
                            forwardTo: isReply ? forwardToName : null,
                            originalMessagePreview: isReply ? originalMessageData : null,

                            giveName: serverActivity.Give || 'شما',
                            takeName: serverActivity.Take || 'گیرنده',
                            forwardedFromName: isReply ? forwardFromName : null,
                            forwardedToName: isReply ? forwardToName : null,
                        }

                        selectedLetter.value.messages.splice(index, 1, updatedMessage)
                    }
                    
                    selectedLetter.value.status = 'sent'
                    
                    // Store the current selected letter ID before updating
                    const currentSelectedId = selectedLetter.value?.IDDocItem
                    
                    // Update document in the list with new activity info
                    if (currentSelectedId && response.data.activity) {
                        const activity = response.data.activity
                        const docIndex = letters.value.findIndex(l => l.IDDocItem === currentSelectedId)
                        if (docIndex !== -1) {
                            const doc = letters.value[docIndex]
                            if (activity.Dates) doc.Dates = activity.Dates
                            if (activity.Times) doc.Tim = activity.Times
                            if (activity.Take) doc.LastTake = activity.Take
                            if (activity.TakeId) doc.LastTakeId = activity.TakeId
                            if (activity.Dates) doc.LastActDate = activity.Dates
                            if (activity.Times) doc.LastActTime = activity.Times
                            
                            // Re-sort the documents list
                            letters.value.sort((a, b) => {
                                const dateA = parseDocumentDate(a.LastActDate, a.LastActTime)
                                const dateB = parseDocumentDate(b.LastActDate, b.LastActTime)
                                if (dateA && dateB) {
                                    return new Date(dateB).getTime() - new Date(dateA).getTime()
                                }
                                return 0
                            })
                            
                            // Update the selected index to point to the same document
                            const newIndex = letters.value.findIndex(l => l.IDDocItem === currentSelectedId)
                            if (newIndex !== -1) {
                                selectedLetterIndex.value = newIndex
                            }
                        }
                    }

                    const sentActivity = response.data.activity
                    const sentAt = sentActivity?.Dates
                        ? parseDocumentDate(sentActivity.Dates, sentActivity.Times)
                        : new Date()
                    moveLetterToTop(selectedLetter.value, sentAt)
                    
                    showToastMessage(isReply ? 'پاسخ با موفقیت ارسال شد' : 'پیام با موفقیت ارسال شد', 'success')
                } else {
                    // Handle error
                    const index = selectedLetter.value.messages.findIndex(m => m.id === messageId)
                    if (index !== -1) {
                        const updatedMessage = {
                            ...selectedLetter.value.messages[index],
                            status: 'error',
                            isPending: false
                        }
                        selectedLetter.value.messages.splice(index, 1, updatedMessage)
                    }
                    
                    if (response.data.return_code === 403 || 
                        response.data.error_details === 'USER_NOT_REGISTERED' ||
                        (response.data.message && response.data.message.includes('not registered'))) {
                        openRegistrationModal()
                        showToastMessage('لطفاً ابتدا ثبت نام کنید', 'warning', '⚠️')
                        // Remove the failed message
                        const failIndex = selectedLetter.value.messages.findIndex(m => m.id === messageId)
                        if (failIndex !== -1) {
                            selectedLetter.value.messages.splice(failIndex, 1)
                        }
                        return
                    } else {
                        showToastMessage(response.data.error_details || response.data.message || 'خطا در ارسال پیام', 'error')
                    }
                }
            } catch (error) {
                console.error('Error sending message:', error)
                
                // Update message to error state
                const index = selectedLetter.value.messages.findIndex(m => m.id === messageId)
                if (index !== -1) {
                    const updatedMessage = {
                        ...selectedLetter.value.messages[index],
                        status: 'error',
                        isPending: false
                    }
                    selectedLetter.value.messages.splice(index, 1, updatedMessage)
                }
                
                let errorMessage = 'خطا در ارتباط با سرور'
                
                if (error.response?.data?.detail) {
                    errorMessage = error.response.data.detail
                    if (errorMessage.includes('not registered') || errorMessage.includes('User not registered')) {
                        openRegistrationModal()
                        showToastMessage('لطفاً ابتدا ثبت نام کنید', 'warning', '⚠️')
                        // Remove the failed message
                        const failIndex = selectedLetter.value.messages.findIndex(m => m.id === messageId)
                        if (failIndex !== -1) {
                            selectedLetter.value.messages.splice(failIndex, 1)
                        }
                        return
                    }
                }
                
                selectedLetter.value.status = 'error'
                showToastMessage(errorMessage, 'error', '❌')
            }
        }

        const cancelReply = () => {
            isReplying.value = false
            isPrivateReplying.value = false
            replyToMessage.value = null
            replyToMessageIndex.value = null
            // Remove any reply prefix from the message input
            newMessage.value = newMessage.value.replace(/^@[^\s]+\s/, '')
        }

        const createNewChat = async () => {
            if (!selectedCustomer.value) {
                showToastMessage('لطفاً گیرنده را انتخاب کنید', 'error')
                return
            }
            if (!newLetterAc.value || !newLetterAct.value) {
                showToastMessage('لطفاً نوع و موضوع نامه را انتخاب کنید', 'error')
                return
            }
            if (!newLetterMessage.value.trim() && !newChatFile.value) {
                showToastMessage('لطفاً متن نامه یا فایل ضمیمه را وارد کنید', 'error')
                return
            }

            let fileType = 'عکس'
            let fileObj = null
            let picName = ''
            let actualFileType = 'image'
            
            if (newChatFile.value) {
                fileType = newChatFile.value.persianType || 'فایل'
                fileObj = newChatFile.value.file || null
                picName = newChatFile.value.name || 'file.bin'
                actualFileType = newChatFile.value.file_type || 'other'
            }

            const newChat = {
                id: Date.now(),
                customerId: selectedCustomer.value.id,
                customerName: getCustomerDisplayName(selectedCustomer.value),
                summary:
                    newLetterMessage.value.trim().substring(0, 50) ||
                    (newChatFile.value?.name ? truncateText(newChatFile.value.name, 50) : '') ||
                    'نامه',
                description: newLetterMessage.value.trim() || (newChatFile.value?.name || ''),
                date: new Date().toISOString(),
                status: 'pending',
                unread: 0,
                messages: [{
                    sender: 'user',
                    text: newLetterMessage.value.trim(),
                    image: newChatFile.value?.data || null,
                    timestamp: new Date().toISOString(),
                    status: 'pending',
                    file_type: actualFileType,
                    file_name: picName,
                    mime_type: newChatFile.value?.type || null,
                    displayType: newChatFile.value?.displayType || 'فایل'
                }],
                activityId: 1,
                documentId: Date.now() % 1000,
                Sender: authStore.user?.name || 'من',
                Receiver: getCustomerDisplayName(selectedCustomer.value),
                IDDocItem: Date.now(),
                ReceiverId: selectedCustomer.value.sub_code_id
            }

            letters.value.unshift(newChat)
            selectedLetterIndex.value = 0
            showChat.value = true

            closeNewChatModal()

            await nextTick()
            scrollToBottom()

            try {
                const userId = authStore.user?.subCodeId
                const receiver = selectedCustomer.value.sub_code_id
                const payload = {
                    Header: {
                        Ac: newLetterAc.value,         
                        Act: newLetterAct.value,        
                        Dates: new Date().toLocaleDateString('fa-IR'),
                        Sender: userId,
                        Receiver: receiver,
                        Operator: 0,
                        EnterNum: newChat.documentId
                    },
                    Body: [{
                        Type: fileType,
                        Marbot: newLetterMessage.value.trim(),
                        Comment: newLetterMessage.value.trim(),
                        Atf: 0,
                        Bed: 1,
                        Bes: newChat.documentId,
                        picName: picName
                    }]
                }

                const response = await officeService.saveDocument(payload, fileObj)
                
                if (response.data.success) {
                    newChat.status = 'sent'
                    newChat.messages[0].status = 'sent'
                    newLetterAc.value = null
                    newLetterAct.value = null
                    if (response.data.file_metadata) {
                        newChat.messages[0].image = response.data.file_metadata.url
                        newChat.messages[0].file_url = response.data.file_metadata.url
                    }
                    showToastMessage('نامه با موفقیت ارسال شد', 'success')
                } else {
                    if (response.data.return_code === 403 || 
                        response.data.error_details === 'USER_NOT_REGISTERED' ||
                        (response.data.message && response.data.message.includes('not registered'))) {
                        openRegistrationModal()
                        showToastMessage('لطفاً ابتدا ثبت نام کنید', 'warning', '⚠️')
                        if (letters.value && letters.value.length > 0) {
                            const lastIndex = letters.value.length - 1
                            if (letters.value[lastIndex] === newChat) {
                                letters.value.pop()
                            }
                        }
                        selectedLetterIndex.value = null
                        showChat.value = false
                        return
                    } else {
                        newChat.status = 'error'
                        newChat.messages[0].status = 'error'
                        showToastMessage(response.data.error_details || response.data.message || 'خطا در ارسال نامه', 'error')
                    }
                }
            } catch (error) {
                console.error('Error creating chat:', error)
                let errorMessage = 'خطا در ارتباط با سرور'
                
                if (error.response?.data?.detail) {
                    errorMessage = error.response.data.detail
                    if (errorMessage.includes('not registered') || errorMessage.includes('User not registered')) {
                        openRegistrationModal()
                        showToastMessage('لطفاً ابتدا ثبت نام کنید', 'warning', '⚠️')
                        if (letters.value && letters.value.length > 0) {
                            const lastIndex = letters.value.length - 1
                            if (letters.value[lastIndex] === newChat) {
                                letters.value.pop()
                            }
                        }
                        selectedLetterIndex.value = null
                        showChat.value = false
                        return
                    }
                }
                
                newChat.status = 'error'
                newChat.messages[0].status = 'error'
                showToastMessage(errorMessage, 'error', '❌')
            }
        }

        const submitReference = async () => {
            loadingSubmitReference.value = true;

            if (!selectedLetter.value) {
                showToastMessage('نامه انتخاب نشده است', 'error')
                loadingSubmitReference.value = false;
                return
            }
            
            if (!selectedReferenceCustomer.value) {
                showToastMessage('لطفاً گیرنده را انتخاب کنید', 'error')
                loadingSubmitReference.value = false;
                return
            }
            
            if (!referenceText.value.trim()) {
                showToastMessage('لطفاً متن ارجاع را وارد کنید', 'error')
                loadingSubmitReference.value = false;
                return
            }

            const sourceMessage = referencingMessage.value
            const sourceReferenceAct = referenceAct.value
            const referencePrivateForSend = referenceIsPrivate.value

            try {
                isLoading.value = true
                const userId = authStore.user?.subCodeId
                
                const payload = {
                    IDDocItem: selectedLetter.value.IDDocItem || 0,
                    IDDocAct: referenceAct.value || 0,
                    Paraf: referenceText.value.trim(),
                    PicAdres: pendingReferenceFile.value?.data || selectedLetter.value.picName || '',
                    takeId: selectedReferenceCustomer.value.id_subcode || 0,
                    Sender: userId || 0,
                    typAct: 2,
                    privateAct: referencePrivateForSend ? 1 : 0,
                }

                console.log(payload)

                let fileObj = null
                if (pendingReferenceFile.value) {
                    fileObj = pendingReferenceFile.value.file || null
                }

                const response = await officeService.referenceDocument(payload, fileObj)
                
                if (response.data.success) {
                    showToastMessage('نامه با موفقیت ارجاع داده شد', 'success')
                    moveLetterToTop(
                        selectedLetter.value,
                        response.data.activity?.Dates
                            ? parseDocumentDate(response.data.activity.Dates, response.data.activity.Times)
                            : new Date()
                    )
                    
                    // Store the current selected letter ID before closing
                    const currentSelectedId = selectedLetter.value?.IDDocItem
                    
                    closeReferenceModal()
                    pendingReferenceFile.value = null
                    
                    // Add the new activity to the current letter's messages
                    if (selectedLetter.value && response.data.activity) {
    const newActivity = response.data.activity

    // Reference ID — prefer what we set locally before the request
    const localRefId = sourceReferenceAct   // set by handleMessageForward
    const serverAtfAct = newActivity?.AtfAct
    const wasFirstMessageRef =
        localRefId === 0 ||
        String(serverAtfAct) === String(selectedLetter.value.IDDocItem)

    const newMessage = {
        sender: String(newActivity.GiveId) === String(userId) ? 'user' : 'other',
        senderName: String(newActivity.GiveId) === String(userId) ? 'شما' : (newActivity.Give || 'کاربر'),
        text: newActivity.Paraf || '',
        image: newActivity.PicDocAct || null,
        file_url: newActivity.PicDocAct || null,
        timestamp: parseDocumentDate(newActivity.Dates, newActivity.Times),
        status: 'sent',
        file_type: 'other',
        file_name: newActivity.PicDocAct ? newActivity.PicDocAct.split('/').pop() : '',
        isFirstMessage: false,
        activityData: newActivity,
        giveId: newActivity.GiveId,
        takeId: newActivity.TakeId,
        firstId: newActivity.FirstId,
        docActAuto: newActivity.DocActAuto,
        bed: newActivity.Bed,
        bes: newActivity.Bes,
        atf: newActivity.ATF,
        isReference: true,
        isForwarded: newActivity.TypAct === 2,
        typAct: newActivity.TypAct || 1,
        privateAct: referencePrivateForSend ? 1 : 0,
        forwardFrom: newActivity.Give || null,
        forwardTo: newActivity.Take || null,
        // 🔒 Preserve local intent
        originalDocActAuto: wasFirstMessageRef ? 0 : (localRefId || newActivity.AtfAct || null),
        giveName: newActivity.Give || 'کاربر',
        takeName: newActivity.Take || 'کاربر',
    }

    // Also attach the preview if we have the source message
    if (sourceMessage) {
        const source = sourceMessage
        newMessage.originalMessagePreview = {
            text: source.text || source.Paraf || source.activityData?.Paraf || '',
            sender: source.senderName || source.giveName || 'کاربر',
            hasFile: !!(source.file_url || source.PicDocAct || source.activityData?.PicDocAct || source.PicDocItem || source.activityData?.PicDocItem),
            fileUrl: source.file_url || source.PicDocAct || source.activityData?.PicDocAct || source.PicDocItem || source.activityData?.PicDocItem || null,
            docActAuto: wasFirstMessageRef ? 0 : (source.docActAuto ?? null),
            timestamp: source.timestamp,
        }
    }

    if (!selectedLetter.value.messages) {
        selectedLetter.value.messages = []
    }
    selectedLetter.value.messages.push(newMessage)
                        
                        // Update the letter's last activity info
                        if (newActivity.Dates) {
                            selectedLetter.value.Dates = newActivity.Dates
                        }
                        if (newActivity.Times) {
                            selectedLetter.value.Tim = newActivity.Times
                        }
                        if (newActivity.Take) {
                            selectedLetter.value.LastTake = newActivity.Take
                        }
                        if (newActivity.TakeId) {
                            selectedLetter.value.LastTakeId = newActivity.TakeId
                        }
                        if (newActivity.Dates) {
                            selectedLetter.value.LastActDate = newActivity.Dates
                        }
                        if (newActivity.Times) {
                            selectedLetter.value.LastActTime = newActivity.Times
                        }
                        
                        // Update the summary if text is available
                        if (referenceText.value.trim()) {
                            selectedLetter.value.summary = referenceText.value.trim().substring(0, 50)
                        }
                        
                        // Scroll to bottom to show the new message
                        nextTick(() => {
                            scrollToBottom()
                        })
                        
                        // Update the document in the list with new activity info
                        const docIndex = letters.value.findIndex(l => l.IDDocItem === currentSelectedId)
                        if (docIndex !== -1) {
                            const doc = letters.value[docIndex]
                            if (newActivity.Dates) doc.Dates = newActivity.Dates
                            if (newActivity.Times) doc.Tim = newActivity.Times
                            if (newActivity.Take) doc.LastTake = newActivity.Take
                            if (newActivity.TakeId) doc.LastTakeId = newActivity.TakeId
                            if (newActivity.Dates) doc.LastActDate = newActivity.Dates
                            if (newActivity.Times) doc.LastActTime = newActivity.Times
                        }
                    } else {
                        // Fallback: refresh the documents list
                        await fetchDocuments()
                        // Try to reselect the same letter
                        if (currentSelectedId) {
                            const index = letters.value.findIndex(l => l.IDDocItem === currentSelectedId)
                            if (index !== -1) {
                                await selectLetter(index)
                            }
                        }
                    }
                } else {
                    if (response.data.return_code === 403 || 
                        response.data.error_details === 'USER_NOT_REGISTERED' ||
                        (response.data.message && response.data.message.includes('not registered'))) {
                        closeReferenceModal()
                        openRegistrationModal()
                        showToastMessage('لطفاً ابتدا ثبت نام کنید', 'warning', '⚠️')
                        return
                    } else {
                        showToastMessage(response.data.error_details || response.data.message || 'خطا در ارجاع نامه', 'error')
                    }
                }
            } catch (error) {
                console.error('Error referencing document:', error)
                let errorMessage = 'خطا در ارتباط با سرور'
                
                if (error.response?.data?.detail) {
                    errorMessage = error.response.data.detail
                    if (errorMessage.includes('not registered') || errorMessage.includes('User not registered')) {
                        closeReferenceModal()
                        openRegistrationModal()
                        showToastMessage('لطفاً ابتدا ثبت نام کنید', 'warning', '⚠️')
                        return
                    }
                }
                
                showToastMessage(errorMessage, 'error', '❌')
            } finally {
                isLoading.value = false
                loadingSubmitReference.value = false;
            }
        }

        const getTypLabel = (typ) => {
            const labels = {
                1: '📤 ارسال',
                2: '📥 دریافت',
                3: '↗️ ارجاع',
                4: '↘️ ارجاع شده'
            }
            return labels[typ] || '📄'
        }

        const getProxiedImage = (url) => {
            const proxied = authStore.proxiedImage(url)
            return proxied
        }

        // Add this inside the setup() function
        const truncateFileName = (fileName, maxLength = 20) => {
            if (!fileName) return ''
            if (fileName.length <= maxLength) return fileName
            
            const ext = fileName.split('.').pop()
            const name = fileName.substring(0, fileName.lastIndexOf('.'))
            const truncatedName = name.substring(0, maxLength - ext.length - 3)
            
            return `${truncatedName}...${ext}`
        }

        const autoResizeTextarea = () => {
            const textarea = messageInput.value
            if (!textarea) return
            
            // Reset height to auto to get correct scrollHeight
            textarea.style.height = 'auto'
            // Set height to scrollHeight (limited to max 120px)
            const newHeight = Math.min(textarea.scrollHeight, 120)
            textarea.style.height = Math.max(newHeight, 28) + 'px'
        }

        const getMessageKey = (msg, idx) => {
            return `msg-${msg.id || idx}-${msg.file_url || msg.image || 'none'}-${msg.status}`
        }

        const showMessageActions = ref(false)
        const selectedMessageForActions = ref(null)
        const selectedMessageIndexForActions = ref(null)

        const openMessageActions = (msg, index) => {
            selectedMessageForActions.value = msg
            selectedMessageIndexForActions.value = index
            showMessageActions.value = true

            // If the message data carries its own SeenA (only available for activities)
            const seenStr = getMessageSeenA(msg)

            const subcodes = parseSeenSubcodes(seenStr)
            if (subcodes.length === 0) {
                // nothing to fetch
                return
            }

            // Kick off the fetch (fire and forget — template shows a loading spinner)
            loadSeenByForMessage(subcodes)
        }

        const loadSeenByForMessage = async (subcodes) => {
            if (!subcodes || subcodes.length === 0) return

            const actKey = selectedMessageForActions.value?.docActAuto
                || selectedMessageForActions.value?.activityData?.DocActAuto
                || 'unknown'

            // Cache hit?
            if (seenByCache.value[actKey]) return

            seenByLoading.value = true
            seenByError.value = null

            try {
                // Send as a comma-separated string per your API's design
                const csv = ',' + subcodes.join(',') + ','
                const response = await officeService.getAccountTitles(csv)

                if (response.data.success) {
                    const titles = response.data.titles_by_subcode || {}
                    // Build the list preserving the order from subcodes
                    const list = subcodes.map(sc => ({
                        SubCode: sc,
                        Title: titles[String(sc)] || null,
                    }))
                    seenByCache.value = { ...seenByCache.value, [actKey]: list }
                } else {
                    seenByError.value =
                        response.data.error_details || response.data.message || 'خطا در دریافت بینندگان'
                }
            } catch (err) {
                console.error('Error loading seen-by:', err)
                seenByError.value = err.response?.data?.detail || 'خطا در ارتباط با سرور'
            } finally {
                seenByLoading.value = false
            }
        }

        const clearSeenBy = () => {
            seenByLoading.value = false
            seenByError.value = null
            // Keep the cache — it's keyed by activity id, so it's safe to reuse
        }

        const closeMessageActions = () => {
            showMessageActions.value = false
            selectedMessageForActions.value = null
            selectedMessageIndexForActions.value = null
            clearSeenBy()
        }

        const handleMessageReply = (privateReply = false) => {
            const message = selectedMessageForActions.value
            isPrivateReplying.value = privateReply
            console.log('isPrivateReplying.value ' + privateReply)
            const index = selectedMessageIndexForActions.value
            closeMessageActions()
            
            if (message) {
                // Set reply state
                replyToMessage.value = message
                replyToMessageIndex.value = index
                isReplying.value = true
                
                // Get the sender name
                const senderName = message.senderName || 'کاربر'
                
                // Get the original text (truncate for display)
                //const originalText = message.text || ''
                //const truncatedText = originalText.length > 100 ? originalText.substring(0, 100) + '...' : originalText
                
                // Show reply indicator at the top of input area
                showToastMessage(`در حال پاسخ به ${senderName}`, 'info')
                
                // Focus on input
                nextTick(() => {
                    if (messageInput.value) {
                        messageInput.value.focus()
                    }
                    // Scroll to bottom to show the input area
                    scrollToBottom()
                })
            }
        }

        const handlePrivateMessageReply = () => {
            const message = selectedMessageForActions.value
            const index = selectedMessageIndexForActions.value
            if (!message) return

            privateReplySourceMessage.value = message
            privateReplySourceIndex.value = index
            const defaultRecipient = defaultRecipientForMessage(message)
            selectedPrivateRecipient.value = defaultRecipient.id_subcode ? defaultRecipient : null
            const participant = letterParticipants.value.find(person =>
                String(person.SubCodeId) === String(selectedPrivateRecipient.value?.id_subcode)
            )
            privateRecipientParticipantId.value = participant ? String(participant.SubCodeId) : ''
            privateRecipientSearchQuery.value = ''
            privateRecipientSearchResults.value = []
            closeMessageActions()
            showPrivateRecipientModal.value = true
        }

        const selectPrivateLetterParticipant = () => {
            if (!privateRecipientParticipantId.value) return
            const person = letterParticipants.value.find(item =>
                String(item.SubCodeId) === String(privateRecipientParticipantId.value)
            )
            if (person) {
                selectedPrivateRecipient.value = toRecipientChoice(person)
                privateRecipientSearchQuery.value = ''
                privateRecipientSearchResults.value = []
            }
        }

        const selectPrivateSearchRecipient = (person) => {
            selectedPrivateRecipient.value = person
            const participant = letterParticipants.value.find(item =>
                String(item.SubCodeId) === String(person.id_subcode)
            )
            privateRecipientParticipantId.value = participant ? String(participant.SubCodeId) : ''
            privateRecipientSearchQuery.value = person.full_name || person.title || ''
            privateRecipientSearchResults.value = []
        }

// Accepts an optional query string (like searchCustomers()), so the template
// can call it with '' on focus to fetch everyone.
const searchPrivateRecipients = async (queryOverride = undefined) => {
    const query = (queryOverride !== undefined
        ? queryOverride
        : privateRecipientSearchQuery.value
    ).trim()

    try {
        isLoading.value = true
        const response = await officeService.searchParents(query)

        if (response.data.success) {
            const parents = response.data.parents || []

            privateRecipientSearchResults.value = parents
                // Never allow selecting yourself as a private recipient
                .filter(parent =>
                    String(parent.id_subcode) !== String(authStore.user?.subCodeId)
                )
                .map(parent => ({
                    id: parent.id_subcode || 0,
                    phone_number: parent.tel2 || '',
                    first_name: parent.title || '',
                    last_name: '',
                    full_name: parent.title || 'کاربر بدون نام',
                    sub_code_id: parent.id_subcode,
                    id_subcode: parent.id_subcode,
                    title: parent.title,
                    tel2: parent.tel2,
                }))

            if (privateRecipientSearchResults.value.length === 0) {
                showToastMessage('مشتریی یافت نشد', 'info')
            }
        } else {
            showToastMessage('خطا در جستجوی مشتریان', 'error')
        }
    } catch (error) {
        console.error('Error searching private recipients:', error)
        showToastMessage('خطا در ارتباط با سرور', 'error')
        privateRecipientSearchResults.value = []
    } finally {
        isLoading.value = false
    }
}

// Debounced wrapper for the @input handler
const onPrivateRecipientSearchInput = () => {
    clearTimeout(privateRecipientSearchTimer.value)
    const delay = window.innerWidth < 768 ? 50 : 300

    privateRecipientSearchTimer.value = setTimeout(() => {
        const query = privateRecipientSearchQuery.value.trim()
        if (query) {
            selectedPrivateRecipient.value = null
            privateRecipientParticipantId.value = ''
            searchPrivateRecipients()
        } else {
            privateRecipientSearchResults.value = []
        }
    }, delay)
}

        const cancelPrivateRecipientSelection = () => {
            showPrivateRecipientModal.value = false
            privateReplySourceMessage.value = null
            privateReplySourceIndex.value = null
            selectedPrivateRecipient.value = null
            privateRecipientParticipantId.value = ''
            privateRecipientSearchQuery.value = ''
            privateRecipientSearchResults.value = []
        }

        const continuePrivateReply = () => {
            if (!selectedPrivateRecipient.value?.id_subcode || !privateReplySourceMessage.value) return
            if (String(selectedPrivateRecipient.value.id_subcode) === String(authStore.user?.subCodeId)) {
                showToastMessage('نمی‌توانید خودتان را به‌عنوان گیرنده پاسخ خصوصی انتخاب کنید', 'warning')
                return
            }
            replyToMessage.value = privateReplySourceMessage.value
            replyToMessageIndex.value = privateReplySourceIndex.value
            isReplying.value = true
            isPrivateReplying.value = true
            showPrivateRecipientModal.value = false
            privateReplySourceMessage.value = null
            privateReplySourceIndex.value = null
            showToastMessage(`پاسخ خصوصی برای ${getCustomerDisplayName(selectedPrivateRecipient.value)}`, 'info')
            nextTick(() => {
                messageInput.value?.focus()
                scrollToBottom()
            })
        }

        const handleMessageForward = () => {
            const message = selectedMessageForActions.value
            if (!message) return

            closeMessageActions()
            openReferenceModal()
            referenceIsPrivate.value = false
            referencingMessage.value = ''
            referenceAct.value = getReferenceIdForMessage(message)

            const defaultRecipient = defaultRecipientForMessage(message)
            selectedReferenceCustomer.value = defaultRecipient
            referenceSearchQuery.value = defaultRecipient.full_name
            const participant = letterParticipants.value.find(person =>
                String(person.SubCodeId) === String(defaultRecipient.id_subcode)
            )
            referenceParticipantId.value = participant ? String(participant.SubCodeId) : ''

            showToastMessage('گیرنده ارجاع را بررسی یا تغییر دهید', 'info')
        }

        const handleMessageCopy = () => {
            const message = selectedMessageForActions.value
            closeMessageActions()
            
            if (message) {
                const text = message.text || ''
                // Copy to clipboard
                navigator.clipboard.writeText(text).then(() => {
                    showToastMessage('متن پیام کپی شد', 'success')
                }).catch(() => {
                    // Fallback
                    const textarea = document.createElement('textarea')
                    textarea.value = text
                    document.body.appendChild(textarea)
                    textarea.select()
                    document.execCommand('copy')
                    document.body.removeChild(textarea)
                    showToastMessage('متن پیام کپی شد', 'success')
                })
            }
        }

        // Helper to fetch a file from a URL and convert it to the newChatFile format
        const fetchFileForPendingAction = async (fileUrl, fileName) => {
            if (!fileUrl) return null
            
            try {
                const proxiedUrl = getProxiedImage(fileUrl)
                const response = await fetch(proxiedUrl)
                
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}`)
                }
                
                const blob = await response.blob()
                
                // Derive the filename from URL if not provided
                let name = fileName
                if (!name) {
                    const cleanUrl = fileUrl.split('?')[0]
                    name = cleanUrl.split('/').pop() || `file_${Date.now()}`
                }
                
                const file = new File([blob], name, { type: blob.type || 'application/octet-stream' })
                
                // Convert to data URL
                const dataUrl = await new Promise((resolve, reject) => {
                    const reader = new FileReader()
                    reader.onload = (e) => resolve(e.target.result)
                    reader.onerror = reject
                    reader.readAsDataURL(blob)
                })
                
                const fileInfo = getFileTypeInfo(blob.type, name)
                
                return {
                    data: dataUrl,
                    file: file,
                    name: name,
                    type: blob.type,
                    file_type: fileInfo.type,
                    displayType: fileInfo.displayType,
                    icon: fileInfo.icon,
                    persianType: fileInfo.persianType,
                    mime_type: blob.type
                }
            } catch (error) {
                console.error('Error fetching file for pending action:', error)
                return null
            }
        }

        const handleMessagePendingActions = async () => {
            const message = selectedMessageForActions.value
            closeMessageActions()
            console.log('message ' + message)
            
            if (message) {
                const act = message.activityData || {}
                const senderName = act.Give || message.giveName || message.senderName || 'کاربر'
                const messageText = message.text || act.Paraf || act.Comment || act.Marbot || ''
                const prefilledText = `بازارسال شده از ${senderName}\n${messageText}`
                
                // Get the file URL from the selected act (prefer PicDocAct, fall back to PicDocItem)
                const fileUrl = message.file_url || message.image || act.PicDocAct || act.PicDocItem || null
                const fileName = message.file_name || (fileUrl ? fileUrl.split('/').pop() : '')
                
                // Show a loading toast if there's a file to fetch
                if (fileUrl) {
                    showToastMessage('در حال دریافت فایل...', 'info')
                }
                
                // Fetch the file if it exists
                let fetchedFile = null
                if (fileUrl) {
                    fetchedFile = await fetchFileForPendingAction(fileUrl, fileName)
                    if (!fetchedFile) {
                        showToastMessage('خطا در دریافت فایل پیام', 'error')
                    }
                }
                
                // Open the modal with the prefilled text and file
                openNewChatModal(prefilledText, '', fetchedFile)
            }
        }

        const handleMessageDelete = () => {
            const index = selectedMessageIndexForActions.value
            closeMessageActions()
            
            if (index !== null && confirm('آیا از حذف این پیام اطمینان دارید؟')) {
                // Remove the message from the array
                if (selectedLetter.value && selectedLetter.value.messages) {
                    selectedLetter.value.messages.splice(index, 1)
                    showToastMessage('پیام حذف شد', 'success')
                }
            }
        }

const handleMessageDownload = async () => {
    // Store the message reference BEFORE closing
    const message = selectedMessageForActions.value

    // Close the modal
    closeMessageActions()

    console.log('Downloading message:', message)

    if (!message) {
        showToastMessage('پیامی برای دانلود وجود ندارد', 'error')
        return
    }

    try {
        const fileUrl = message.file_url || message.image

        if (fileUrl) {
            // If it's a local data/blob URL, a plain link works
            if (fileUrl.startsWith('data:') || fileUrl.startsWith('blob:')) {
                const link = document.createElement('a')
                link.href = fileUrl
                link.download = message.file_name || 'download'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                showToastMessage('دانلود شروع شد', 'success')
                return
            }

            // Cross-origin URL → fetch as blob, then download via object URL
            const proxied = getProxiedImage(fileUrl)

            const response = await fetch(proxied, {
                method: 'GET',
                // If your proxy needs auth, add it here:
                // headers: { Authorization: `Bearer ${authStore.token}` },
            })

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`)
            }

            const blob = await response.blob()
            const objectUrl = URL.createObjectURL(blob)

            // Build a good filename
            let fileName = message.file_name
            if (!fileName) {
                // try to derive from URL, strip query string
                const cleanUrl = fileUrl.split('?')[0]
                fileName = cleanUrl.split('/').pop() || `download_${Date.now()}`
            }

            const link = document.createElement('a')
            link.href = objectUrl
            link.download = fileName
            link.style.display = 'none'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)

            // Give the browser a tick to start the download before revoking
            setTimeout(() => URL.revokeObjectURL(objectUrl), 1000)

            showToastMessage('دانلود شروع شد', 'success')
        } else {
            // If no file, download the text as a .txt file
            const text = message.text || ''
            const blob = new Blob([text], { type: 'text/plain;charset=utf-8' })
            const url = URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = `message_${Date.now()}.txt`
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            URL.revokeObjectURL(url)
            showToastMessage('متن پیام دانلود شد', 'success')
        }
    } catch (error) {
        console.error('Download error:', error)
        showToastMessage('خطا در دانلود', 'error')
    }
}

        // ============ TUTORIAL / TOOLTIP SYSTEM ============
        const TUTORIAL_KEY = 'chat_letter_tutorial_shown'

        const showTutorial = ref(false)
        const currentStep = ref(0)
        const showTooltip = ref(false)
        const tooltipText = ref('')
        const tooltipStyle = ref({})
        const tooltipTimeout = ref(null)

        const tutorialSteps = [
            {
                title: '📬 ایجاد نامه جدید',
                description: 'برای ایجاد یک نامه جدید، روی دکمه + در نوار بالایی کلیک کنید. سپس گیرنده و متن نامه را وارد کنید.',
                icon: '📝',
                target: '.primary-btn'
            },
            {
                title: '📄 مشاهده نامه‌ها',
                description: 'برای مشاهده جزئیات یک نامه، روی آن کلیک کنید. تمام پیام‌ها و فایل‌های ضمیمه را مشاهده خواهید کرد.',
                icon: '👁️',
                target: '.letter-item'
            },
            {
                title: '📎 ارسال فایل',
                description: 'برای ارسال فایل، روی دکمه کلیپس 📎 کلیک کنید. می‌توانید تصویر، صدا، ویدئو یا هر نوع فایل دیگری ارسال کنید.',
                icon: '📎',
                target: '.tool-btn:first-child'
            },
            {
                title: '🎤 ضبط صدا',
                description: 'برای ضبط صدا، روی دکمه میکروفون 🎤 کلیک کنید. پس از اتمام ضبط، فایل صوتی به صورت خودکار ارسال می‌شود.',
                icon: '🎙️',
                target: '.tool-btn.recording'
            },
            {
                title: '↩️ ارجاع نامه',
                description: 'برای ارجاع یک نامه به شخص دیگر، روی دکمه اشتراک گذاری 📤 در نوار بالایی کلیک کنید و گیرنده را انتخاب کنید.',
                icon: '🔄',
                target: '.action-btn:last-child'
            },
            {
                title: '📋 عملیات روی پیام',
                description: 'روی هر پیام، دکمه سه نقطه ⋮ را ببینید. با کلیک روی آن می‌توانید پاسخ دهید، بازارسال کنید، کپی کنید، دانلود کنید یا حذف کنید.',
                icon: '⚡',
                target: '.msg-menu-btn'
            }
        ]

        // Check if tutorial should be shown
        const checkTutorial = () => {
            const tutorialShown = localStorage.getItem(TUTORIAL_KEY)
            if (!tutorialShown) {
                // Show tutorial after a short delay
                setTimeout(() => {
                    showTutorial.value = true
                }, 500)
            }
        }

        const closeTutorial = () => {
            showTutorial.value = false
            localStorage.setItem(TUTORIAL_KEY, 'true')
            // Show tooltips after tutorial
            setTimeout(() => {
                showNextTooltip()
            }, 1000)
        }

        const nextTutorialStep = () => {
            if (currentStep.value < tutorialSteps.length - 1) {
                currentStep.value++
            } else {
                closeTutorial()
            }
        }

        // Tooltip system for highlighting elements
        const showNextTooltip = () => {
            const steps = [
                {
                    text: 'ایجاد نامه جدید با دکمه +',
                    selector: '.primary-btn',
                    position: 'bottom'
                },
                {
                    text: 'مشاهده نامه‌ها با کلیک روی هر کدام',
                    selector: '.letter-item',
                    position: 'bottom'
                },
                {
                    text: 'ارسال فایل با دکمه کلیپس 📎',
                    selector: '.tool-btn:first-child',
                    position: 'bottom'
                },
                {
                    text: 'ضبط صدا با دکمه میکروفون 🎤',
                    selector: '.tool-btn.recording',
                    position: 'bottom'
                },
                {
                    text: 'ارجاع نامه با دکمه اشتراک گذاری 📤',
                    selector: '.action-btn:last-child',
                    position: 'bottom'
                },
                {
                    text: 'عملیات روی پیام با دکمه سه نقطه ⋮',
                    selector: '.msg-menu-btn',
                    position: 'bottom'
                }
            ]
            
            let currentTooltipIndex = 0
            
            const showTooltipForElement = (index) => {
                if (index >= steps.length) {
                    return
                }
                
                const step = steps[index]
                const element = document.querySelector(step.selector)
                
                if (element) {
                    const rect = element.getBoundingClientRect()
                    const tooltipWidth = 280
                    
                    let left = rect.left + rect.width / 2 - tooltipWidth / 2
                    let top = rect.bottom + 16
                    
                    // Adjust position if tooltip goes off screen
                    if (left < 16) left = 16
                    if (left + tooltipWidth > window.innerWidth - 16) {
                        left = window.innerWidth - tooltipWidth - 16
                    }
                    if (top + 100 > window.innerHeight - 16) {
                        top = rect.top - 100
                    }
                    
                    tooltipStyle.value = {
                        left: left + 'px',
                        top: top + 'px',
                        width: tooltipWidth + 'px'
                    }
                    tooltipText.value = step.text
                    showTooltip.value = true
                    
                    // Highlight the element
                    element.style.boxShadow = '0 0 0 4px var(--primary), 0 0 20px rgba(108, 92, 231, 0.3)'
                    element.style.transition = 'box-shadow 0.3s ease'
                    
                    // Store reference to remove highlight later
                    const highlightedElement = element
                    
                    // Auto advance after 4 seconds
                    if (tooltipTimeout.value) {
                        clearTimeout(tooltipTimeout.value)
                    }
                    
                    tooltipTimeout.value = setTimeout(() => {
                        // Remove highlight
                        highlightedElement.style.boxShadow = ''
                        showTooltip.value = false
                        currentTooltipIndex++
                        setTimeout(() => {
                            showTooltipForElement(currentTooltipIndex)
                        }, 500)
                    }, 4000)
                } else {
                    // Element not found, skip to next
                    currentTooltipIndex++
                    setTimeout(() => {
                        showTooltipForElement(currentTooltipIndex)
                    }, 500)
                }
            }
            
            // Start showing tooltips
            setTimeout(() => {
                showTooltipForElement(0)
            }, 500)
        }

        const closeTooltip = () => {
            showTooltip.value = false
            if (tooltipTimeout.value) {
                clearTimeout(tooltipTimeout.value)
                tooltipTimeout.value = null
            }
            // Remove highlights
            document.querySelectorAll('.primary-btn, .letter-item, .tool-btn, .action-btn, .msg-menu-btn').forEach(el => {
                el.style.boxShadow = ''
            })
        }

const filteredMessages = computed(() => {
    if (!selectedLetter.value) {
        return []
    }
    const selectedId = selectedLetter.value.IDDocItem ?? selectedLetter.value.Doc_Auto ?? selectedLetter.value.id
    const sourceMessages = String(twoPersonViewLetterId.value) === String(selectedId)
        ? twoPersonMessages.value
        : selectedLetter.value.messages
    if (!sourceMessages) return []
    // Filter out messages that have no content
    return sourceMessages.filter(msg => {
        // Check if message has any content
        const hasImage = msg.image && msg.image !== null && msg.image !== ''
        const hasFile = msg.file_url && msg.file_url !== null && msg.file_url !== ''
        const hasText = msg.text && msg.text.trim() !== ''
        
        return hasImage || hasFile || hasText
    })
})

        // ============ POLLING / REFRESH SYSTEM ============
        const POLLING_INTERVAL = 30000 // 30 seconds for document list
        const ACTIVITY_POLLING_INTERVAL = 15000 // 15 seconds for activities
        let documentPollingTimer = null
        let activityPollingTimer = null
        let isDocumentPolling = ref(false)
        let isActivityPolling = ref(false)
        let lastDocumentFetch = ref(null)
        let lastActivityFetch = ref(null)
        let documentHash = ref('')
        let activityHash = ref('')

        // Generate a simple hash from documents array for change detection
        const generateDocumentHash = (docs) => {
            if (!docs || docs.length === 0) return 'empty'
            // Use ID + LastActDate + LastActTime for quick comparison
            return docs.map(d => `${d.IDDocItem}|${d.LastActDate || d.Dates}|${d.LastActTime || d.Tim}`).join('|')
        }

        // Generate a simple hash from activities for change detection
        const generateActivityHash = (activities) => {
            if (!activities || activities.length === 0) return 'empty'
            return activities.map(a => `${a.DocActAuto}|${a.Dates}|${a.Times}`).join('|')
        }

        // Smart fetch documents with change detection
        const fetchDocumentsSmart = async (force = false) => {
            if (isDocumentPolling.value) return
            
            try {
                isDocumentPolling.value = true
                const userId = authStore.user?.subCodeId
                
                if (!userId) {
                    return
                }
                console.log(filterAct.value + ' ' + filterAc.value)
                const response = await officeService.listDoc2(
                    userId,
                    filterAc.value ?? 0,
                    filterAct.value ?? 0,
                )
                
                if (response.data.success && response.data.documents) {
                    const transformedLetters = response.data.documents.map((doc, index) => {
                        return {
                            id: doc.Doc_Auto || doc.IDDocItem || Date.now() + index,
                            customerId: doc.SenderId || doc.ReceiverId || 'unknown',
                            customerName: doc.Sender || doc.Receiver || 'مشتری',
                            summary: doc.Expl?.substring(0, 50) || 'نامه',
                            description: doc.Expl || '',
                            date: parseDocumentDate(doc.Dates, doc.Tim),
                            status: 'sent',
                            unread: 0,
                            messages: [],
                            activityId: doc.IDDocItem || null,
                            documentId: doc.Doc_Auto || doc.IDDocAct || null,
                            IDDocItem: doc.IDDocItem,
                            IDDocAct: doc.Doc_Auto || doc.IDDocAct,
                            Doc_Auto: doc.Doc_Auto,
                            docData: doc,
                            Sender: doc.Sender,
                            Receiver: doc.Receiver,
                            SenderId: doc.SenderId,
                            ReceiverId: doc.ReceiverId,
                            typ: doc.typ,
                            Tim: doc.Tim,
                            Expl: doc.Expl,
                            Dates: doc.Dates,
                            LastTake: doc.LastTake,
                            LastTakeId: doc.LastTakeId,
                            LastActDate: doc.LastActDate || doc.Dates,
                            LastActTime: doc.LastActTime || doc.Tim,
                            LastDate: parseDocumentDate(
                                doc.LastActDate || doc.Dates,
                                doc.LastActTime || doc.Tim
                            ),
                            docItemData: null,
                            type: null,
                            marbot: null,
                            comment: null,
                            atf: null,
                            bed: null,
                            bes: null,
                            picName: null,
                            activities: [],
                            participants: null,
                            activityLoaded: false,
                            closeDoc: doc.closeDoc ?? doc.CloseDoc ?? 0,
                            Seen: doc.Seen ?? '',
                            SeenA: doc.SeenA ?? '',
                            MohalKar: doc.MohalKar ?? '',
                            RateDoc: doc.RateDoc ?? 0
                        }
                    })
                    
                    // Sort documents by LastActDate and LastActTime (newest first)
                    transformedLetters.sort((a, b) => {
                        const dateA = parseDocumentDate(a.LastActDate, a.LastActTime)
                        const dateB = parseDocumentDate(b.LastActDate, b.LastActTime)
                        if (dateA && dateB) {
                            return new Date(dateB).getTime() - new Date(dateA).getTime()
                        }
                        return 0
                    })
                    
                    // Check if there are actual changes
                    const newHash = generateDocumentHash(transformedLetters)
                    const hasChanged = newHash !== documentHash.value || force
                    
                    if (hasChanged || force) {
                        // Preserve selected letter's messages if it exists
                        const selectedId = selectedLetter.value?.IDDocItem
                        let preservedMessages = null
                        let preservedActivities = null
                        let preservedParticipants = null
                        let preservedActivityLoaded = false
                        
                        if (selectedId) {
                            const existingDoc = letters.value.find(l => l.IDDocItem === selectedId)
                            if (existingDoc) {
                                preservedMessages = existingDoc.messages
                                preservedActivities = existingDoc.activities
                                preservedParticipants = existingDoc.participants
                                preservedActivityLoaded = existingDoc.activityLoaded
                            }
                        }
                        
                        // Update the letters
                        letters.value = transformedLetters
                        documentHash.value = newHash
                        lastDocumentFetch.value = new Date().toISOString()
                        
                        // Restore messages for selected letter if it still exists
                        if (selectedId && preservedMessages) {
                            const restoredDoc = letters.value.find(l => l.IDDocItem === selectedId)
                            if (restoredDoc) {
                                restoredDoc.messages = preservedMessages
                                restoredDoc.activities = preservedActivities
                                restoredDoc.participants = preservedParticipants
                                restoredDoc.activityLoaded = preservedActivityLoaded
                            }
                        }

                        if (selectedLetter.value) {
                            markSeenForLetter(selectedLetter.value)
                        }
                        
                        // Update selected index if needed
                        if (selectedId) {
                            const newIndex = letters.value.findIndex(l => l.IDDocItem === selectedId)
                            if (newIndex !== -1 && selectedLetterIndex.value !== null) {
                                selectedLetterIndex.value = newIndex
                            } else if (newIndex === -1 && selectedLetterIndex.value !== null) {
                                // Selected letter was deleted
                                selectedLetterIndex.value = null
                                showChat.value = false
                                showToastMessage('نامه انتخابی حذف شده است', 'info')
                            }
                        }
                        
                        // Only show toast on initial load or if there were changes
                        if (!force && hasChanged) {
                            // Silent update - no toast to avoid spam
                        }
                    }
                }
            } catch (error) {
                console.error('Error polling documents:', error)
            } finally {
                isDocumentPolling.value = false
            }
        }

        const getMessageSeenA = (msg) => {
    if (!msg) return ''
    // Prefer the live activity object (which markSeenForLetter updates)
    return msg.activityData?.SeenA ?? msg.SeenA ?? ''
}

        // Smart fetch activities for selected letter
        const fetchActivitiesSmart = async (force = false) => {
            if (isActivityPolling.value) return
            if (!selectedLetter.value) return
            
            const docCode = selectedLetter.value.Doc_Auto
            if (!docCode) return
            
            try {
                isActivityPolling.value = true
                const response = await officeService.listDocAct(docCode)
                
                if (response.data.success && response.data.activities) {
                    const activities = response.data.activities
                    selectedLetter.value.participants = response.data.participants || []
                    const newHash = generateActivityHash(activities)
                    const hasChanged = newHash !== activityHash.value || force
                    
                    if (hasChanged || force) {
                        const userId = authStore.user?.subCodeId
                        const messages = []
                        let firstMessage = null
                        const restMessages = []
                        
                        // Create a map for quick lookup
                        const activityMap = {}
                        activities.forEach(act => {
                            activityMap[act.DocActAuto] = act
                        })
                        
                        // Process first activity
                        if (activities.length > 0) {
                            const firstAct = activities[0]
                            const firstText = firstAct.Comment || firstAct.Marbot || firstAct.Paraf || ''
                            const firstFileUrl = firstAct.PicDocItem || null
                            const firstFileName = firstFileUrl ? firstFileUrl.split('/').pop() : ''
                            const isFirstMessageUser = String(selectedLetter.value.SenderId) === String(userId)
                            
                            let firstFileType = 'other'
                            if (firstFileUrl) {
                                const urlLower = firstFileUrl.toLowerCase()
                                if (urlLower.match(/\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i)) {
                                    firstFileType = 'image'
                                } else if (urlLower.match(/\.(mp3|wav|ogg|m4a|aac|flac|webm)$/i)) {
                                    firstFileType = 'audio'
                                } else if (urlLower.match(/\.(mp4|avi|mov|wmv|mkv|flv)$/i)) {
                                    firstFileType = 'video'
                                } else if (urlLower.match(/\.pdf$/i)) {
                                    firstFileType = 'pdf'
                                } else if (urlLower.match(/\.(doc|docx|xls|xlsx|ppt|pptx|txt|rtf)$/i)) {
                                    firstFileType = 'document'
                                } else if (urlLower.match(/\.(zip|rar|7z|tar|gz)$/i)) {
                                    firstFileType = 'archive'
                                }
                            }
                            
                            firstMessage = {
                                giveId: selectedLetter.value.SenderId,
                                takeId: selectedLetter.value.ReceiverId,
                                firstId: selectedLetter.value.SenderId,
                                giveName: selectedLetter.value.Sender || 'کاربر',
                                takeName: selectedLetter.value.Receiver || 'کاربر',
                                sender: isFirstMessageUser ? 'user' : 'other',
                                senderName: isFirstMessageUser ? 'شما' : (selectedLetter.value.Sender || 'کاربر'),
                                text: firstText,
                                image: firstFileUrl,
                                file_url: firstFileUrl,
                                timestamp: parseDocumentDate(firstAct.FDates, firstAct.FTimes),
                                status: 'sent',
                                file_type: firstFileType,
                                file_name: firstFileName || 'فایل',
                                icon: getFileTypeInfo('', firstFileName).icon,
                                displayType: getFileTypeInfo('', firstFileName).displayType,
                                mime_type: '',
                                isFirstMessage: true,
                                activityData: firstAct,
                                privateAct: 0,
                                __order: 0,
                                isForwarded: false,
                                typAct: firstAct.TypAct || 1,
                                forwardFrom: null,
                                forwardTo: null,
                                originalDocActAuto: null,
                                SeenA: firstAct.SeenA ?? '',
                            }
                        }
                        console.log('ffff ' + firstMessage.giveId)
                        
                        // Process remaining activities
                        for (let i = 0; i < activities.length; i++) {
                            const act = activities[i]
                            const isUser = String(act.GiveId) === String(userId)
                            const text = act.Paraf || ''
                            let fileUrl = act.PicDocAct || null
                            let fileName = fileUrl ? fileUrl.split('/').pop() : ''
                            
                            let fileType = 'other'
                            if (fileUrl) {
                                const urlLower = fileUrl.toLowerCase()
                                if (urlLower.match(/\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i)) {
                                    fileType = 'image'
                                } else if (urlLower.match(/\.(mp3|wav|ogg|m4a|aac|flac|webm)$/i)) {
                                    fileType = 'audio'
                                } else if (urlLower.match(/\.(mp4|avi|mov|wmv|mkv|flv)$/i)) {
                                    fileType = 'video'
                                } else if (urlLower.match(/\.pdf$/i)) {
                                    fileType = 'pdf'
                                } else if (urlLower.match(/\.(doc|docx|xls|xlsx|ppt|pptx|txt|rtf)$/i)) {
                                    fileType = 'document'
                                } else if (urlLower.match(/\.(zip|rar|7z|tar|gz)$/i)) {
                                    fileType = 'archive'
                                }
                            }
                            
                            let senderName = act.Give || 'کاربر'
                            if (isUser) {
                                senderName = 'شما'
                            }
                                                        
                            const isForwarded = act.TypAct === 2
                            let forwardFrom = null
                            let forwardTo = null
                            let originalDocActAuto = null
                            let originalMessagePreview = null

                            if (isForwarded && act.AtfAct !== undefined && act.AtfAct !== null) {
                                // Two cases mean "the target is the first message":
                                //   1. The SP returned AtfAct === 0 (older server versions)
                                //   2. The SP returned AtfAct === IDDocItem (current behavior)
                                //
                                // NOTE: in fetchActivitiesSmart, `selectedLetter.value.IDDocItem` is the
                                // current doc's ID. We compare against it directly to avoid depending on
                                // the helper (which reads selectedLetter.value, same value here, but
                                // being explicit keeps this function self-contained).
                                const currentDocId = selectedLetter.value?.IDDocItem
                                const isRootReference =
                                    Number(act.AtfAct) === 0 ||
                                    (
                                        Number(act.TypAct) === 2 &&
                                        currentDocId !== undefined &&
                                        currentDocId !== null &&
                                        String(act.AtfAct) === String(currentDocId)
                                    )

                                originalDocActAuto = isRootReference ? 0 : act.AtfAct

                                const originalAct = isRootReference
                                    ? activities[0]
                                    : activityMap[act.AtfAct]

                                if (originalAct) {
                                    forwardFrom = act.Give || 'کاربر'
                                    forwardTo = act.Take || 'کاربر'
                                    originalMessagePreview = {
                                        text: isRootReference ? originalAct.Comment : originalAct.Paraf,
                                        sender: originalAct.Give || 'کاربر',
                                        hasFile: !!(originalAct.PicDocAct || originalAct.PicDocItem),
                                        fileUrl: originalAct.PicDocAct || originalAct.PicDocItem || null,
                                        docActAuto: isRootReference ? 0 : originalAct.DocActAuto,
                                        timestamp: parseDocumentDate(
                                            originalAct.Dates || originalAct.FDates,
                                            originalAct.Times || originalAct.FTimes
                                        )
                                    }
                                }
                            }
                            
                            const message = {
                                sender: isUser ? 'user' : 'other',
                                senderName: senderName,
                                text: text,
                                image: fileUrl,
                                file_url: fileUrl,
                                timestamp: parseDocumentDate(act.Dates, act.Times),
                                status: 'sent',
                                file_type: fileType,
                                file_name: fileName || 'فایل',
                                icon: getFileTypeInfo('', fileName).icon,
                                displayType: getFileTypeInfo('', fileName).displayType,
                                mime_type: '',
                                isFirstMessage: false,
                                activityData: act,
                                giveId: act.GiveId,
                                takeId: act.TakeId,
                                firstId: act.FirstId,
                                docActAuto: act.DocActAuto,
                                bed: act.Bed,
                                bes: act.Bes,
                                atf: act.ATF,
                                isReference: act.ATF && act.ATF > 0,
                                __order: i,
                                isForwarded: isForwarded,
                                typAct: act.TypAct || 1,
                                forwardFrom: forwardFrom,
                                forwardTo: forwardTo,
                                originalDocActAuto: originalDocActAuto,
                                originalMessagePreview: originalMessagePreview,
                                giveName: act.Give || 'کاربر',
                                takeName: act.Take || 'کاربر',
                                privateAct: Number(act.PrivateAct) === 1 ? 1 : 0,
                                scrollTarget: isForwarded ? originalDocActAuto : null,
                                SeenA: act.SeenA ?? '',
                            }
                            
                            restMessages.push(message)
                        }
                        
                        // Sort rest messages
                        restMessages.sort((a, b) => {
                            const dateA = new Date(a.timestamp)
                            const dateB = new Date(b.timestamp)
                            return dateA - dateB
                        })
                        
                        // Build final messages
                        if (firstMessage) {
                            messages.push(firstMessage)
                        }
                        messages.push(...restMessages)
                        if (firstMessage) {
                            firstMessage.__order = 0
                        }
                        
                        // Update the letter with new messages
                        const currentLetter = selectedLetter.value
                        if (currentLetter) {
                            currentLetter.messages = messages
                            currentLetter.activities = activities
                            currentLetter.participants = response.data.participants || []
                            currentLetter.activityLoaded = true
                            activityHash.value = newHash
                            lastActivityFetch.value = new Date().toISOString()

                            // ✅ Mark any newly-arrived activities as seen (user is currently
                            //    viewing this thread, so they've implicitly read everything)
                            markSeenForLetter(currentLetter)

                            if (hasChanged) {
                                nextTick(() => {
                                    scrollToBottom()
                                })
                            }
                        }
                    }
                }
            } catch (error) {
                console.error('Error polling activities:', error)
            } finally {
                isActivityPolling.value = false
            }
        }

        // Start polling
        const startPolling = () => {
            // Clear any existing timers
            stopPolling()
            
            // Document list polling - every 30 seconds
            documentPollingTimer = setInterval(() => {
                fetchDocumentsSmart(false)
            }, POLLING_INTERVAL)
            
            // Activities polling - only if a letter is selected
            activityPollingTimer = setInterval(() => {
                if (selectedLetter.value) {
                    fetchActivitiesSmart(false)
                }
            }, ACTIVITY_POLLING_INTERVAL)
        }

        // Stop polling
        const stopPolling = () => {
            if (documentPollingTimer) {
                clearInterval(documentPollingTimer)
                documentPollingTimer = null
            }
            if (activityPollingTimer) {
                clearInterval(activityPollingTimer)
                activityPollingTimer = null
            }
        }

const lastFetchedLetterId = ref(null)

watch(selectedLetter, (newLetter, oldLetter) => {
    if (!newLetter) return

    const id = newLetter.IDDocItem

    // Skip if the same letter as before
    if (oldLetter && id === oldLetter.IDDocItem) return

    // Skip if we just loaded this letter via selectLetter
    if (lastFetchedLetterId.value === id) return

    activityHash.value = ''
    fetchActivitiesSmart(true)
})

        // Watch for message changes to resize
        watch(newMessage, () => {
            nextTick(() => {
                autoResizeTextarea()
            })
        })

        // ============ CLOSE + RATING FLOW ============

        // --- Rating state (already added) ---
        const showRatingModal = ref(false)
        const ratingValue = ref(0)
        const ratingFeedback = ref('')
        const ratingSubmitAttempted = ref(false)
        const ratingSubmitting = ref(false)
        const ratingDocId = ref(null)
        const ratingLetterRef = ref(null)

        // --- Close confirmation state (NEW) ---
        const showCloseConfirmModal = ref(false)
        const pendingCloseLetter = ref(null)
        const isClosingLetter = ref(false)
        const completingLetterId = ref(null)

        const ratingOptions = [
        { value: 1, emoji: '😡', label: 'خیلی بد' },
        { value: 2, emoji: '🙁', label: 'بد' },
        { value: 3, emoji: '😐', label: 'متوسط' },
        { value: 4, emoji: '🙂', label: 'خوب' },
        { value: 5, emoji: '🤩', label: 'عالی' },
        ]

        const needsRatingFeedback = computed(() => {
        return ratingValue.value >= 1 && ratingValue.value <= 3
        })

        const canSubmitRating = computed(() => {
        if (ratingValue.value < 1 || ratingValue.value > 5) return false
        if (needsRatingFeedback.value && !ratingFeedback.value.trim()) return false
        return !ratingSubmitting.value
        })

        const markLetterDone = async (letter) => {
        if (!letter || !isEmployee.value || isLetterClosed(letter) || isLetterDone(letter)) return

        const docId = letter.Doc_Auto || letter.IDDocItem
        if (!docId) {
            showToastMessage('شناسه نامه پیدا نشد', 'error')
            return
        }

        completingLetterId.value = String(docId)
        try {
            const response = await officeService.closeOrRateDoc({
                IDDoc: docId,
                CloseOrRate: 'C',
                val: 2,
                RateTxt: '',
            })

            if (!response.data.success) {
                showToastMessage(response.data.error_details || response.data.message || 'ثبت انجام کار ناموفق بود', 'error')
                return
            }

            letter.closeDoc = 2
            letter.CloseDoc = 2
            showToastMessage('وضعیت نامه انجام شد؛ برای فرستنده اعلان ارسال شد', 'success')
        } catch (error) {
            console.error('Error marking letter as done:', error)
            showToastMessage(error.response?.data?.detail || 'خطا در ثبت انجام کار نامه', 'error')
        } finally {
            completingLetterId.value = null
        }
        }

        // Step 1 — user clicks the close button → show confirmation
        const closeLetter = (letter) => {
        if (!letter) return

        if (!isCustomer.value || !isLetterDone(letter)) {
            showToastMessage('بستن و امتیازدهی فقط پس از انجام کار نامه برای فرستنده اصلی امکان‌پذیر است', 'warning')
            return
        }

        if (!isUserTheCreator(letter)) {
            showToastMessage('فقط فرستنده اصلی نامه می‌تواند آن را ببندد', 'error')
            return
        }

        const docId = letter.Doc_Auto || letter.IDDocItem
        if (!docId) {
            showToastMessage('شناسه نامه یافت نشد', 'error')
            return
        }

        if (isLetterClosed(letter)) {
            showToastMessage('این نامه قبلاً بسته شده است', 'info')
            return
        }

        pendingCloseLetter.value = letter
        showCloseConfirmModal.value = true
        isClosingLetter.value = false
        }

        // Step 2 — user cancels
        const closeCloseConfirmModal = () => {
        if (isClosingLetter.value) return    // don't close mid-flight
        showCloseConfirmModal.value = false
        pendingCloseLetter.value = null
        }

        // Step 3 — user confirms → call API
        const confirmCloseLetter = async () => {
        const letter = pendingCloseLetter.value
        if (!letter) return

        if (!isCustomer.value || !isLetterDone(letter)) {
            closeCloseConfirmModal()
            showToastMessage('ابتدا باید کار نامه انجام شده باشد', 'warning')
            return
        }

        if (!isUserTheCreator(letter)) {
            closeCloseConfirmModal()
            showToastMessage('شما اجازه بستن این نامه را ندارید', 'error')
            return
        }

        const docId = letter.Doc_Auto || letter.IDDocItem
        if (!docId) {
            showToastMessage('شناسه نامه یافت نشد', 'error')
            closeCloseConfirmModal()
            return
        }

        isClosingLetter.value = true

        try {
            const response = await officeService.closeOrRateDoc({
            IDDoc: docId,
            CloseOrRate: 'C',
            val: 1,
            RateTxt: '',
            })

            if (response.data.success) {
            // Mark locally so it moves to the "بایگانی" tab right away
            letter.closeDoc = 1

            // If the selected letter was this one and we're on the "open" tab,
            // deselect it so the chat area doesn't show a hidden letter
            if (
                activeLetterTab.value === 'open' &&
                selectedLetter.value?.IDDocItem === letter.IDDocItem
            ) {
                selectedLetterIndex.value = null
                showChat.value = false
            }

            showToastMessage('نامه بسته شد', 'success')

            // Close confirm modal
            showCloseConfirmModal.value = false
            pendingCloseLetter.value = null
            isClosingLetter.value = false

            // Open rating modal
            openRatingModal(letter)
            } else {
            isClosingLetter.value = false

            if (
                response.data.error_details === 'USER_NOT_REGISTERED' ||
                (response.data.message && response.data.message.includes('not registered'))
            ) {
                closeCloseConfirmModal()
                openRegistrationModal()
                showToastMessage('لطفاً ابتدا ثبت نام کنید', 'warning', '⚠️')
                return
            }

            showToastMessage(
                response.data.error_details || response.data.message || 'خطا در بستن نامه',
                'error'
            )
            }
        } catch (error) {
            isClosingLetter.value = false
            console.error('Error closing letter:', error)

            let errorMessage = 'خطا در ارتباط با سرور'
            if (error.response?.data?.detail) {
            errorMessage = error.response.data.detail
            if (errorMessage.includes('not registered')) {
                closeCloseConfirmModal()
                openRegistrationModal()
                showToastMessage('لطفاً ابتدا ثبت نام کنید', 'warning', '⚠️')
                return
            }
            }
            showToastMessage(errorMessage, 'error', '❌')
        }
        }

        // --- Rating modal (unchanged) ---
        const openRatingModal = (letter) => {
        ratingLetterRef.value = letter
        ratingDocId.value = letter.Doc_Auto || letter.IDDocItem
        ratingValue.value = 0
        ratingFeedback.value = ''
        ratingSubmitAttempted.value = false
        ratingSubmitting.value = false
        showRatingModal.value = true
        }

        const closeRatingModal = () => {
        showRatingModal.value = false
        ratingValue.value = 0
        ratingFeedback.value = ''
        ratingSubmitAttempted.value = false
        ratingSubmitting.value = false
        ratingDocId.value = null
        ratingLetterRef.value = null
        }

        const selectRating = (value) => {
        ratingValue.value = value
        if (value > 3) {
            ratingFeedback.value = ''
        }
        }

        const submitRating = async () => {
        ratingSubmitAttempted.value = true
        if (!canSubmitRating.value) return
        if (!ratingDocId.value) {
            showToastMessage('شناسه نامه یافت نشد', 'error')
            return
        }

        ratingSubmitting.value = true

        try {
            const response = await officeService.closeOrRateDoc({
            IDDoc: ratingDocId.value,
            CloseOrRate: 'R',
            val: ratingValue.value,
            RateTxt: needsRatingFeedback.value ? ratingFeedback.value.trim() : '',
            })

            if (response.data.success) {
            if (ratingLetterRef.value) {
                ratingLetterRef.value.rating = ratingValue.value
                ratingLetterRef.value.ratingFeedback = ratingFeedback.value.trim() || null
            }

            showToastMessage('امتیاز شما ثبت شد. متشکریم!', 'success')

            // TODO: send feedback text to backend here when you have an endpoint
            // if (needsRatingFeedback.value && ratingFeedback.value.trim()) {
            //   await officeService.saveRatingFeedback({
            //     IDDoc: ratingDocId.value,
            //     val: ratingValue.value,
            //     feedback: ratingFeedback.value.trim(),
            //   })
            // }

            closeRatingModal()
            } else {
            showToastMessage(
                response.data.error_details || response.data.message || 'خطا در ثبت امتیاز',
                'error'
            )
            }
        } catch (error) {
            console.error('Error submitting rating:', error)
            showToastMessage(
            error.response?.data?.detail || 'خطا در ارتباط با سرور',
            'error',
            '❌'
            )
        } finally {
            ratingSubmitting.value = false
        }
        }

        // Truncate plain text for previews (no extension logic)
        const truncateText = (text, maxLength = 60) => {
            if (!text) return ''
            // Collapse whitespace/newlines into single spaces so the preview stays on one line
            const clean = String(text).replace(/\s+/g, ' ').trim()
            if (clean.length <= maxLength) return clean
            return clean.slice(0, maxLength).trimEnd() + '…'
        }

        // ============ ACT DOCS (AC/ACT) ============
        const actDocItems   = ref([])      // flat list from API
        const actDocsLoading = ref(false)
        const actDocsError   = ref(null)

        // ---- Sidebar filter state ----
        const filterAc  = ref(null)   // number | null
        const filterAct = ref(null)   // number | null
        const showLettersFilter = ref(false)

        const filterActOptions = computed(() => {
        if (!filterAc.value) return []
        const group = visibleActDocsGroupsFilter.value.find(g => Number(g.Ac) === Number(filterAc.value))
        return group ? group.items : []
        })

        const onFilterAcChange = () => {
        // reset the ACT filter when AC changes
        filterAct.value = null
        }

        const clearLetterFilters = () => {
        filterAc.value = null
        filterAct.value = null
        }

        // ---- New Letter modal state ----
        const newLetterAc  = ref(null)
        const newLetterAct = ref(null)

        const newLetterActOptions = computed(() => {
        if (!newLetterAc.value) return []
        const group = visibleActDocsGroupsNewMsg.value.find(g => Number(g.Ac) === Number(newLetterAc.value))
        return group ? group.items : []
        })

        const onNewLetterAcChange = () => {
        // reset ACT when AC changes
        newLetterAct.value = null
        selectedCustomer.value = null
        customerSearchResults.value = []
        if (customerSearchQuery.value.trim()) {
            searchCustomers()
        }
        }

        // ---- Load once ----
        const loadActDocs = async () => {
            actDocsLoading.value = true
            actDocsError.value = null

            try {
                const response = await officeService.listActDocs()

                if (response.data.success) {
                actDocItems.value = response.data.items || []
                } else {
                if (
                    response.data.error_details === 'USER_NOT_REGISTERED' ||
                    (response.data.message && response.data.message.includes('not registered'))
                ) {
                    actDocsError.value = 'لطفاً ابتدا ثبت نام کنید'
                } else {
                    actDocsError.value =
                    response.data.error_details || response.data.message || 'خطا در دریافت انواع نامه'
                }
                actDocItems.value = []
                }
            } catch (error) {
                console.error('Error loading act docs:', error)
                actDocsError.value =
                error.response?.data?.detail || 'خطا در ارتباط با سرور'
                actDocItems.value = []
            } finally {
                actDocsLoading.value = false
            }
        }

        let filterDebounceTimer = null
        const isFilterRefetching = ref(false)

        watch(
            () => [filterAc.value, filterAct.value],
            () => {
                clearTimeout(filterDebounceTimer)
                filterDebounceTimer = setTimeout(async () => {
                    isFilterRefetching.value = true
                    try {
                        await fetchDocumentsSmart(true)
                    } finally {
                        isFilterRefetching.value = false
                    }
                }, 300)
            }
        )

        const isUserTheCreator = (letter) => {
            if (!letter) return false

            // ✅ Admins can close any letter
            if (isAdmin.value) return true

            const userId = authStore.user?.subCodeId
            if (!userId) return false

            // 1) If the letter's activities are already loaded, check the first activity's FirstId
            const activities = letter.activities || letter.docData?.activities || []
            if (Array.isArray(activities) && activities.length > 0) {
                const firstAct = activities[0]
                const firstId = firstAct?.FirstId ?? firstAct?.firstId
                if (firstId !== undefined && firstId !== null) {
                return String(firstId) === String(userId)
                }
            }

            // 2) Fallback: use SenderId / Sender from the doc
            const senderId =
                letter.FirstId ??
                letter.firstId ??
                letter.SenderId ??
                letter.senderId

            if (senderId !== undefined && senderId !== null) {
                return String(senderId) === String(userId)
            }

            return false
        }

const getReferenceIdForMessage = (msg) => {
    if (!msg) return 0

    if (msg.isFirstMessage === true) return 0

    // Defensive: if the message we're pointing at happens to be the same
    // as the first activity of the document, treat it as root too.
    const activities = selectedLetter.value?.activities || []
    if (activities.length > 0) {
        const firstAct = activities[0]
        const firstAuto = firstAct?.DocActAuto ?? null
        const msgAuto = msg?.docActAuto ?? msg?.activityData?.DocActAuto ?? null
        if (firstAuto !== null && msgAuto !== null && String(firstAuto) === String(msgAuto)) {
            return 0
        }
    }

    return msg.docActAuto ?? msg.activityData?.DocActAuto ?? 0
}

const doesActReferenceFirstMessage = (act) => {
    if (!act) return false
    if (Number(act.TypAct) !== 2) return false

    const docId = selectedLetter.value?.IDDocItem
    if (docId === undefined || docId === null) return false

    // The SP stores AtfAct as the doc id when it refers to the first message
    return String(act.AtfAct) === String(docId)
}

// ============ SEEN HELPERS ============
// Seen strings look like ",55895,55902," — sometimes empty string, sometimes null.
const parseSeenSubcodes = (seenStr) => {
    if (!seenStr) return []
    if (Array.isArray(seenStr)) return seenStr.map(s => String(s).trim()).filter(Boolean)
    return String(seenStr)
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
}

// Has this subcode already seen the seen field?
const hasSeen = (seenStr, subcode) => {
    if (subcode === undefined || subcode === null) return false
    const list = parseSeenSubcodes(seenStr)
    return list.some(s => String(s) === String(subcode))
}

// A letter is unseen by the current user if they aren't in Seen
const isLetterUnseen = (letter) => {
    const me = authStore.user?.subCodeId
    if (!me || !letter) return false
    return !hasSeen(letter.Seen, me)
}

// Is the last activity unseen by the current user?
// `SeenA` on the doc tracks the last activity's seen state.
const isLastActUnseen = (letter) => {
    const me = authStore.user?.subCodeId
    if (!me || !letter) return false
    return !hasSeen(letter.SeenA, me)
}

const seenByTitles = computed(() => {
    const msg = selectedMessageForActions.value
    if (!msg) return []
    const key = msg.docActAuto || msg.activityData?.DocActAuto
    return seenByCache.value[key] || []
})

const seenDispatched = ref(new Set())
const markSeenForLetter = (targetLetter, options = {}) => {
    const {
        includeActivities = true,
        onlyLastActivity = false,
    } = options

    const mySubcode = authStore.user?.subCodeId
    if (!mySubcode || !targetLetter?.IDDocItem) return

    // ---------- 1. Mark the DOCUMENT (typ=1) ----------
    const docKey = `1:${targetLetter.IDDocItem}`
    const seenList = parseSeenSubcodes(targetLetter.Seen)
    const docAlreadySeen = seenList.some(s => String(s) === String(mySubcode))
    const docAlreadyDispatched = seenDispatched.value.has(docKey)

    if (!docAlreadySeen && !docAlreadyDispatched) {
        // Snapshot BEFORE the optimistic update
        const previousSeen = targetLetter.Seen || ''
        seenDispatched.value.add(docKey)

        officeService.saveSeenDoc({
            Sub: mySubcode,
            typ: 1,
            id_Doc: targetLetter.IDDocItem,
            PreviousSeen: previousSeen,
        }).catch(err => {
            seenDispatched.value.delete(docKey)
            console.warn('saveSeenDoc(document) failed:', err)
        })
    }

    // Optimistic local update (always, idempotent)
    if (!docAlreadySeen) {
        seenList.push(String(mySubcode))
        targetLetter.Seen = ',' + seenList.join(',') + ','
    }

    // ---------- 2. Mark the ACTIVITIES (typ=2) ----------
    if (!includeActivities) return

    const acts = Array.isArray(targetLetter.activities) ? targetLetter.activities : []
    const toMark = onlyLastActivity && acts.length > 0
        ? [acts[acts.length - 1]]
        : acts

    for (const act of toMark) {
        if (!act?.DocActAuto) continue

        const actKey = `2:${act.DocActAuto}`
        const actSeenList = parseSeenSubcodes(act.SeenA)
        const actAlreadySeen = actSeenList.some(s => String(s) === String(mySubcode))
        const actAlreadyDispatched = seenDispatched.value.has(actKey)

        if (!actAlreadySeen && !actAlreadyDispatched) {
            const previousSeen = act.SeenA || ''
            seenDispatched.value.add(actKey)

            officeService.saveSeenDoc({
                Sub: mySubcode,
                typ: 2,
                id_Doc: act.DocActAuto,
                PreviousSeen: previousSeen,
            }).catch(err => {
                seenDispatched.value.delete(actKey)
                console.warn(`saveSeenDoc(activity ${act.DocActAuto}) failed:`, err)
            })
        }

        // Optimistic local update (always, idempotent)
        if (!actAlreadySeen) {
            actSeenList.push(String(mySubcode))
            act.SeenA = ',' + actSeenList.join(',') + ','
        }
    }

    // ---------- 3. Mirror last activity's SeenA onto the letter ----------
    if (acts.length > 0) {
        const lastAct = acts[acts.length - 1]
        if (lastAct?.SeenA) {
            targetLetter.SeenA = lastAct.SeenA
        }
    }
}

        onMounted(async () => {
            await loadActDocs()
            applyRoleFilterDefaults()
            await fetchDocuments()
            window.addEventListener('resize', handleResize)
            letter.date = new Date().toLocaleDateString('fa-IR')
            checkTutorial()
            startPolling()
            checkPushNotificationSubscription()

            let roles = authStore.getAvailableRoles
            console.log('roles ' + roles)    
        })

        // Cleanup on unmount
        onUnmounted(() => {
            if (recordingTimer.value) {
                clearInterval(recordingTimer.value)
            }
            if (mediaRecorder.value && isRecording.value) {
                mediaRecorder.value.stop()
            }
            if (searchTimeout.value) {
                clearTimeout(searchTimeout.value)
            }
            if (referenceSearchTimeout.value) {
                clearTimeout(referenceSearchTimeout.value)
            }
            if (privateRecipientSearchTimer.value) {
                clearTimeout(privateRecipientSearchTimer.value)
            }
            if (pendingFile.value?.data) {
                URL.revokeObjectURL(pendingFile.value.data)
            }
            if (pendingReferenceFile.value?.data) {
                URL.revokeObjectURL(pendingReferenceFile.value.data)
            }
            if (tooltipTimeout.value) {
                clearTimeout(tooltipTimeout.value)
            }
            if (pushPromptTimer.value) {
                clearTimeout(pushPromptTimer.value)
            }

            if (filterDebounceTimer) clearTimeout(filterDebounceTimer)
            stopPolling()
        })

        return {
            letter,
            letters,
            selectedLetter,
            selectedLetterIndex,
            newMessage,
            pendingFile,
            pendingReferenceFile,
            searchQuery,
            showChat,
            fileInput,
            newChatFileInput,
            referenceFileInput,
            messageInput,
            messagesContainer,
            previewImageUrl,
            isMobile,
            isLoading,
            showToast,
            toastMessage,
            toastType,
            toastIconClass,
            showPushPrompt,
            pushPromptBusy,
            pushPromptError,
            dismissPushPrompt,
            enablePushNotifications,
            filteredLetters,
            showNewChatModal,
            showParticipantsModal,
            letterParticipants,
            selectableLetterParticipants,
            participantSummary,
            participantDisplayName,
            phoneNumbers,
            showUnclosedLettersWarning,
            unclosedLettersCount,
            cancelUnclosedLettersWarning,
            continueCreateNewChat,
            customerSearchQuery,
            customerSearchResults,
            selectedCustomer,
            newLetterMessage,
            letterSummary,
            newChatFile,
            showReferenceModal,
            referenceSearchQuery,
            referenceSearchResults,
            selectedReferenceCustomer,
            referenceParticipantId,
            referenceIsPrivate,
            referenceText,
            showRegistrationModal,
            registrationLoading,
            registrationData,
            firstMessageText,
            firstMessageFile,
            showMessageActions,
            selectedMessageForActions,
            openMessageActions,
            closeMessageActions,
            handleMessageReply,
            isPrivateReplying,
            handlePrivateMessageReply,
            showPrivateRecipientModal,
            selectedPrivateRecipient,
            privateRecipientParticipantId,
            privateRecipientSearchQuery,
            privateRecipientSearchResults,
            selectPrivateLetterParticipant,
            selectPrivateSearchRecipient,
            searchPrivateRecipients,
            cancelPrivateRecipientSelection,
            continuePrivateReply,
            handleMessageForward,
            handleMessageCopy,
            handleMessagePendingActions,
            handleMessageDownload,
            handleMessageDelete,
            showTutorial,
            currentStep,
            tutorialSteps,
            closeTutorial,
            nextTutorialStep,
            showTooltip,
            tooltipText,
            tooltipStyle,
            closeTooltip,

            goBack,
            selectLetter,
            sendMessage,
            attachImage,
            handleFileUpload,
            previewImage,
            viewLetterDetails,
            deleteLetter,
            toggleSidebar,
            formatTime,
            showToastMessage,
            openNewChatModal,
            closeNewChatModal,
            searchCustomers,
            selectCustomer,
            createNewChat,
            fetchDocuments,
            getCustomerInitial,
            getCustomerDisplayName,
            removeSelectedCustomer,
            truncateFileName,
            onSearchInput,
            onClearCustomerSearch,
            getTypLabel,
            isRecording,
            isRecordingVoice,
            recordingTime,
            voiceRecordingTime,
            toggleRecording,
            startVoiceRecording,
            handleNewChatFile,
            getFileTypeInfo,
            openReferenceModal,
            openReferenceModalForMessage,
            closeReferenceModal,
            onReferenceSearchInput,
            searchReferenceCustomers,
            selectReferenceCustomer,
            selectReferenceParticipant,
            submitReference,
            loadingSubmitReference,
            handleReferenceFileUpload,
            openRegistrationModal,
            closeRegistrationModal,
            submitRegistration,
            getProxiedImage,
            getMessageKey,

            isImageUrl,
            isAudioUrl,
            isVideoUrl,
            isPdfUrl,
            getAudioMimeType,
            handleImageError,
            scrollToOriginalForwardedMessage,
            scrollToMessage,

            isReplying,
            replyToMessage,
            cancelReply,
            isDocumentPolling,
            isActivityPolling,
            filteredMessages,
            isLoadingDocs,
            isFilterRefetching,
            isLoadingActivities,
            loadingMessage,
            loadingProgress,
            isFirstLoad,

            letterTabs,
            visibleLetterTabs,
            activeLetterTab,
            getLetterTabCount,
            isLetterClosed,
            isLetterDone,

            // Close + rating flow
            markLetterDone,
            completingLetterId,
            closeLetter,
            showRatingModal,
            ratingValue,
            ratingFeedback,
            ratingSubmitAttempted,
            ratingSubmitting,
            ratingOptions,
            needsRatingFeedback,
            canSubmitRating,
            openRatingModal,
            closeRatingModal,
            selectRating,
            submitRating,
            showCloseConfirmModal,
            pendingCloseLetter,
            isClosingLetter,
            closeCloseConfirmModal,
            confirmCloseLetter,
            isUserTheCreator,
            truncateText,

            // Act docs + filter
            actDocItems,
            actDocsGroups,
            actDocsLoading,
            actDocsError,
            loadActDocs,

            // Sidebar filter
            filterAc,
            filterAct,
            showLettersFilter,
            filterActOptions,
            onFilterAcChange,
            clearLetterFilters,

            // New-letter dropdowns
            newLetterAc,
            newLetterAct,
            newLetterActOptions,
            onNewLetterAcChange,

            // Roles
            userRoles,
            isAdmin,
            isEmployer,
            isOffice,
            isStore,
            isCustomer,
            isEmployee,
            isCustomerOnly,

            // Role-filtered groups
            visibleActDocsGroupsFilter,
            visibleActDocsGroupsNewMsg,

            registrationErrors,
            onNationalCodeInput,
            toEnglishDigits,

            // Seen helpers
            parseSeenSubcodes,
            hasSeen,
            isLetterUnseen,
            isLastActUnseen,

            // Seen-by UI
            seenByCache,
            seenByLoading,
            seenByError,
            seenByTitles,
            loadSeenByForMessage,
            clearSeenBy,

            onPrivateRecipientSearchInput,

            togglePersonDocumentsView,
            handleChatScroll,
            isPersonDocsLoading,
            showScrollBottomBtn,
            scrollToBottomSmooth,
            unreadScrollCount
        }
    }
}
</script>

<style scoped>
.chat-app {
    max-width: 1400px;
    margin: 0 auto;
    padding: 16px;
    min-height: 100vh;
    background: var(--bg);
    font-family: 'Vazir', 'Tahoma', sans-serif;
    direction: rtl;
    margin-bottom: 45px;
}

/* Navbar */
.app-navbar {
    background: var(--card-bg);
    border-radius: var(--radius);
    box-shadow: var(--shadow-1);
    padding: 12px 24px;
    margin-bottom: 16px;
    border: 1px solid var(--card-border);
}

.navbar-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.nav-left {
    display: flex;
    align-items: center;
    gap: 14px;
}

.nav-btn {
    width: 40px;
    height: 40px;
    border: none;
    border-radius: 50%;
    background: var(--bg);
    color: var(--subtext);
    font-size: 16px;
    cursor: pointer;
    transition: var(--transition);
    display: flex;
    align-items: center;
    justify-content: center;
}

.nav-btn:hover {
    background: var(--primary);
    color: white;
    transform: scale(0.95);
}

.primary-btn {
    background: linear-gradient(135deg, var(--gradient-1), var(--gradient-2));
    color: white;
    box-shadow: 0 4px 12px rgba(108, 92, 231, 0.3);
}

.primary-btn:hover {
    transform: scale(1.05) !important;
    box-shadow: 0 6px 20px rgba(108, 92, 231, 0.4);
}

.app-brand {
    color: var(--text);
    font-size: 18px;
    font-weight: 700;
}

.nav-right {
    display: flex;
    align-items: center;
    gap: 12px;
}

.letter-count-badge {
    background: var(--ring);
    color: var(--primary);
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
}

/* Container */
.chat-container {
    background: var(--card-bg);
    border-radius: var(--radius);
    box-shadow: var(--shadow-1);
    overflow: hidden;
    height: calc(100vh - 140px);
    min-height: 500px;
    border: 1px solid var(--card-border);
}

.chat-layout {
    display: flex;
    height: 100%;
}

/* Sidebar */
.chat-sidebar {
    width: 340px;
    min-width: 340px;
    border-left: 1px solid var(--card-border);
    display: flex;
    flex-direction: column;
    background: var(--card-bg);
}

.sidebar-search {
    padding: 12px 16px;
    border-bottom: 1px solid var(--card-border);
}

.sidebar-search-row {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
}

.sidebar-search-row .search-wrapper {
    flex: 1 1 auto;
    min-width: 0;
}

.letters-filter-toggle {
    position: relative;
    flex: 0 0 40px;
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--card-border);
    border-radius: var(--radius-sm);
    background: var(--bg);
    color: var(--subtext);
    cursor: pointer;
    transition: var(--transition);
}

.letters-filter-toggle:hover,
.letters-filter-toggle.active {
    border-color: var(--primary);
    color: var(--primary);
    background: color-mix(in srgb, var(--primary) 10%, var(--bg));
}

.letters-filter-toggle:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px var(--ring);
}

.filter-active-dot {
    position: absolute;
    top: 7px;
    right: 7px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--primary);
    box-shadow: 0 0 0 2px var(--bg);
}
.search-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.search-wrapper .search-icon {
    position: absolute;
    right: 12px;
    color: var(--subtext);
    font-size: 14px;
}

.search-input {
    width: 100%;
    padding: 10px 38px 10px 12px;
    border: 1px solid var(--card-border);
    border-radius: var(--radius-sm);
    font-size: 14px;
    background: var(--bg);
    color: var(--text);
    transition: var(--transition);
}

.search-input::placeholder {
    color: var(--subtext);
}

.search-input:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px var(--ring);
}

.clear-search {
    position: absolute;
    left: 12px;
    background: none;
    border: none;
    color: var(--subtext);
    cursor: pointer;
    padding: 4px;
}

/* Letter List */
.letter-list {
    flex: 1;
    overflow-y: auto;
    padding: 4px 0;
}

.letter-item {
    display: flex;
    padding: 12px 16px;
    cursor: pointer;
    transition: var(--transition);
    border-bottom: 1px solid var(--card-border);
    align-items: center;
    gap: 10px;
    position: relative;
}

.letter-item:hover {
    background: var(--bg);
}

.letter-item.active {
    background: var(--ring);
    border-right: 3px solid var(--primary);
}

.letter-avatar {
    position: relative;
    width: 44px;
    height: 44px;
    min-width: 44px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--gradient-1), var(--gradient-2));
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: white;
}

.unread-dot {
    position: absolute;
    top: -4px;
    right: -4px;
    background: #EF4444;
    color: white;
    font-size: 10px;
    font-weight: 700;
    padding: 1px 6px;
    border-radius: 10px;
    min-width: 18px;
    text-align: center;
}

.letter-info {
    flex: 1;
    min-width: 0;
}

.letter-sender {
    font-size: 13px;
    font-weight: 600;
    color: var(--text);
    display: flex;
    align-items: center;
    gap: 4px;
}

.letter-sender .from {
    color: var(--subtext);
    font-weight: 500;
}

.letter-sender .to {
    color: var(--primary);
    font-weight: 600;
}

.arrow-icon {
    color: var(--subtext);
    font-size: 11px;
}

.letter-preview {
    font-size: 13px;
    color: var(--subtext);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 2px;
}

.letter-meta {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    min-width: 50px;
}

.letter-date {
    font-size: 11px;
    color: var(--subtext);
}

.status-sent { color: var(--green); }
.status-delivered { color: var(--primary); }
.status-pending { color: var(--orange-1); }

/* Empty State */
.empty-state {
    text-align: center;
    padding: 60px 20px;
    color: var(--subtext);
}

.empty-icon {
    font-size: 48px;
    margin-bottom: 12px;
    color: var(--subtext);
}

.empty-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--text);
}

.empty-sub {
    font-size: 13px;
    opacity: 0.7;
}

/* Chat Area */
.chat-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: var(--card-bg);
    position: relative;
}

.chat-header {
    padding: 12px 20px;
    border-bottom: 1px solid var(--card-border);
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: var(--card-bg);
    min-height: 64px;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    flex: 1;
}

.chat-avatar {
    width: 40px;
    height: 40px;
    min-width: 40px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--gradient-1), var(--gradient-2));
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
}

.chat-contact-info {
    flex: 1;
    min-width: 0;
}

.contact-name {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: var(--heading);
}

.contact-name-button {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    max-width: min(100%, 360px);
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--heading);
    text-align: right;
    cursor: pointer;
}

.contact-name-button .contact-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.contact-name-button > i {
    flex: 0 0 auto;
    color: var(--subtext);
    font-size: 10px;
}

.participants-overlay {
    position: fixed;
    inset: 0;
    z-index: 1200;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 18px;
    background: var(--modal-overlay, rgba(15, 23, 42, 0.55));
}

.participants-modal {
    width: min(100%, 440px);
    max-height: min(80vh, 620px);
    overflow: hidden;
    border: 1px solid var(--border, #e5e7eb);
    border-radius: 16px;
    background: var(--card, #fff);
    box-shadow: 0 18px 55px rgba(15, 23, 42, 0.24);
}

.participants-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 18px 20px;
    border-bottom: 1px solid var(--border, #e5e7eb);
}

.participants-header h3 {
    margin: 0;
    color: var(--heading);
    font-size: 16px;
}

.participants-header p {
    margin: 5px 0 0;
    color: var(--subtext);
    font-size: 12px;
}

.participants-close {
    width: 34px;
    height: 34px;
    flex: 0 0 auto;
    border: 0;
    border-radius: 50%;
    background: var(--bg, #f3f4f6);
    color: var(--subtext);
    cursor: pointer;
}

.participants-list {
    max-height: calc(min(80vh, 620px) - 80px);
    overflow-y: auto;
    padding: 10px 16px 16px;
}

.participant-card {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 13px 4px;
    border-bottom: 1px solid var(--border, #e5e7eb);
}

.participant-avatar {
    display: grid;
    width: 38px;
    height: 38px;
    flex: 0 0 auto;
    place-items: center;
    border-radius: 50%;
    background: color-mix(in srgb, var(--gradient-1, #4f46e5) 12%, transparent);
    color: var(--gradient-1, #4f46e5);
}

.participant-details {
    display: grid;
    min-width: 0;
    gap: 8px;
}

.participant-details > strong {
    color: var(--heading);
    font-size: 14px;
}

.participant-phones {
    display: flex;
    flex-wrap: wrap;
    gap: 7px;
}

.participant-phone {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 6px 9px;
    border-radius: 9px;
    background: var(--bg, #f3f4f6);
    color: var(--text, #374151);
    font-size: 12px;
    text-decoration: none;
}

.participant-phone i {
    color: var(--green, #16a34a);
}

.participant-no-phone,
.participants-empty {
    color: var(--subtext);
    font-size: 12px;
}

.participants-empty {
    margin: 18px 4px 8px;
    text-align: center;
}

.reference-participant-select {
    margin-top: 10px;
}

.private-reference-option {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: var(--text, #374151);
    font-size: 13px;
    cursor: pointer;
    user-select: none;
    line-height: 1.2;
}

.private-reference-option input {
    accent-color: var(--gradient-1, #4f46e5);
    width: 16px;
    height: 16px;
    margin-top: 5px;
    margin: 0;
    flex-shrink: 0;
}

.private-recipient-modal {
    max-width: 540px;
}

.private-recipient-help,
.private-recipient-selected {
    color: var(--subtext);
    font-size: 13px;
    line-height: 1.7;
}

.private-recipient-selected {
    margin: 4px 0 0;
}

.contact-status {
    font-size: 12px;
    color: var(--subtext);
    display: flex;
    align-items: center;
    gap: 6px;
}

.status-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    display: inline-block;
}

.status-dot.online { background: var(--green); }
.status-dot.offline { background: var(--orange-1); }

.header-actions {
    display: flex;
    gap: 6px;
}

.action-btn {
    width: 36px;
    height: 36px;
    border: none;
    border-radius: 50%;
    background: var(--bg);
    color: var(--subtext);
    cursor: pointer;
    transition: var(--transition);
    display: flex;
    align-items: center;
    justify-content: center;
}

.action-btn:hover {
    background: var(--ring);
    color: var(--primary);
}

.action-btn.danger:hover {
    background: #FEE2E2;
    color: #EF4444;
}

/* Messages */
.chat-messages {
    flex: 1;
    overflow-y: auto;
    padding: 16px 20px;
    background: var(--bg);
    display: flex;
    flex-direction: column;
}

.message-wrapper {
    display: flex;
    margin-bottom: 8px;
    animation: fadeInUp 0.3s ease-out;
}

.message-wrapper.sent {
    justify-content: flex-end;
}

.message-wrapper.received {
    justify-content: flex-start;
}

.message-bubble {
    max-width: 70%;
    padding: 8px 14px;
    border-radius: 14px;
    position: relative;
    word-wrap: break-word;
}

.sent .message-bubble {
    background: linear-gradient(135deg, var(--gradient-1), var(--gradient-2));
    color: white;
    border-bottom-left-radius: 4px;
}

.received .message-bubble {
    background: var(--card-bg);
    color: var(--text);
    border-bottom-right-radius: 4px;
    border: 1px solid var(--card-border);
}

.message-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.message-image {
    max-width: 200px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    position: relative;
}

.message-image img {
    width: 100%;
    height: auto;
    display: block;
}

.image-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0,0,0,0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: var(--transition);
    color: white;
}

.message-image:hover .image-overlay {
    opacity: 1;
}

.message-text {
    font-size: 14px;
    line-height: 1.5;
    color: white;
}

.message-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 6px;
    margin-top: 4px;
    font-size: 11px;
}

.sent .message-footer {
    color: rgba(255,255,255,0.7);
}

.received .message-footer {
    color: var(--subtext);
}

@keyframes fadeInUp {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

/* Empty Chat */
.empty-chat {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: var(--subtext);
}

.empty-chat .empty-icon {
    font-size: 56px;
    margin-bottom: 12px;
    color: var(--subtext);
}

.empty-chat p {
    margin: 4px 0;
    font-size: 16px;
    color: var(--text);
}

.empty-hint {
    font-size: 13px;
    opacity: 0.7;
}

/* Chat Input */
.chat-input-area {
    padding: 12px 16px;
    border-top: 1px solid var(--card-border);
    display: flex;
    gap: 10px;
    align-items: flex-end;
    background: var(--card-bg);
}

.input-actions {
    display: flex;
    gap: 4px;
    align-items: center;
}

.tool-btn {
    width: 36px;
    height: 36px;
    border: none;
    border-radius: 50%;
    background: var(--bg);
    color: var(--subtext);
    cursor: pointer;
    transition: var(--transition);
    display: flex;
    align-items: center;
    justify-content: center;
}

.tool-btn:hover {
    background: var(--ring);
    color: var(--primary);
}

.input-wrapper {
    flex: 1;
    position: relative;
}

.message-input {
    width: 100%;
    border: 1px solid var(--card-border);
    border-radius: 24px;
    font-size: 14px;
    font-family: inherit;
    background: var(--bg);
    color: var(--text);
    resize: none;
    transition: var(--transition);
    line-height: 1.5;
    max-height: 100px;
}

.message-input::placeholder {
    color: var(--subtext);
}

.message-input:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px var(--ring);
}

.pending-image {
    position: absolute;
    bottom: calc(100% + 4px);
    right: 0;
    background: var(--card-bg);
    border-radius: 8px;
    padding: 4px;
    box-shadow: 0 4px 12px var(--shadow-1);
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1px solid var(--card-border);
}

.pending-image img {
    max-height: 40px;
    border-radius: 4px;
}

.remove-pending {
    background: none;
    border: none;
    color: #EF4444;
    cursor: pointer;
    padding: 4px;
}

.send-btn {
    width: 44px;
    height: 44px;
    min-width: 44px;
    border: none;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--gradient-1), var(--gradient-2));
    color: white;
    cursor: pointer;
    transition: var(--transition);
    display: flex;
    align-items: center;
    justify-content: center;
}

.send-btn:hover:not(:disabled) {
    transform: scale(1.05);
    box-shadow: 0 4px 16px rgba(108, 92, 231, 0.3);
}

.send-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.mobile-back {
    position: absolute;
    top: 12px;
    right: 12px;
    background: var(--card-bg);
    border: 1px solid var(--card-border);
    border-radius: 50%;
    width: 36px;
    height: 36px;
    cursor: pointer;
    display: none;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px var(--shadow-1);
    z-index: 10;
}

/* Push notification invitation */
.push-prompt-overlay {
    position: fixed;
    inset: 0;
    z-index: 10002;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: rgba(0, 0, 0, 0.55);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    animation: fadeIn 0.25s ease;
}

.push-prompt-modal {
    width: 100%;
    max-width: 430px;
    padding: 28px 24px 22px;
    border: 1px solid var(--card-border);
    border-radius: 20px;
    background: var(--card-bg);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
    text-align: center;
    animation: slideUp 0.25s ease;
}

.push-prompt-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    margin-bottom: 14px;
    border-radius: 50%;
    background: rgba(108, 92, 231, 0.12);
    color: var(--primary, #6c5ce7);
    font-size: 27px;
    box-shadow: 0 0 0 8px rgba(108, 92, 231, 0.05);
}

.push-prompt-title {
    margin: 0 0 10px;
    color: var(--heading, var(--text));
    font-size: 1.15rem;
    font-weight: 700;
}

.push-prompt-text,
.push-prompt-hint {
    margin: 0 auto 12px;
    color: var(--text);
    font-size: 0.92rem;
    line-height: 1.8;
}

.push-prompt-hint {
    padding: 10px 12px;
    border-radius: 10px;
    background: rgba(108, 92, 231, 0.08);
    color: var(--subtext);
    font-size: 0.8rem;
}

.push-prompt-error {
    margin: 8px 0 14px;
    color: #ef4444;
    font-size: 0.8rem;
    line-height: 1.6;
}

.push-prompt-actions {
    display: flex;
    gap: 10px;
    margin-top: 18px;
}

.push-prompt-btn {
    flex: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    min-height: 44px;
    padding: 10px 14px;
    border-radius: 11px;
    font-family: inherit;
    font-size: 0.85rem;
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.15s ease, opacity 0.2s ease, background 0.2s ease;
}

.push-prompt-btn:hover:not(:disabled) {
    transform: translateY(-1px);
}

.push-prompt-btn:disabled {
    cursor: wait;
    opacity: 0.6;
}

.push-prompt-btn.secondary {
    border: 1px solid var(--card-border);
    background: transparent;
    color: var(--text);
}

.push-prompt-btn.primary {
    border: none;
    background: var(--primary, #6c5ce7);
    color: #fff;
}

@media (max-width: 480px) {
    .push-prompt-actions {
        flex-direction: column-reverse;
    }

    .push-prompt-btn {
        width: 100%;
    }
}

/* Modal */
.modal-overlay {
    position: fixed;
    inset: 0;
    background: var(--modal-overlay);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10001;
    padding: 20px;
    animation: fadeIn 0.3s ease;
}

.modal1 {
    background: var(--card-bg);
    border-radius: var(--radius);
    max-width: 520px;
    width: 100%;
    max-height: 105vh; 
    overflow: hidden;
    box-shadow: 0 20px 60px var(--shadow-2);
    animation: slideUp 0.3s ease;
    border: 1px solid var(--card-border);
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

@keyframes slideUp {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
}

.modal-header {
    padding: 16px 20px;
    background: linear-gradient(135deg, var(--gradient-1), var(--gradient-2));
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-title {
    margin: 0;
    font-size: 17px;
    font-weight: 700;
    color: white;
    display: flex;
    align-items: center;
    gap: 8px;
}

.modal-close1 {
    background: none;
    border: none;
    color: white;
    font-size: 20px;
    cursor: pointer;
    opacity: 0.7;
    transition: var(--transition);
}

.modal-close1:hover {
    opacity: 1;
}

.modal-body {
    padding: 20px;
    overflow-y: auto;
    max-height: calc(90vh - 120px);
}

.form-group {
    margin-bottom: 18px;
}

.form-label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: var(--subtext);
    margin-bottom: 6px;
}

.form-label.required::after {
    content: '*';
    color: #EF4444;
    margin-right: 4px;
}

.customer-search {
    position: relative;
    display: flex;
    align-items: center;
}

.search-indicator {
    position: absolute;
    right: 12px;
    color: var(--subtext);
}

.customer-input {
    width: 100%;
    padding: 10px 38px 10px 12px;
    border: 1px solid var(--card-border);
    border-radius: var(--radius-sm);
    font-size: 14px;
    background: var(--bg);
    color: var(--text);
    transition: var(--transition);
}

.customer-input::placeholder {
    color: var(--subtext);
}

.customer-input:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px var(--ring);
}

.clear-search-btn {
    position: absolute;
    left: 12px;
    background: none;
    border: none;
    color: var(--subtext);
    cursor: pointer;
}

.customer-results {
    max-height: 180px;
    overflow-y: auto;
    border: 1px solid var(--card-border);
    border-radius: var(--radius-sm);
    margin-top: 4px;
    background: var(--card-bg);
}

.customer-result {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    cursor: pointer;
    transition: var(--transition);
    border-bottom: 1px solid var(--card-border);
}

.customer-result:hover {
    background: var(--bg);
}

.customer-result.selected {
    background: var(--ring);
    border-right: 3px solid var(--primary);
}

.customer-avatar {
    width: 36px;
    height: 36px;
    min-width: 36px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--gradient-1), var(--gradient-2));
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
}

.customer-details {
    flex: 1;
    min-width: 0;
}

.customer-name {
    font-size: 14px;
    font-weight: 600;
    color: var(--text);
}

.customer-sub {
    font-size: 12px;
    color: var(--subtext);
}

.selected-check {
    color: var(--primary);
    font-size: 18px;
}

.selected-customer-tag {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background: var(--ring);
    border-radius: var(--radius-sm);
    margin-top: 8px;
    border: 1px solid var(--primary);
}

.tag-name {
    flex: 1;
    font-weight: 600;
    color: var(--text);
}

.tag-remove {
    background: none;
    border: none;
    color: #EF4444;
    cursor: pointer;
}

.form-textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid var(--card-border);
    border-radius: var(--radius-sm);
    font-size: 14px;
    font-family: inherit;
    background: var(--bg);
    color: var(--text);
    resize: vertical;
    transition: var(--transition);
    min-height: 80px;
}

.form-textarea::placeholder {
    color: var(--subtext);
}

.form-textarea:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px var(--ring);
}

.upload-zone {
    border: 2px dashed var(--card-border);
    border-radius: var(--radius-sm);
    padding: 20px;
    text-align: center;
    cursor: pointer;
    transition: var(--transition);
    min-height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.upload-zone:hover {
    border-color: var(--primary);
    background: var(--ring);
}

.upload-preview {
    position: relative;
    display: inline-block;
}

.upload-preview img {
    max-height: 100px;
    max-width: 100%;
    border-radius: 8px;
}

.remove-upload {
    position: absolute;
    top: -8px;
    right: -8px;
    background: #EF4444;
    color: white;
    border: none;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.upload-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    color: var(--subtext);
}

.upload-icon {
    font-size: 32px;
    color: var(--primary);
}

.upload-hint {
    font-size: 12px;
    opacity: 0.7;
}

.modal-footer {
    padding: 12px 20px;
    border-top: 1px solid var(--card-border);
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    background: var(--card-bg);
}

.btn {
    padding: 10px 24px;
    border: none;
    border-radius: var(--radius-sm);
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: var(--transition);
    display: flex;
    align-items: center;
    gap: 8px;
}

.btn-secondary {
    background: var(--bg);
    color: var(--subtext);
}

.btn-secondary:hover {
    background: var(--card-border);
}

.btn-primary {
    background: linear-gradient(135deg, var(--gradient-1), var(--gradient-2));
    color: white;
}

.btn-primary:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(108, 92, 231, 0.3);
}

.btn-primary:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Image Preview Modal */
.image-preview-modal {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    padding: 20px;
}

.preview-content {
    position: relative;
    max-width: 90%;
    max-height: 90%;
}

.preview-image {
    max-width: 100%;
    max-height: 90vh;
    border-radius: 8px;
}

.preview-close {
    position: absolute;
    top: -44px;
    right: 0;
    background: none;
    border: none;
    color: white;
    font-size: 28px;
    cursor: pointer;
}

/* Toast */
.toast {
    position: fixed;
    top: 24px;
    right: 50%;
    transform: translateX(50%);
    z-index: 9999;
    padding: 14px 24px;
    border-radius: var(--radius-sm);
    box-shadow: 0 4px 20px var(--shadow-2);
    min-width: 300px;
    max-width: 90%;
    animation: slideDown 0.3s ease-out;
}

.toast.success {
    background: var(--green);
    color: white;
}

.toast.error {
    background: var(--orange-1);
    color: white;
}

.toast.info {
    background: var(--primary);
    color: white;
}

.toast-content {
    display: flex;
    align-items: center;
    gap: 12px;
}

.toast-icon {
    font-size: 20px;
}

.toast-message {
    flex: 1;
    font-size: 14px;
}

.toast-close {
    background: none;
    border: none;
    color: rgba(255,255,255,0.7);
    cursor: pointer;
    padding: 4px;
}

@keyframes slideDown {
    from { opacity: 0; transform: translateX(50%) translateY(-20px); }
    to { opacity: 1; transform: translateX(50%) translateY(0); }
}

/* Responsive */
@media (max-width: 768px) {
    .chat-app {
        padding: 10px;
    }
    
    .chat-sidebar {
        width: 100%;
        min-width: 0;
        border-left: none;
    }

    .chat-sidebar.sidebar-hidden {
        display: none;
    }

    .chat-area {
        display: none;
    }

    .chat-area.chat-active {
        display: flex;
    }

    .mobile-back {
        display: flex !important;
    }

    .chat-container {
        height: calc(100vh - 110px);
        min-height: 400px;
    }

    .message-bubble {
        max-width: none;
    }

    .modal1 {
        max-width: 95%;
        margin: 10px;
    }

    .app-navbar {
        padding: 10px 16px;
    }
}

@media (max-width: 480px) {
    .letter-item {
        padding: 10px 12px;
    }

    .letter-avatar {
        width: 38px;
        height: 38px;
        min-width: 38px;
        font-size: 15px;
    }

    .chat-header {
        padding: 10px 14px;
    }

    .chat-input-area {
        padding: 8px 12px;
    }

    .message-input {
        font-size: 13px;
    }

    .send-btn {
        width: 38px;
        height: 38px;
        min-width: 38px;
    }

    .toast {
        min-width: auto;
        width: 90%;
        padding: 12px 16px;
    }
}

/* Messages Container */
.chat-messages {
    flex: 1;
    overflow-y: auto;
    padding: 16px 20px;
    background: var(--bg);
    display: flex;
    flex-direction: column;
}

/* Message Wrapper */
.message-wrapper {
    display: flex;
    margin-bottom: 8px;
    animation: fadeInUp 0.3s ease-out;
}

.message-wrapper.sent {
    justify-content: flex-end;
}

.message-wrapper.received {
    justify-content: flex-start;
}

/* Message Bubble */
.message-bubble {
    max-width: none;
    padding: 8px 14px;
    border-radius: 14px;
    position: relative;
    word-wrap: break-word;
}

.sent .message-bubble {
    background: linear-gradient(135deg, var(--gradient-1), var(--gradient-2));
    color: white;
    border-bottom-left-radius: 4px;
}

.received .message-bubble {
    background: var(--card-bg);
    color: var(--text);
    border-bottom-right-radius: 4px;
    border: 1px solid var(--card-border);
}

/* Message Content */
.message-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.message-text {
    font-size: 14px;
    line-height: 1.5;
}

/* Message Image */
.message-image {
    max-width: 200px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    position: relative;
}

.message-image img {
    width: 100%;
    height: auto;
    display: block;
}

.image-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0,0,0,0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: var(--transition);
    color: white;
}

.message-image:hover .image-overlay {
    opacity: 1;
}

/* Message Footer */
.message-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 6px;
    margin-top: 4px;
    font-size: 11px;
}

.sent .message-footer {
    color: rgba(255,255,255,0.7);
}

.received .message-footer {
    color: var(--subtext);
}

.msg-time {
    font-size: 10px;
}

.msg-status {
    display: inline-flex;
    align-items: center;
}

.msg-status i {
    font-size: 12px;
}

/* Status Colors */
.msg-status .fa-check-double {
    color: var(--primary);
}

.msg-status .fa-clock {
    color: var(--subtext);
}

.msg-status .fa-exclamation-circle {
    color: var(--orange-1);
}

/* Empty Chat States */
.empty-chat {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: var(--subtext);
    padding: 40px 20px;
}

.empty-chat .empty-icon {
    font-size: 56px;
    margin-bottom: 12px;
    color: var(--subtext);
}

.empty-chat p {
    margin: 4px 0;
    font-size: 16px;
    color: var(--text);
}

.empty-hint {
    font-size: 13px;
    color: var(--subtext);
}

/* Animations */
@keyframes fadeInUp {
    from { 
        opacity: 0; 
        transform: translateY(10px); 
    }
    to { 
        opacity: 1; 
        transform: translateY(0); 
    }
}

/* Additional theme fixes */
:root {
    --radius: 16px;
    --radius-sm: 10px;
    --transition: 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Scrollbar styling */
.letter-list::-webkit-scrollbar,
.chat-messages::-webkit-scrollbar,
.customer-results::-webkit-scrollbar {
    width: 4px;
}

.letter-list::-webkit-scrollbar-track,
.chat-messages::-webkit-scrollbar-track,
.customer-results::-webkit-scrollbar-track {
    background: var(--bg);
    border-radius: 4px;
}

.letter-list::-webkit-scrollbar-thumb,
.chat-messages::-webkit-scrollbar-thumb,
.customer-results::-webkit-scrollbar-thumb {
    background: var(--subtext);
    border-radius: 4px;
}

.letter-list::-webkit-scrollbar-thumb:hover,
.chat-messages::-webkit-scrollbar-thumb:hover,
.customer-results::-webkit-scrollbar-thumb:hover {
    background: var(--muted);
}

.modal-footer {
    padding: 12px 20px;
    border-top: 1px solid var(--card-border);
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    align-items: center;  /* Add this to align items vertically */
    background: var(--card-bg);
}

/* Make sure buttons don't have conflicting styles */
.modal-footer .btn {
    margin: 0;  /* Reset any margins */
    white-space: nowrap;  /* Prevent text wrapping */
}

/* If using flex: 1 or something causing issues */
.btn-secondary,
.btn-primary {
    flex-shrink: 0;  /* Prevent buttons from shrinking */
}

/* Recording Indicator */
.recording-indicator {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    background: #fee2e2;
    border-radius: 10px;
    color: #dc2626;
    font-size: 14px;
}

.recording-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #dc2626;
    animation: pulse-dot 1s ease-in-out infinite;
}

@keyframes pulse-dot {
    0%, 100% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.5); opacity: 0.5; }
}

.recording-timer {
    font-weight: 600;
    font-family: monospace;
}

/* Recording Button */
.tool-btn.recording {
    background: #dc2626;
    color: white;
    animation: pulse-recording 1.5s ease-in-out infinite;
}

@keyframes pulse-recording {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.1); }
}

/* Audio Preview */
.pending-audio {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background: #f3f4f6;
    border-radius: 8px;
    margin-top: 8px;
}

.pending-audio .audio-name {
    font-size: 13px;
    color: #374151;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.pending-audio .fa-file-audio {
    color: #8b5cf6;
    font-size: 18px;
}

/* Audio Preview in Modal */
.audio-preview {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 20px;
    background: #f3f4f6;
    border-radius: 12px;
    border: 2px dashed #8b5cf6;
}

.audio-preview .audio-icon {
    font-size: 32px;
    color: #8b5cf6;
}

.audio-preview .audio-filename {
    font-size: 14px;
    color: #374151;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Voice Recording Button in Modal */
.upload-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
}

.btn-voice {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: #f3f4f6;
    border: 2px solid #e5e7eb;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s ease;
    color: #374151;
}

.btn-voice:hover {
    background: #e5e7eb;
}

.btn-voice.recording {
    background: #dc2626;
    color: white;
    border-color: #dc2626;
    animation: pulse-recording 1.5s ease-in-out infinite;
}

.voice-timer {
    font-family: monospace;
    font-size: 14px;
    color: #6b7280;
    font-weight: 600;
}
/* Typ Hint Box */
.typ-hint-box {
    display: flex;
    gap: 12px;
    padding: 10px 14px;
    background: var(--bg-secondary, #f8f9fa);
    border-radius: 10px;
    margin-bottom: 12px;
    flex-wrap: wrap;
    border: 1px solid var(--border-color, #e9ecef);
}

.hint-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: var(--text-muted, #6c757d);
}

.hint-dot {
    width: 12px;
    height: 12px;
    border-radius: 4px;
    display: inline-block;
}

.hint-dot.type-1 {
    background: #3B82F6;
}
.hint-dot.type-2 {
    background: #22C55E;
}
.hint-dot.type-3 {
    background: #F59E0B;
}
.hint-dot.type-4 {
    background: #EF4444;
}

.hint-label {
    font-size: 11px;
    white-space: nowrap;
}

/* Letter Item with Typ Colors */
.letter-item {
    position: relative;
    border-right: 4px solid transparent;
    transition: all 0.2s ease;
}

.letter-item.type-1 {
    border-right-color: #3B82F6;
    background: rgba(59, 130, 246, 0.03);
}

.letter-item.type-2 {
    border-right-color: #22C55E;
    background: rgba(34, 197, 94, 0.03);
}

.letter-item.type-3 {
    border-right-color: #F59E0B;
    background: rgba(245, 158, 11, 0.03);
}

.letter-item.type-4 {
    border-right-color: #EF4444;
    background: rgba(239, 68, 68, 0.03);
}

.letter-item.type-1:hover {
    background: rgba(59, 130, 246, 0.08);
}

.letter-item.type-2:hover {
    background: rgba(34, 197, 94, 0.08);
}

.letter-item.type-3:hover {
    background: rgba(245, 158, 11, 0.08);
}

.letter-item.type-4:hover {
    background: rgba(239, 68, 68, 0.08);
}

.letter-item.active.type-1 {
    background: rgba(59, 130, 246, 0.12);
    border-right-color: #3B82F6;
}

.letter-item.active.type-2 {
    background: rgba(34, 197, 94, 0.12);
    border-right-color: #22C55E;
}

.letter-item.active.type-3 {
    background: rgba(245, 158, 11, 0.12);
    border-right-color: #F59E0B;
}

.letter-item.active.type-4 {
    background: rgba(239, 68, 68, 0.12);
    border-right-color: #EF4444;
}

/* Typ Badge on Letter */
.letter-type-badge {
    font-size: 10px;
    padding: 2px 8px;
    border-radius: 10px;
    font-weight: 600;
    white-space: nowrap;
    display: inline-block;
}

.letter-type-badge.type-1 {
    background: rgba(59, 130, 246, 0.15);
    color: #3B82F6;
}

.letter-type-badge.type-2 {
    background: rgba(34, 197, 94, 0.15);
    color: #22C55E;
}

.letter-type-badge.type-3 {
    background: rgba(245, 158, 11, 0.15);
    color: #F59E0B;
}

.letter-type-badge.type-4 {
    background: rgba(239, 68, 68, 0.15);
    color: #EF4444;
}

.letter-type-badge.type-0 {
    background: rgba(107, 114, 128, 0.15);
    color: #6B7280;
}

/* Update letter-meta to accommodate badge */
.letter-meta {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    min-width: 60px;
}

.letter-date {
    font-size: 11px;
    color: var(--text-muted, #6c757d);
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
    .typ-hint-box {
        background: var(--bg-secondary-dark, #1f2937);
        border-color: var(--border-color-dark, #374151);
    }
    
    .hint-item {
        color: var(--text-muted-dark, #9ca3af);
    }
    
    .letter-item.type-1 {
        background: rgba(59, 130, 246, 0.08);
    }
    
    .letter-item.type-2 {
        background: rgba(34, 197, 94, 0.08);
    }
    
    .letter-item.type-3 {
        background: rgba(245, 158, 11, 0.08);
    }
    
    .letter-item.type-4 {
        background: rgba(239, 68, 68, 0.08);
    }
}

/* Mobile Responsive */
@media (max-width: 768px) {
    .typ-hint-box {
        gap: 8px;
        padding: 8px 10px;
        flex-wrap: wrap;
    }
    
    .hint-item {
        font-size: 10px;
    }
    
    .hint-dot {
        width: 10px;
        height: 10px;
    }
    
    .letter-type-badge {
        font-size: 9px;
        padding: 1px 6px;
    }
}
/* Audio Player */
.message-audio {
    padding: 8px 0;
}

.audio-player {
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0, 0, 0, 0.1);
    padding: 8px 12px;
    border-radius: 8px;
}

.audio-player .audio-icon {
    font-size: 20px;
    color: #8b5cf6;
}

.audio-player audio {
    flex: 1;
    min-width: 150px;
    max-width: 300px;
}

/* Video Player */
.message-video video {
    max-width: 100%;
    max-height: 300px;
    border-radius: 8px;
}

/* Document Link */
.message-document .document-link,
.message-file-other .file-link {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    background: rgba(59, 130, 246, 0.1);
    border-radius: 8px;
    color: #3B82F6;
    text-decoration: none;
    transition: all 0.2s ease;
}

.message-document .document-link:hover,
.message-file-other .file-link:hover {
    background: rgba(59, 130, 246, 0.2);
    transform: scale(1.02);
}

.document-link .doc-icon,
.file-link .file-icon {
    font-size: 20px;
}
.msg-reference-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 2px 6px;
    font-size: 12px;
    opacity: 0.6;
    transition: all 0.2s ease;
    color: inherit;
    margin-right: 4px;
}

.msg-reference-btn:hover {
    opacity: 1;
    transform: scale(1.1);
}

.message-wrapper.sent .msg-reference-btn {
    color: rgba(255, 255, 255, 0.8);
}

.message-wrapper.received .msg-reference-btn {
    color: rgba(0, 0, 0, 0.6);
}

.message-footer {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
}

.registration-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--modal-overlay);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    animation: fadeIn 0.3s ease-out;
}

.registration-modal-content {
    background: var(--card-bg);
    border-radius: 12px;
    max-width: 500px;
    width: 95%;
    max-height: 90vh;
    overflow-y: auto;
    animation: slideUp 0.3s ease-out;
    border: 1px solid var(--card-border);
    box-shadow: 0 8px 32px var(--shadow-2);
}

.registration-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    border-bottom: 1px solid var(--card-border);
}

.registration-modal-header h3 {
    margin: 0;
    font-size: 18px;
    color: var(--heading);
    font-weight: 600;
}

.close-modal-btn {
    background: none;
    border: none;
    font-size: 28px;
    color: var(--subtext);
    cursor: pointer;
    padding: 0 8px;
    transition: color 0.2s;
}

.close-modal-btn:hover {
    color: var(--orange-1);
    transform: rotate(90deg);
}

.registration-modal-body {
    padding: 24px;
}

.registration-message {
    background: rgba(249, 115, 22, 0.1);
    border: 1px solid var(--orange-1);
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
}

.registration-message p {
    margin: 5px 0;
    color: var(--orange-1);
}

.registration-form {
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.form-group label {
    font-weight: 500;
    color: var(--heading);
    font-size: 14px;
}

.form-group label .required {
    color: var(--orange-1);
}

.form-input,
.form-textarea {
    padding: 10px 12px;
    border: 1px solid var(--card-border);
    border-radius: 6px;
    font-size: 14px;
    transition: border-color 0.2s, box-shadow 0.2s;
    font-family: inherit;
    background: var(--bg);
    color: var(--text);
}

.form-input:focus,
.form-textarea:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px var(--ring);
}

.form-input[readonly] {
    background-color: var(--bg);
    color: var(--subtext);
    opacity: 0.7;
    cursor: not-allowed;
}

.form-hint {
    font-size: 12px;
    color: var(--muted);
}

.form-actions {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    margin-top: 8px;
}

.cancel-btn {
    padding: 10px 20px;
    background: var(--bg);
    border: 1px solid var(--card-border);
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s;
    color: var(--subtext);
}

.cancel-btn:hover {
    background: var(--hover);
    border-color: var(--muted);
}

.register-btn {
    padding: 10px 24px;
    background: var(--green);
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.2s;
}

.register-btn:hover:not(:disabled) {
    background: #0d9f6e;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.register-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

/* Toast Styles */
.toast-notification {
    position: sticky;
    bottom: 20px;
    margin: 10px 20px;
    padding: 15px 25px;
    border-radius: 8px;
    box-shadow: 0 4px 12px var(--shadow-2);
    z-index: 20;
    animation: slideUp 0.5s ease-out;
}

.toast-notification.success {
    background: linear-gradient(135deg, var(--green), #0d9f6e);
    color: white;
}

.toast-notification.error {
    background: linear-gradient(135deg, var(--orange-1), var(--orange-2));
    color: white;
}

.toast-notification.warning {
    background: linear-gradient(135deg, #f59e0b, #d97706);
    color: white;
}

.toast-content {
    display: flex;
    align-items: center;
    gap: 12px;
}

.toast-icon {
    font-size: 24px;
}

.toast-message {
    flex: 1;
    font-size: 15px;
    font-weight: 500;
}

.toast-close {
    background: none;
    border: none;
    color: white;
    font-size: 24px;
    cursor: pointer;
    padding: 0 8px;
    opacity: 0.8;
    transition: opacity 0.2s;
}

.toast-close:hover {
    opacity: 1;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(30px) scale(0.95);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

/* Responsive Adjustments */
@media (max-width: 480px) {
    .registration-modal-content {
        width: 100%;
        max-height: 100vh;
        border-radius: 0;
    }
    
    .registration-modal-header {
        padding: 16px 20px;
    }
    
    .registration-modal-body {
        padding: 20px;
    }
    
    .form-actions {
        flex-direction: column;
    }
    
    .cancel-btn,
    .register-btn {
        width: 100%;
        justify-content: center;
    }
    
    .toast-notification {
        margin: 10px;
        padding: 12px 16px;
    }
}
/* Message File Styles */
.message-file {
    margin-bottom: 8px;
    border-radius: 12px;
    overflow: hidden;
}

.message-image {
    position: relative;
    cursor: pointer;
    border-radius: 12px;
    overflow: hidden;
    max-width: 300px;
}

.message-image img {
    width: 100%;
    height: auto;
    max-height: 300px;
    object-fit: cover;
    display: block;
}

.image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.message-image:hover .image-overlay {
    opacity: 1;
}

.image-overlay i {
    color: white;
    font-size: 24px;
}

/* Audio Player */
.message-audio {
    min-width: 200px;
    max-width: 300px;
}

.audio-player {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 12px;
}

.audio-icon {
    font-size: 20px;
    color: var(--primary);
}

.audio-player audio {
    width: 100%;
    height: 40px;
}

/* Video Player */
.message-video {
    border-radius: 12px;
    overflow: hidden;
    max-width: 350px;
}

.message-video video {
    width: 100%;
    max-height: 350px;
    display: block;
}

/* Document Link */
.message-document {
    padding: 4px 0;
}

.document-link {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 8px 14px;
    background: rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    text-decoration: none;
    color: var(--text) !important;
    transition: background 0.2s ease;
    font-size: 14px;
}

.document-link:hover {
    background: rgba(0, 0, 0, 0.15);
    text-decoration: none;
}

.doc-icon {
    font-size: 20px;
    color: #EF4444;
}

.document-link .doc-name {
    font-weight: 500;
}

/* Other File */
.message-file-other {
    padding: 4px 0;
}

.file-link {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 8px 14px;
    background: rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    text-decoration: none;
    color: var(--text) !important;
    transition: background 0.2s ease;
    font-size: 14px;
}

.file-link:hover {
    background: rgba(0, 0, 0, 0.15);
    text-decoration: none;
}

.file-link .file-name {
    font-weight: 500;
}

/* Message Bubble - Make sure files are displayed properly */
.message-bubble {
    max-width: 80%;
    padding: 10px 14px;
    border-radius: 18px;
    word-wrap: break-word;
}

.message-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.message-text {
    font-size: 14px;
    line-height: 1.5;
}

.message-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    font-size: 11px;
    margin-top: 4px;
    opacity: 0.8;
}

/* Sent vs Received message alignment */
.message-wrapper.sent {
    display: flex;
    justify-content: flex-end;
}

.message-wrapper.received {
    display: flex;
    justify-content: flex-start;
}

.message-wrapper.sent .message-bubble {
    background-color: var(--primary) !important;
    color: white !important;
}

.message-wrapper.received .message-bubble {
    background-color: var(--subtext-opposite) !important;
}

.message-wrapper.received .message-bubble .document-link {
    color: var(--text) !important;
}

.message-wrapper.sent .message-bubble .document-link {
    color: white !important;
}

.message-wrapper.sent .message-bubble .document-link:hover {
    background: rgba(255, 255, 255, 0.15);
}

.message-wrapper.received .message-bubble .document-link:hover {
    background: rgba(0, 0, 0, 0.15);
}
.pending-file {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background: rgba(59, 130, 246, 0.1);
    border-radius: 8px;
    margin: 4px 0;
}

.pending-file .file-name {
    font-size: 13px;
    font-weight: 500;
    color: var(--text);
}

.pending-file .file-type-badge {
    font-size: 11px;
    padding: 2px 8px;
    background: var(--primary);
    color: white;
    border-radius: 12px;
}

.pending-file .remove-pending {
    background: none;
    border: none;
    color: #EF4444;
    cursor: pointer;
    padding: 4px;
}

.pending-file .remove-pending:hover {
    color: #DC2626;
}
/* Image fallback */
.image-fallback {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 12px;
    min-height: 100px;
    color: var(--text-muted);
    gap: 8px;
}

.image-fallback i {
    font-size: 32px;
}

.image-fallback span {
    font-size: 13px;
}

/* Message image container */
.message-image {
    position: relative;
    cursor: pointer;
    border-radius: 12px;
    overflow: hidden;
    max-width: 300px;
    background: rgba(0, 0, 0, 0.05);
}

.message-image img {
    width: 100%;
    height: auto;
    max-height: 300px;
    object-fit: contain;
    display: block;
}

/* Audio player enhancements */
.audio-player {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    background: rgba(0, 0, 0, 0.06);
    border-radius: 12px;
    min-width: 200px;
}

.audio-player audio {
    width: 100%;
    height: 40px;
    outline: none;
}

.audio-player audio::-webkit-media-controls-panel {
    background-color: transparent;
}

/* Video player enhancements */
.message-video {
    border-radius: 12px;
    overflow: hidden;
    max-width: 350px;
    background: rgba(0, 0, 0, 0.05);
}

.message-video video {
    width: 100%;
    max-height: 350px;
    display: block;
    outline: none;
}

/* Document links - make them more visible */
.document-link {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
    background: rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    text-decoration: none;
    color: var(--text) !important;
    transition: all 0.2s ease;
    font-size: 14px;
    border: 1px solid rgba(0, 0, 0, 0.05);
}

.document-link:hover {
    background: rgba(0, 0, 0, 0.15);
    text-decoration: none;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.doc-icon {
    font-size: 22px;
    color: #EF4444;
}

/* File link */
.file-link {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
    background: rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    text-decoration: none;
    color: var(--text) !important;
    transition: all 0.2s ease;
    font-size: 14px;
    border: 1px solid rgba(0, 0, 0, 0.05);
}

.file-link:hover {
    background: rgba(0, 0, 0, 0.15);
    text-decoration: none;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Style for sent messages - white text on colored background */
.message-wrapper.sent .document-link,
.message-wrapper.sent .file-link {
    color: white !important;
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.1);
}

.message-wrapper.sent .document-link:hover,
.message-wrapper.sent .file-link:hover {
    background: rgba(255, 255, 255, 0.25);
}

.message-wrapper.sent .doc-icon {
    color: #FCA5A5;
}

/* For received messages - darker text on light background */
.message-wrapper.received .document-link,
.message-wrapper.received .file-link {
    color: var(--text) !important;
    background: rgba(0, 0, 0, 0.06);
    border-color: rgba(0, 0, 0, 0.05);
}



/* WhatsApp-style message layout */
.message-wrapper {
    margin-bottom: 4px;
    display: flex;
    flex-direction: column;
}

.message-wrapper.sent {
    align-items: flex-end;
}

.message-wrapper.received {
    align-items: flex-start;
}

.message-wrapper.private-act-message .message-bubble {
    box-shadow: 0 0 0 1px rgba(245, 158, 11, 0.45);
}

.private-act-indicator {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    max-width: min(92%, 520px);
    margin: 2px 4px 6px;
    padding: 5px 9px;
    border: 1px solid rgba(245, 158, 11, 0.32);
    border-radius: 10px;
    background: rgba(245, 158, 11, 0.1);
    color: var(--text);
    font-size: 11px;
    line-height: 1.6;
}

.private-act-indicator i {
    margin-inline-end: 2px;
    color: #d97706;
}

.private-act-indicator strong {
    color: #b45309;
    font-weight: 700;
}

.private-act-indicator-sent {
    align-self: flex-end;
}

.private-act-indicator-received {
    align-self: flex-start;
}

/* Sender name wrapper - WhatsApp style */
.sender-name-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 2px 0 2px 0;
    padding: 0 4px;
}

.sender-name {
    font-size: 13px;
    font-weight: 600;
    color: #6c5ce7;
}

.message-wrapper.sent .sender-name {
    color: var(--primary);
}

.message-wrapper.received .sender-name {
    color: #6c5ce7;
}

.sender-name-right {
    text-align: right;
}

.sender-name-left {
    text-align: left;
}

.message-time-separator {
    font-size: 11px;
    color: #999;
    font-weight: 400;
}

/* Message bubble wrapper */
.message-bubble-wrapper {
    max-width: 75%;
}

.message-bubble {
    padding: 8px 12px;
    border-radius: 12px;
    position: relative;
    word-wrap: break-word;
}

.message-wrapper.sent .message-bubble {
    border-bottom-right-radius: 4px;
}

.message-wrapper.received .message-bubble {
    border-bottom-left-radius: 4px;
}

/* Message footer */
.message-footer {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
    margin-top: 2px;
    font-size: 11px;
}

.msg-time {
    font-size: 11px;
    opacity: 0.7;
}

.msg-status {
    font-size: 14px;
}

/* Reference button */
.msg-reference-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 2px 6px;
    font-size: 12px;
    opacity: 0.4;
    transition: all 0.2s ease;
    color: inherit;
}

.msg-reference-btn:hover {
    opacity: 1;
    transform: scale(1.1);
}

.message-wrapper.sent .msg-reference-btn {
    color: rgba(255, 255, 255, 0.6);
}

.message-wrapper.received .msg-reference-btn {
    color: rgba(0, 0, 0, 0.4);
}

/* Message image */
.message-image {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    max-width: 300px;
}

.message-image img {
    width: 100%;
    height: auto;
    display: block;
    max-height: 300px;
    object-fit: cover;
}

.image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.message-image:hover .image-overlay {
    opacity: 1;
}

.image-overlay i {
    color: white;
    font-size: 24px;
}

/* Audio player */
.message-audio .audio-player {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 10px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    min-width: 200px;
}

.message-audio .audio-icon {
    font-size: 20px;
    color: #6c5ce7;
}

.message-audio audio {
    flex: 1;
    min-width: 120px;
    max-width: 250px;
}

/* Video player */
.message-video video {
    max-width: 100%;
    max-height: 300px;
    border-radius: 8px;
}

/* Document links */
.message-document .document-link,
.message-file-other .file-link {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    background: rgba(108, 92, 231, 0.1);
    border-radius: 8px;
    color: #6c5ce7;
    text-decoration: none;
    transition: all 0.2s ease;
}

.message-wrapper.sent .document-link,
.message-wrapper.sent .file-link {
    background: rgba(255, 255, 255, 0.15);
    color: white;
}

.message-document .document-link:hover,
.message-file-other .file-link:hover {
    transform: scale(1.02);
}

.document-link .doc-icon,
.file-link .file-icon {
    font-size: 20px;
}

/* Empty chat */
.empty-chat {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: var(--text-muted);
}

.empty-chat .empty-icon {
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.5;
}

.empty-chat p {
    font-size: 16px;
    margin: 4px 0;
}

.empty-hint {
    font-size: 13px;
    opacity: 0.7;
}

/* Image fallback */
.image-fallback {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    min-height: 100px;
}

.image-fallback i {
    font-size: 32px;
    color: #999;
    margin-bottom: 8px;
}

.image-fallback span {
    font-size: 13px;
    color: #999;
}

/* Mobile responsive */
@media (max-width: 768px) {
    .message-bubble-wrapper {
        max-width: 85%;
    }
    
    .sender-name {
        font-size: 12px;
    }
    
    .message-image img {
        max-height: 200px;
    }
    
    .message-audio .audio-player {
        min-width: 300px;
    }
    
    .message-audio audio {
        max-width: 180px;
    }
}
.bubble-sent {
    margin-right: auto;
}
.bubble-received {
    margin-left: auto;
}
.text-sent {
    color: white;
}
.text-received {
    color: var(--text);
}

/* Chat Input Area */
.chat-input-area {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    padding: 8px 12px;
    background: var(--bg-color, #fff);
    border-top: 1px solid var(--border-color, #e5e7eb);
    flex-shrink: 0;
}

.input-actions {
    display: flex;
    gap: 6px;
    align-items: center;
    flex-shrink: 0;
}

.tool-btn {
    width: 36px;
    height: 36px;
    border: none;
    background: transparent;
    border-radius: 50%;
    cursor: pointer;
    color: #6b7280;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    flex-shrink: 0;
}

.tool-btn:hover {
    background: #f3f4f6;
    color: #374151;
}

.tool-btn.recording {
    color: #EF4444;
    background: #fee2e2;
    animation: pulse-recording 1.5s ease-in-out infinite;
}

@keyframes pulse-recording {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.1); }
}

/* Input Wrapper */
.input-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #f3f4f6;
    border-radius: 20px;
    padding: 5px 12px;
    min-height: 40px;
    max-height: 120px;
    overflow-y: auto;
    position: relative;
}

/* Recording Indicator */
.recording-indicator {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 0;
    color: #dc2626;
    font-size: 13px;
}

.recording-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #dc2626;
    animation: pulse-dot 1s ease-in-out infinite;
}

@keyframes pulse-dot {
    0%, 100% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.5); opacity: 0.5; }
}

.recording-timer {
    font-weight: 600;
    font-family: monospace;
}

/* Message Input Textarea */
.message-input {
    width: 100%;
    border: none;
    background: transparent;
    resize: none;
    font-size: 14px;
    font-family: inherit;
    outline: none;
    color: var(--text-color, #1f2937);
    min-height: 32px;
    max-height: 100px;
    line-height: 1.5;
}

.message-input::placeholder {
    color: #9ca3af;
}

/* Pending File */
.pending-file {
    display: flex;
    align-items: center;
    gap: 6px;
    background: #e5e7eb;
    border-radius: 16px;
    padding: 4px 10px 4px 8px;
    margin: 4px 0;
    max-width: 100%;
    flex-wrap: nowrap;
    overflow: hidden;
}

.pending-file i {
    font-size: 14px;
    color: #6b7280;
    flex-shrink: 0;
}

.pending-file .file-name {
    font-size: 13px;
    color: #374151;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px;
    flex: 1;
    min-width: 40px;
}

.pending-file .file-type-badge {
    font-size: 10px;
    background: #d1d5db;
    padding: 2px 8px;
    border-radius: 10px;
    color: #4b5563;
    font-weight: 500;
    white-space: nowrap;
    flex-shrink: 0;
}

.remove-pending {
    background: none;
    border: none;
    cursor: pointer;
    color: #9ca3af;
    padding: 2px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.remove-pending:hover {
    color: #EF4444;
    transform: scale(1.2);
}

/* Send Button */
.send-btn {
    width: 40px;
    height: 40px;
    border: none;
    background: var(--primary, #6c5ce7);
    color: white;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
}

.send-btn:hover:not(:disabled) {
    background: var(--primary-dark, #5b4bd5);
    transform: scale(1.05);
}

.send-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

/* Mobile Responsive */
@media (max-width: 768px) {
    .chat-input-area {
        padding: 6px 8px;
        gap: 6px;
    }
    
    .tool-btn {
        width: 32px;
        height: 32px;
        font-size: 14px;
    }
    
    .input-wrapper {
        border-radius: 16px;
        padding: 0px 10px;
        min-height: 36px;
    }
    
    .message-input {
        font-size: 13px;
        min-height: 28px;
    }
    
    .pending-file .file-name {
        max-width: 80px;
        font-size: 12px;
    }
    
    .pending-file .file-type-badge {
        font-size: 9px;
        padding: 1px 6px;
    }
    
    .send-btn {
        width: 36px;
        height: 36px;
        font-size: 16px;
    }
}

/* Scrollbar for input wrapper */
.input-wrapper::-webkit-scrollbar {
    width: 4px;
}

.input-wrapper::-webkit-scrollbar-track {
    background: transparent;
}

.input-wrapper::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 2px;
}

.input-wrapper::-webkit-scrollbar-thumb:hover {
    background: #9ca3af;
}
/* Audio Player - Fixed */
.message-audio {
    width: 100%;
    min-width: 200px;
    max-width: 100%;
}

.audio-player {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 12px;
    background: rgba(0, 0, 0, 0.06);
    border-radius: 12px;
    width: 100%;
    min-width: 200px;
    max-width: 100%;
    overflow: hidden; /* Prevents overflow */
}

.audio-player audio {
    flex: 1;
    min-width: 100px;
    max-width: 100%;
    width: 100%;
}

/* Make sure audio doesn't overflow the message bubble */
.message-bubble-wrapper {
    max-width: 75%;
    overflow: hidden; /* Add this */
}

.message-bubble {
    max-width: 100%;
    overflow: hidden; /* Add this */
}

/* For mobile */
@media (max-width: 768px) {
    .message-bubble-wrapper {
        max-width: 85%;
    }
    
    .audio-player {
        min-width: 150px;
        padding: 6px 10px;
    }
    
    .audio-player audio {
        min-width: 80px;
    }
}
/* Audio Player - Fixed with proper timeline */
.message-audio {
    width: 100%;
    min-width: 250px;
    max-width: 100%;
}

.audio-player {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 12px;
    background: rgba(0, 0, 0, 0.06);
    border-radius: 12px;
    width: 100%;
    min-width: 250px;
    max-width: 100%;
}

.audio-player audio {
    flex: 1;
    min-width: 180px; /* Increased from 100px */
    max-width: 100%;
    width: 100%;
    height: 40px; /* Ensure consistent height */
}

/* Make message bubble wider for audio */
.message-bubble-wrapper {
    max-width: 80%; /* Increased from 75% */
    min-width: 300px; /* Minimum width for audio */
}

/* For mobile */
@media (max-width: 768px) {
    .message-bubble-wrapper {
        max-width: 90%;
        min-width: 250px;
    }
    
    .audio-player {
        min-width: 200px;
        padding: 6px 10px;
    }
    
    .audio-player audio {
        min-width: 140px;
    }
}

@media (max-width: 480px) {
    .message-bubble-wrapper {
        min-width: 200px;
    }
    
    .audio-player audio {
        min-width: 100px;
    }
}
/* Audio Player - Full fix */
.message-audio {
    width: 100%;
    min-width: 280px;
    max-width: 100%;
}

.audio-player {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 14px;
    background: rgba(0, 0, 0, 0.06);
    border-radius: 12px;
    width: 100%;
    min-width: 280px;
    max-width: 100%;
}

.audio-wrapper {
    flex: 1;
    min-width: 200px;
    width: 100%;
}

.audio-wrapper audio {
    width: 100%;
    min-width: 200px;
    height: 40px;
    display: block;
}

.audio-icon {
    font-size: 20px;
    color: #6c5ce7;
    flex-shrink: 0;
}

/* Make message bubble wider for audio content */
.message-bubble-wrapper {
    max-width: 80%;
    min-width: 320px;
}

/* Chrome/Safari - Make timeline wider */
.audio-wrapper audio::-webkit-media-controls-panel {
    width: 100% !important;
}

.audio-wrapper audio::-webkit-media-controls-timeline {
    flex: 1 !important;
    min-width: 100px !important;
}

.audio-wrapper audio::-webkit-media-controls-current-time-display,
.audio-wrapper audio::-webkit-media-controls-time-remaining-display {
    min-width: 30px !important;
}

/* Firefox */
.audio-wrapper audio::-moz-range-track {
    width: 100%;
}

/* Mobile responsive */
@media (max-width: 768px) {
    .message-bubble-wrapper {
        max-width: 90%;
        min-width: 250px;
    }
    
    .message-audio {
        min-width: 220px;
    }
    
    .audio-player {
        min-width: 220px;
        padding: 6px 10px;
        gap: 8px;
    }
    
    .audio-wrapper {
        min-width: 140px;
    }
    
    .audio-wrapper audio {
        min-width: 140px;
    }
}

@media (max-width: 480px) {
    .message-bubble-wrapper {
        min-width: 180px;
    }
    
    .message-audio {
        min-width: 160px;
    }
    
    .audio-player {
        min-width: 160px;
        padding: 4px 8px;
        gap: 6px;
        flex-wrap: nowrap;
    }
    
    .audio-wrapper {
        min-width: 100px;
    }
    
    .audio-wrapper audio {
        min-width: 100px;
        height: 36px;
    }
    
    .audio-icon {
        font-size: 16px;
    }
}
.input-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #f3f4f6;
    border-radius: 20px;
    padding: 0px 12px;
    min-height: 40px;
    max-height: 130px;
    overflow-y: auto;
    position: relative;
}

.message-input {
    width: 100%;
    border: none;
    background: transparent;
    resize: none;
    font-size: 14px;
    font-family: inherit;
    outline: none;
    color: var(--text-color, #1f2937);
    min-height: 28px;
    max-height: 120px;
    line-height: 1.5;
    overflow-y: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
}

.message-input::placeholder {
    color: #9ca3af;
}
/* Input Wrapper - Fixed */
.input-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #f3f4f6;
    border-radius: 20px;
    padding: 6px 12px;
    min-height: 44px;
    max-height: 130px;
    overflow-y: auto;
    position: relative;
}

/* Textarea - Fixed */
.message-input {
    width: 100%;
    border: none;
    background: transparent;
    resize: none;
    font-size: 14px;
    font-family: inherit;
    outline: none;
    color: var(--text-color, #1f2937);
    min-height: 32px;
    max-height: 120px;
    line-height: 1.6;
    overflow-y: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
    padding: 2px 0;
    margin: 0;
}

.message-input::placeholder {
    color: #9ca3af;
}

/* Scrollbar styling for textarea */
.message-input::-webkit-scrollbar {
    width: 4px;
}

.message-input::-webkit-scrollbar-track {
    background: transparent;
}

.message-input::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 2px;
}

.message-input::-webkit-scrollbar-thumb:hover {
    background: #9ca3af;
}

/* For Firefox */
.message-input {
    scrollbar-width: thin;
}
/* Message Text - Fix for multi-line messages */
.message-text {
    font-size: 14px;
    line-height: 1.6;
    text-align: right;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: break-word;
    max-width: 100%;
}

.text-sent {
    color: white;
    white-space: pre-wrap;
}

.text-received {
    color: var(--text);
    white-space: pre-wrap;
}

/* Make sure the message bubble handles long text properly */
.message-bubble {
    max-width: 100%;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.message-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-width: 100%;
}
.msg-menu-btn {
    background: none;
    border: none;
    color: var(gra);
    cursor: pointer;
    padding: 2px 6px;
    border-radius: 50%;
    transition: all 0.2s ease;
    font-size: 12px;
    opacity: 0.4;
}

.msg-menu-btn:hover {
    opacity: 1;
    background: var(--bg);
    color: var(--primary);
}

.message-wrapper.sent .msg-menu-btn {
    color: rgba(255, 255, 255, 0.6);
}

.message-wrapper.received .msg-menu-btn {
    color: var(--subtext);
}

/* Update sender-name-wrapper to accommodate the menu button */
.sender-name-wrapper {
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 2px 0 2px 0;
    padding: 0 4px;
}
/* Letter Actions Modal */
.letter-actions-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10001;
    animation: fadeIn 0.2s ease;
}

.letter-actions-modal {
    background: var(--card-bg);
    border-radius: 16px;
    max-width: 320px;
    width: 90%;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    animation: slideUp 0.25s ease;
    overflow: hidden;
    border: 1px solid var(--card-border);
}

.letter-actions-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    background: linear-gradient(135deg, var(--gradient-1), var(--gradient-2));
    border-bottom: 1px solid var(--card-border);
}

.letter-actions-title {
    display: flex;
    align-items: center;
    gap: 10px;
    color: white;
    font-weight: 600;
    font-size: 15px;
}

.letter-actions-title i {
    font-size: 18px;
}

.letter-actions-close {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    padding: 4px 8px;
    font-size: 18px;
    opacity: 0.7;
    transition: opacity 0.2s;
}

.letter-actions-close:hover {
    opacity: 1;
}

.letter-actions-body {
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.letter-action-btn {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border: none;
    border-radius: 10px;
    background: transparent;
    color: var(--text);
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 14px;
    font-weight: 500;
    width: 100%;
    text-align: right;
}

.letter-action-btn i {
    font-size: 18px;
    width: 24px;
    text-align: center;
    color: var(--subtext);
}

.letter-action-btn:hover {
    background: var(--bg);
}

.letter-action-btn.danger:hover {
    background: #FEE2E2;
    color: #EF4444;
}

.letter-action-btn.danger:hover i {
    color: #EF4444;
}

/* Letter Menu Button */
.letter-menu-btn {
    background: none;
    border: none;
    color: var(--subtext);
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 50%;
    transition: all 0.2s ease;
    font-size: 14px;
}

.letter-menu-btn:hover {
    background: var(--bg);
    color: var(--primary);
}

/* Update letter-meta to accommodate the menu button */
.letter-meta {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    min-width: 60px;
    position: relative;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

@keyframes slideUp {
    from { opacity: 0; transform: translateY(20px) scale(0.95); }
    to { opacity: 1; transform: translateY(0) scale(1); }
}

/* Tutorial Overlay */
.tutorial-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999;
    animation: fadeIn 0.4s ease;
}

.tutorial-container {
    background: var(--card-bg);
    border-radius: 20px;
    max-width: 520px;
    width: 90%;
    max-height: 90vh;
    overflow: hidden;
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.5);
    animation: slideUp 0.4s ease;
    border: 1px solid var(--card-border);
}

.tutorial-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    background: linear-gradient(135deg, var(--gradient-1), var(--gradient-2));
    color: white;
}

.tutorial-header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
}

.tutorial-close {
    background: none;
    border: none;
    color: white;
    font-size: 22px;
    cursor: pointer;
    opacity: 0.7;
    transition: opacity 0.2s;
    padding: 4px 8px;
}

.tutorial-close:hover {
    opacity: 1;
}

.tutorial-body {
    padding: 24px;
    max-height: 400px;
    overflow-y: auto;
}

.tutorial-step {
    display: flex;
    gap: 16px;
    padding: 16px;
    border-radius: 12px;
    background: var(--bg);
    margin-bottom: 12px;
    transition: all 0.3s ease;
    border: 2px solid transparent;
}

.tutorial-step.active {
    border-color: var(--primary);
    background: var(--ring);
}

.step-number {
    width: 32px;
    height: 32px;
    min-width: 32px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--gradient-1), var(--gradient-2));
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 14px;
}

.step-content {
    flex: 1;
    position: relative;
}

.step-title {
    font-weight: 600;
    color: var(--text);
    font-size: 15px;
    margin-bottom: 4px;
}

.step-description {
    font-size: 13px;
    color: var(--subtext);
    line-height: 1.5;
}

.step-icon {
    position: absolute;
    top: 0;
    left: -8px;
    font-size: 20px;
    opacity: 0.2;
}

.tutorial-footer {
    padding: 16px 24px;
    border-top: 1px solid var(--card-border);
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: var(--card-bg);
}

.tutorial-btn {
    padding: 10px 24px;
    border: none;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
}

.skip-btn {
    background: var(--bg);
    color: var(--subtext);
}

.skip-btn:hover {
    background: var(--card-border);
}

.next-btn {
    background: linear-gradient(135deg, var(--gradient-1), var(--gradient-2));
    color: white;
}

.next-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(108, 92, 231, 0.3);
}

.done-btn {
    background: var(--green);
    color: white;
}

.done-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(16, 185, 129, 0.3);
}

.tutorial-dots {
    display: flex;
    justify-content: center;
    gap: 8px;
    padding: 12px 0 16px 0;
    background: var(--card-bg);
}

.tutorial-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--card-border);
    cursor: pointer;
    transition: all 0.3s ease;
}

.tutorial-dot.active {
    background: var(--primary);
    width: 24px;
    border-radius: 4px;
}

/* Tooltip Popup */
.tooltip-popup {
    position: fixed;
    z-index: 99998;
    background: var(--card-bg);
    border-radius: 12px;
    padding: 12px 16px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
    border: 1px solid var(--card-border);
    max-width: 300px;
    animation: tooltipFade 0.3s ease;
    pointer-events: none;
}

.tooltip-popup .tooltip-content {
    display: flex;
    align-items: center;
    gap: 10px;
}

.tooltip-popup .tooltip-text {
    font-size: 13px;
    color: var(--text);
    flex: 1;
}

.tooltip-popup .tooltip-close {
    background: none;
    border: none;
    color: var(--subtext);
    cursor: pointer;
    font-size: 16px;
    padding: 2px 6px;
    pointer-events: all;
}

.tooltip-popup .tooltip-arrow {
    position: absolute;
    width: 12px;
    height: 12px;
    background: var(--card-bg);
    border-left: 1px solid var(--card-border);
    border-top: 1px solid var(--card-border);
    transform: rotate(45deg);
}

.tooltip-popup[data-position="bottom"] .tooltip-arrow {
    top: -7px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
}

.tooltip-popup[data-position="top"] .tooltip-arrow {
    bottom: -7px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
}

.tooltip-popup[data-position="left"] .tooltip-arrow {
    right: -7px;
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
}

.tooltip-popup[data-position="right"] .tooltip-arrow {
    left: -7px;
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
}

@keyframes tooltipFade {
    from {
        opacity: 0;
        transform: translateY(10px) scale(0.95);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}
/* Toast */
.toast {
    position: fixed;
    top: 24px;
    right: 50%;
    transform: translateX(50%);
    z-index: 99999;  /* Change from 9999 to 99999 */
    padding: 14px 24px;
    border-radius: var(--radius-sm);
    box-shadow: 0 4px 20px var(--shadow-2);
    min-width: 300px;
    max-width: 90%;
    animation: slideDown 0.3s ease-out;
}
/* ============ FORWARDED MESSAGE CONTEXT - TYPACT: 2 ============ */
.forwarded-context {
    margin-bottom: 10px;
    padding: 12px 14px;
    border-radius: 12px;
    border-right: 4px solid #FF6B6B;
    background: linear-gradient(135deg, rgba(255, 107, 107, 0.08), rgba(255, 107, 107, 0.02));
    max-width: 90%;
    position: relative;
    margin-right: 48px;
    animation: fadeInForward 0.3s ease;
}

.forwarded-context-sent {
    background: linear-gradient(135deg, rgba(255, 107, 107, 0.12), rgba(255, 107, 107, 0.04));
    border-right-color: #FF6B6B;
    margin-right: 0;
    margin-left: auto;
}

.forwarded-context-received {
    background: linear-gradient(135deg, rgba(255, 107, 107, 0.06), rgba(255, 107, 107, 0.02));
    border-right-color: #FF6B6B;
}

.forwarded-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
    padding-bottom: 6px;
    border-bottom: 1px solid rgba(255, 107, 107, 0.15);
}

.forwarded-icon {
    color: #FF6B6B;
    font-size: 14px;
}

.forwarded-label {
    color: #FF6B6B;
    font-weight: 600;
    font-size: 13px;
}

.forwarded-info {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 8px;
    font-size: 12px;
    color: var(--text-secondary, #3d3d3d);
}

.forwarded-from, .forwarded-to {
    display: flex;
    align-items: center;
    gap: 4px;
    background: rgba(0, 0, 0, 0.04);
    padding: 2px 10px;
    border-radius: 12px;
    font-size: 12px;
}

.forwarded-from i, .forwarded-to i {
    font-size: 11px;
    opacity: 0.6;
}

/* Original Message Preview - Clickable */
.original-message-preview {
    background: rgba(108, 92, 231, 0.06);
    border-radius: 10px;
    padding: 10px 12px;
    cursor: pointer;
    transition: all 0.25s ease;
    border: 1px solid rgba(108, 92, 231, 0.1);
    position: relative;
    overflow: hidden;
}

.original-message-preview:hover {
    background: rgba(108, 92, 231, 0.12);
    border-color: rgba(108, 92, 231, 0.25);
    transform: translateX(-2px);
    box-shadow: 0 2px 12px rgba(108, 92, 231, 0.1);
}

.original-message-preview:active {
    transform: scale(0.98);
}

.preview-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
    font-size: 12px;
}

.preview-header i {
    color: var(--primary, #6c5ce7);
    font-size: 12px;
}

.preview-sender {
    font-weight: 600;
    color: var(--primary, #6c5ce7);
    font-size: 12px;
}

.preview-time {
    color: var(--text-muted, #8e8e93);
    font-size: 11px;
    margin-right: auto;
}

.preview-text {
    font-size: 13px;
    color: var(--text-secondary, #3d3d3d);
    opacity: 0.85;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 4px;
    margin-bottom: 4px;
}

.preview-file {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    color: var(--text-muted, #8e8e93);
    background: rgba(0, 0, 0, 0.04);
    padding: 2px 10px;
    border-radius: 12px;
    width: fit-content;
}

.preview-file i {
    font-size: 11px;
}

.preview-scroll-hint {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    color: var(--primary, #6c5ce7);
    opacity: 0.6;
    margin-top: 6px;
    padding: 4px 10px;
    background: rgba(108, 92, 231, 0.06);
    border-radius: 12px;
    width: fit-content;
    transition: all 0.2s ease;
}

.original-message-preview:hover .preview-scroll-hint {
    opacity: 1;
    background: rgba(108, 92, 231, 0.12);
}

.preview-scroll-hint i {
    font-size: 11px;
    animation: bounceUp 1.5s infinite;
}

.original-message-not-found {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: var(--text-muted, #8e8e93);
    padding: 8px 12px;
    background: rgba(0, 0, 0, 0.04);
    border-radius: 8px;
}

.original-message-not-found i {
    color: #F59E0B;
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
    .forwarded-context {
        background: linear-gradient(135deg, rgba(255, 107, 107, 0.12), rgba(255, 107, 107, 0.04));
    }
    
    .forwarded-context-received {
        background: linear-gradient(135deg, rgba(255, 107, 107, 0.08), rgba(255, 107, 107, 0.02));
    }
    
    .forwarded-info {
        color: var(--text-secondary-dark, #b0b0b0);
    }
    
    .original-message-preview {
        background: rgba(108, 92, 231, 0.08);
        border-color: rgba(108, 92, 231, 0.15);
    }
    
    .original-message-preview:hover {
        background: rgba(108, 92, 231, 0.15);
    }
    
    .preview-text {
        color: var(--text-secondary-dark, #b0b0b0);
    }
}

/* Animations */
@keyframes fadeInForward {
    from {
        opacity: 0;
        transform: translateY(-8px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes bounceUp {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-3px); }
}

/* Responsive */
@media (max-width: 768px) {
    .forwarded-context {
        margin-right: 8px !important;
        max-width: 95%;
        padding: 10px 12px;
    }
    
    .forwarded-context-sent {
        margin-left: 8px !important;
    }
    
    .forwarded-info {
        gap: 6px;
        font-size: 11px;
        flex-wrap: wrap;
    }
    
    .original-message-preview {
        padding: 8px 10px;
    }
    
    .preview-text {
        font-size: 12px;
    }
}
/* Reply Indicator */
.reply-indicator {
    background: var(--bg-secondary, #f0f0f0);
    border-right: 3px solid var(--primary, #6c5ce7);
    border-radius: 8px 8px 0 0;
    padding: 8px 12px;
    margin-bottom: 4px;
    display: flex;
    align-items: flex-start;
    animation: slideDown 0.3s ease;
}

.reply-indicator-content {
    width: 100%;
}

.reply-indicator-header {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.reply-icon {
    color: var(--primary, #6c5ce7);
    font-size: 14px;
}

.reply-indicator-label {
    font-size: 13px;
    color: var(--text-muted, #888);
    font-weight: 500;
}

.reply-indicator-sender {
    font-size: 13px;
    font-weight: 600;
    color: var(--text, #333);
}

.reply-indicator-cancel {
    background: none;
    border: none;
    color: var(--text-muted, #888);
    cursor: pointer;
    padding: 2px 6px;
    margin-right: auto;
    font-size: 14px;
    transition: color 0.2s;
}

.reply-indicator-cancel:hover {
    color: var(--danger, #ef4444);
}

.reply-indicator-text {
    font-size: 13px;
    color: var(--text-muted, #888);
    padding: 4px 0 2px 22px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 90%;
}

.reply-indicator-file {
    font-size: 12px;
    color: var(--text-muted, #888);
    padding: 2px 0 2px 22px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.reply-indicator-file i {
    font-size: 11px;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
/* Loading States */
.loading-state {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    padding: 20px;
    width: 100%;
}

.loading-state.chat-loading {
    min-height: 300px;
}

.loading-spinner-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;
    max-width: 280px;
}

.loading-spinner {
    width: 48px;
    height: 48px;
    border: 4px solid var(--border-color, #e2e8f0);
    border-top: 4px solid var(--primary, #6C5CE7);
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.loading-text {
    color: var(--text-secondary, #64748b);
    font-size: 14px;
    font-weight: 500;
    text-align: center;
}

.loading-progress-bar {
    width: 100%;
    height: 4px;
    background: var(--border-color, #e2e8f0);
    border-radius: 4px;
    overflow: hidden;
}

.loading-progress-fill {
    height: 100%;
    background: linear-gradient(90deg, var(--primary, #6C5CE7), var(--primary-light, #a29bfe));
    border-radius: 4px;
    transition: width 0.3s ease;
    width: 0%;
}

/* Skeleton Loading for Letter Items */
.skeleton-item {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    gap: 12px;
    background: var(--bg-card, #ffffff);
    border-radius: 8px;
    margin-bottom: 8px;
    border: 1px solid var(--border-color, #e2e8f0);
}

.skeleton-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: var(--skeleton-bg, #e2e8f0);
    animation: pulse 1.5s ease-in-out infinite;
}

.skeleton-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.skeleton-line {
    height: 12px;
    background: var(--skeleton-bg, #e2e8f0);
    border-radius: 4px;
    animation: pulse 1.5s ease-in-out infinite;
}

.skeleton-line.short {
    width: 60%;
}

.skeleton-line.long {
    width: 80%;
}

@keyframes pulse {
    0%, 100% {
        opacity: 0.6;
    }
    50% {
        opacity: 1;
    }
}
/* ==========================================================================
   LETTERS TABS
   ========================================================================== */

.letters-tabs {
  max-width: 800px;
  width: calc(100% - 30px);
  margin: 16px auto 8px;
  display: flex;
  gap: 8px;
  padding: 6px;
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  border-radius: 14px;
  overflow-x: auto;
  scrollbar-width: none;
  position: sticky;
  top: 76px;             /* below the app-navbar (adjust if header is taller) */
  z-index: 9;
  backdrop-filter: blur(10px);
}

.letters-tabs::-webkit-scrollbar {
  display: none;
}

.letters-tab-btn {
  flex: 1 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: var(--muted);
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s ease, color 0.2s ease, transform 0.15s ease;
}

.letters-tab-btn:hover {
  background: var(--hover);
  color: var(--text);
}

.letters-tab-btn.active {
  background: var(--primary);
  color: #fff;
  box-shadow: 0 4px 12px rgba(108, 92, 231, 0.25);
}

.letters-tab-btn i {
  font-size: 0.95rem;
}

.letters-tab-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 11px;
  background: var(--border);
  color: var(--text);
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.letters-tab-btn.active .letters-tab-count {
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
}

.letters-tab-count.zero {
  opacity: 0.55;
}

/* Mobile tweaks */
@media (max-width: 600px) {
  .letters-tabs {
    width: calc(100% - 20px);
    margin: 10px auto 6px;
    top: 2px;
    padding: 4px;
    gap: 4px;
    border-radius: 12px;
  }

  .letters-tab-btn {
    padding: 8px 10px;
    font-size: 0.78rem;
    gap: 5px;
  }

  .letters-tab-btn i {
    font-size: 0.85rem;
  }

  .letters-tab-count {
    min-width: 18px;
    height: 18px;
    font-size: 0.65rem;
    padding: 0 5px;
  }
}

/* ==========================================================================
   LETTER CLOSE BUTTON
   ========================================================================== */

.letter-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  height: 26px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: rgba(239, 68, 68, 0.12);
  color: #EF4444;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.15s ease, color 0.2s ease;
}

.letter-done-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 10px;
  border: 1px solid rgba(245, 158, 11, 0.42);
  border-radius: 8px;
  background: rgba(245, 158, 11, 0.1);
  color: #b45309;
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.letter-done-toggle:hover:not(:disabled) {
  background: #f59e0b;
  border-color: #f59e0b;
  color: #fff;
}

.letter-done-toggle.is-done,
.letter-done-toggle:disabled {
  border-color: rgba(34, 197, 94, 0.35);
  background: rgba(34, 197, 94, 0.1);
  color: #15803d;
  cursor: default;
}

.letter-done-toggle:focus-visible {
  outline: 2px solid #f59e0b;
  outline-offset: 2px;
}

.letter-close-btn:hover {
  background: #EF4444;
  color: #fff;
  transform: scale(1.08);
}

.letter-close-btn:active {
  transform: scale(0.95);
}

/* ==========================================================================
   RATING MODAL
   ========================================================================== */

.rating-overlay {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  animation: fadeIn 0.2s ease;
  padding: 16px;
}

.rating-modal {
  width: 100%;
  max-width: 480px;
  background: var(--card-bg, #fff);
  border: 1px solid var(--card-border, rgba(214, 227, 222, 0.16));
  border-radius: 20px;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.35);
  overflow: hidden;
  animation: slideUp 0.25s ease;
  direction: rtl;
}

.rating-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 1px solid var(--border, rgba(214, 227, 222, 0.16));
}

.rating-header h3 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--heading, #f5f7f4);
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.rating-header h3 i {
  color: var(--accent, #ed7b32);
}

.rating-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: var(--muted, #8f9db5);
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.rating-close:hover {
  background: rgba(239, 68, 68, 0.12);
  color: #EF4444;
}

.rating-body {
  padding: 22px;
}

.rating-question {
  margin: 0 0 18px;
  color: var(--text, #f5f7f4);
  font-size: 0.95rem;
  text-align: center;
}

/* Emoji row */
.rating-emojis {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 8px;
}

.rating-emoji-btn {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px 4px;
  border: 2px solid transparent;
  border-radius: 14px;
  background: var(--bg, rgba(37, 47, 49, 0.55));
  cursor: pointer;
  transition:
    transform 0.15s ease,
    border-color 0.2s ease,
    background-color 0.2s ease,
    box-shadow 0.2s ease;
}

.rating-emoji-btn:hover {
  transform: translateY(-3px);
  background: rgba(62, 107, 181, 0.1);
}

.rating-emoji-btn.active {
  border-color: var(--accent, #ed7b32);
  background: rgba(237, 123, 50, 0.12);
  box-shadow: 0 6px 18px rgba(237, 123, 50, 0.25);
  transform: translateY(-3px);
}

.rating-emoji {
  font-size: 28px;
  line-height: 1;
}

.rating-label {
  font-size: 0.72rem;
  color: var(--muted, #8f9db5);
  font-weight: 500;
  white-space: nowrap;
}

.rating-emoji-btn.active .rating-label {
  color: var(--accent, #ed7b32);
  font-weight: 700;
}

/* Feedback block */
.rating-feedback {
  margin-top: 20px;
}

.rating-feedback-label {
  display: block;
  margin-bottom: 8px;
  color: var(--text, #f5f7f4);
  font-size: 0.85rem;
  font-weight: 500;
}

.rating-feedback-label .required-star {
  color: #EF4444;
  margin-right: 4px;
}

.rating-textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--card-border, rgba(214, 227, 222, 0.2));
  border-radius: 10px;
  background: var(--bg, #fff);
  color: var(--text, #1a1a1a);
  font-family: inherit;
  font-size: 0.9rem;
  resize: vertical;
  min-height: 70px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.rating-textarea:focus {
  outline: none;
  border-color: var(--accent, #ed7b32);
  box-shadow: 0 0 0 3px rgba(237, 123, 50, 0.15);
}

.rating-error {
  display: block;
  margin-top: 6px;
  color: #EF4444;
  font-size: 0.78rem;
}

/* Footer */
.rating-footer {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding: 16px 22px;
  border-top: 1px solid var(--border, rgba(214, 227, 222, 0.16));
}

.rating-footer .btn {
  padding: 10px 22px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: transform 0.15s ease, background-color 0.2s ease, opacity 0.2s ease;
}

.rating-footer .btn-secondary {
  background: transparent;
  border: 1px solid var(--card-border, rgba(214, 227, 222, 0.2));
  color: var(--text, #f5f7f4);
}

.rating-footer .btn-secondary:hover {
  background: rgba(255, 255, 255, 0.05);
}

.rating-footer .btn-primary {
  background: var(--accent, #ed7b32);
  border: none;
  color: #fff;
}

.rating-footer .btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(237, 123, 50, 0.3);
}

.rating-footer .btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Transition for the feedback area */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

/* Mobile */
@media (max-width: 480px) {
  .rating-modal {
    max-width: 100%;
  }

  .rating-emojis {
    gap: 4px;
  }

  .rating-emoji {
    font-size: 22px;
  }

  .rating-label {
    font-size: 0.62rem;
  }

  .rating-emoji-btn {
    padding: 10px 2px;
  }

  .rating-footer {
    flex-direction: column-reverse;
  }

  .rating-footer .btn {
    width: 100%;
  }
}

/* ==========================================================================
   LETTER CLOSE BUTTON (with label)
   ========================================================================== */

.letter-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 10px;
  border: 1px solid rgba(239, 68, 68, 0.35);
  border-radius: 8px;
  background: rgba(239, 68, 68, 0.1);
  color: #EF4444;
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    transform 0.15s ease,
    box-shadow 0.2s ease;
}

.letter-close-btn i {
  font-size: 11px;
}

.letter-close-btn:hover {
  background: #EF4444;
  border-color: #EF4444;
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 6px 14px rgba(239, 68, 68, 0.3);
}

.letter-close-btn:active {
  transform: translateY(0) scale(0.97);
  box-shadow: none;
}

.letter-close-btn:focus-visible {
  outline: 2px solid #EF4444;
  outline-offset: 2px;
}

/* ==========================================================================
   CLOSED BADGE (with label)
   ========================================================================== */

.letter-closed-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 10px;
  border: 1px solid var(--card-border, rgba(214, 227, 222, 0.16));
  border-radius: 8px;
  background: var(--border, rgba(214, 227, 222, 0.08));
  color: var(--muted, #8f9db5);
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  cursor: default;
  user-select: none;
}

.letter-closed-badge i {
  font-size: 11px;
  opacity: 0.85;
}

/* Small tablets and phones: keep icon + label but shrink */
@media (max-width: 600px) {
  .letter-done-toggle,
  .letter-close-btn,
  .letter-closed-badge {
    padding: 10px 8px;
    gap: 5px;
    font-size: 10px;
  }

  .letter-done-toggle i,
  .letter-close-btn i,
  .letter-closed-badge i {
    font-size: 10px;
  }
}

/* ==========================================================================
   CLOSE CONFIRMATION MODAL
   ========================================================================== */

.close-confirm-overlay {
  position: fixed;
  inset: 0;
  z-index: 99998;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  animation: fadeIn 0.2s ease;
}

.close-confirm-modal {
  width: 100%;
  max-width: 420px;
  padding: 28px 24px 24px;
  background: var(--card-bg, #fff);
  border: 1px solid var(--card-border, rgba(214, 227, 222, 0.16));
  border-radius: 20px;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.4);
  text-align: center;
  direction: rtl;
  animation: slideUp 0.25s ease;
}

/* Icon */
.close-confirm-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin-bottom: 16px;
  border-radius: 50%;
  background: rgba(239, 68, 68, 0.12);
  color: #EF4444;
  font-size: 26px;
  box-shadow: 0 0 0 8px rgba(239, 68, 68, 0.06);
}

/* Title */
.close-confirm-title {
  margin: 0 0 12px;
  color: var(--heading, #f5f7f4);
  font-size: 1.15rem;
  font-weight: 700;
}

/* Message */
.close-confirm-message {
  margin: 0 0 14px;
  color: var(--text, #f5f7f4);
  font-size: 0.95rem;
  line-height: 1.7;
}

/* Detail block */
.close-confirm-detail {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  max-width: 100%;
  margin: 0 auto 14px;
  padding: 10px 14px;
  border-radius: 10px;
  background: rgba(62, 107, 181, 0.1);
  color: var(--text, #f5f7f4);
  font-size: 0.85rem;
  line-height: 1.6;
  text-align: center;
}

.close-confirm-detail-label {
  color: var(--muted, #8f9db5);
  font-weight: 500;
  flex-shrink: 0;
}

.close-confirm-detail-value {
  font-weight: 600;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Note */
.close-confirm-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0 0 22px;
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(237, 123, 50, 0.08);
  color: var(--muted, #8f9db5);
  font-size: 0.78rem;
  line-height: 1.7;
  text-align: start;
}

.close-confirm-note i {
  color: var(--accent, #ed7b32);
  margin-top: 2px;
  flex-shrink: 0;
}

/* Actions */
.close-confirm-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.close-confirm-btn {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 18px;
  border: none;
  border-radius: 12px;
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    color 0.2s ease,
    transform 0.15s ease,
    box-shadow 0.2s ease,
    opacity 0.2s ease;
}

.close-confirm-btn.cancel {
  background: transparent;
  border: 1px solid var(--card-border, rgba(214, 227, 222, 0.2));
  color: var(--text, #f5f7f4);
}

.close-confirm-btn.cancel:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.05);
}

.close-confirm-btn.confirm {
  background: #EF4444;
  color: #fff;
  box-shadow: 0 6px 16px rgba(239, 68, 68, 0.25);
}

.close-confirm-btn.confirm:hover:not(:disabled) {
  background: #DC2626;
  transform: translateY(-2px);
  box-shadow: 0 10px 22px rgba(239, 68, 68, 0.35);
}

.close-confirm-btn.confirm:active:not(:disabled) {
  transform: translateY(0);
}

.close-confirm-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.close-confirm-btn:focus-visible {
  outline: 2px solid var(--accent, #ed7b32);
  outline-offset: 3px;
}

/* Mobile */
@media (max-width: 480px) {
  .close-confirm-modal {
    padding: 22px 18px 18px;
  }

  .close-confirm-icon {
    width: 56px;
    height: 56px;
    font-size: 22px;
  }

  .close-confirm-title {
    font-size: 1.05rem;
  }

  .close-confirm-message {
    font-size: 0.88rem;
  }

  .close-confirm-actions {
    flex-direction: column-reverse;
  }

  .close-confirm-btn {
    width: 100%;
  }
}

/* ==========================================================================
   SIDEBAR FILTER (AC / ACT)
   ========================================================================== */

.letters-filter {
  margin-top: 10px;
  padding: 10px 12px;
  background: var(--bg);
  border: 1px solid var(--card-border);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 54px;
  color: var(--subtext);
  font-size: 12px;
  font-weight: 600;
}

.filter-label i {
  font-size: 12px;
  opacity: 0.7;
}

.filter-select {
  flex: 1;
  min-width: 0;
  padding: 8px 10px;
  border: 1px solid var(--card-border);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--text);
  font-family: inherit;
  font-size: 13px;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.filter-select:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--ring);
}

.filter-select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.filter-clear-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 12px;
  border: none;
  border-radius: 8px;
  background: rgba(239, 68, 68, 0.1);
  color: #EF4444;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.filter-clear-btn:hover {
  background: #EF4444;
  color: #fff;
}

/* ==========================================================================
   MODAL SELECTS
   ========================================================================== */

.form-select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--card-border);
  border-radius: var(--radius-sm, 10px);
  background: var(--bg);
  color: var(--text);
  font-family: inherit;
  font-size: 14px;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  appearance: none;
  background-image:
    linear-gradient(45deg, transparent 50%, var(--subtext) 50%),
    linear-gradient(135deg, var(--subtext) 50%, transparent 50%);
  background-position:
    calc(100% - 18px) calc(50% - 2px),
    calc(100% - 13px) calc(50% - 2px);
  background-size: 5px 5px, 5px 5px;
  background-repeat: no-repeat;
  padding-right: 34px;   /* room for the arrow */
}

.form-select:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--ring);
}

.form-select:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.form-hint.error {
  color: #EF4444;
}
.form-error {
    display: block;
    margin-top: 4px;
    color: #EF4444;
    font-size: 12px;
    line-height: 1.5;
}

.form-input.input-error,
.form-textarea.input-error {
    border-color: #EF4444 !important;
    background-color: rgba(239, 68, 68, 0.05);
}

.form-input.input-error:focus,
.form-textarea.input-error:focus {
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.15);
}
/* ==========================================================================
   UNSEEN BADGES
   ========================================================================== */

.new-msg-pill,
.new-doc-pill {
    display: inline-flex;
    align-items: center;
    margin-inline-start: 6px;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 10px;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
}

.new-msg-pill {
    background: #EF4444;
    color: #fff;
    animation: pulse-new 1.6s ease-in-out infinite;
}

.new-doc-pill {
    background: var(--primary, #6c5ce7);
    color: #fff;
}

@keyframes pulse-new {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.65; }
}

.unread-dot {
    position: absolute;
    top: -4px;
    right: -4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    height: 18px;
    padding: 0 4px;
    background: #EF4444;
    color: #fff;
    font-size: 10px;
    border-radius: 10px;
}

.unread-dot i {
    font-size: 9px;
}

/* ==========================================================================
   SEEN BY BLOCK
   ========================================================================== */

.seen-by-block {
    padding: 14px 16px 8px;
    border-top: 1px solid var(--card-border);
    background: var(--card-bg);
}

.seen-by-title {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--subtext);
    font-size: 12px;
    font-weight: 700;
    margin-bottom: 10px;
    letter-spacing: 0.02em;
}

.seen-by-title i {
    color: var(--primary);
    font-size: 13px;
}

.seen-by-loading,
.seen-by-error,
.seen-by-empty {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    font-size: 12px;
    border-radius: 10px;
    color: var(--subtext);
    background: var(--bg);
}

.seen-by-error {
    color: #EF4444;
    background: rgba(239, 68, 68, 0.08);
}

.seen-by-empty {
    color: var(--text-muted);
    background: var(--bg);
}

.mini-spinner {
    display: inline-block;
    width: 12px;
    height: 12px;
    border: 2px solid var(--card-border);
    border-top-color: var(--primary);
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

.seen-by-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    max-height: 140px;
    overflow-y: auto;
    padding: 4px 2px 6px;
}

.seen-by-item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px 4px 4px;
    border-radius: 20px;
    background: var(--bg);
    border: 1px solid var(--card-border);
    font-size: 12px;
    color: var(--text);
    transition: border-color 0.2s ease, background-color 0.2s ease;
}

.seen-by-item:hover {
    border-color: var(--primary);
    background: var(--ring, rgba(108, 92, 231, 0.08));
}

.seen-by-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--gradient-1), var(--gradient-2));
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    flex-shrink: 0;
}

.seen-by-name {
    white-space: nowrap;
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.letter-mohalkar {
    position: absolute;
    top: 10px;
    right: 16px;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--text);
    font-size: 12px;
    font-weight: 600;
}

/* ============================================================================
   Overflow guard for the message thread/composer

   Reply/forward previews and audio messages used to impose fixed min-widths
   (up to 320px). On narrow screens those widths exceeded the chat area and
   created horizontal overflow, which shifted the thread and hid the composer.
   Keep every flex child shrinkable and let message content wrap instead.
   ============================================================================ */
.chat-app,
.chat-container,
.chat-layout,
.chat-area,
.chat-messages,
.message-wrapper,
.message-bubble-wrapper,
.message-bubble,
.message-content,
.chat-input-area,
.input-wrapper,
.reply-indicator,
.reply-indicator-content,
.forwarded-context,
.original-message-preview,
.message-file,
.message-audio,
.audio-player,
.audio-wrapper {
    min-width: 0 !important;
    max-width: 100%;
    box-sizing: border-box;
}

.chat-app {
    width: 100%;
    overflow-x: hidden;
}

.chat-container,
.chat-layout,
.chat-area {
    width: 100%;
}

.chat-layout,
.chat-area,
.chat-messages {
    min-height: 0;
}

.chat-messages {
    overflow-x: hidden;
    overflow-y: auto;
}

.message-wrapper {
    width: 100%;
    overflow: hidden;
}

.message-bubble-wrapper {
    width: fit-content;
    max-width: min(80%, 100%) !important;
    overflow: hidden;
}

.message-bubble {
    width: auto;
    max-width: 100% !important;
    overflow: hidden;
}

.message-content,
.message-text,
.text-sent,
.text-received,
.reply-context-text,
.forwarded-info,
.forwarded-from,
.forwarded-to,
.preview-text {
    min-width: 0;
    max-width: 100%;
    overflow-wrap: anywhere;
    word-break: break-word;
}

.message-image,
.message-image img,
.message-video,
.message-document,
.original-message-preview,
.forwarded-context {
    max-width: 100%;
}

.message-image img,
.message-video video,
.message-document iframe,
.message-document embed {
    width: 100%;
    max-width: 100%;
    height: auto;
}

.message-audio,
.audio-player,
.audio-wrapper,
.audio-wrapper audio {
    width: 100%;
    min-width: 0 !important;
    max-width: 100%;
}

.audio-player {
    display: flex;
}

.audio-wrapper {
    flex: 1 1 auto;
}

.chat-input-area {
    width: 100%;
    flex: 0 0 auto;
    overflow: hidden;
}

.chat-input-area .input-wrapper {
    flex: 1 1 auto;
    min-width: 0 !important;
    max-width: 100%;
}

.chat-input-area .message-input {
    display: block;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
}

.chat-input-area .input-actions,
.chat-input-area .tool-btn,
.chat-input-area .send-btn {
    flex: 0 0 auto;
}

@media (max-width: 768px) {
    .message-bubble-wrapper {
        max-width: 88% !important;
    }

    .chat-input-area {
        gap: 6px;
        padding-inline: 8px;
    }

    .chat-input-area .input-actions {
        gap: 2px;
    }
}

@media (max-width: 420px) {
    .message-bubble-wrapper {
        max-width: 94% !important;
    }

    .chat-input-area .tool-btn {
        width: 32px;
        height: 32px;
    }

    .chat-input-area .send-btn {
        width: 40px;
        min-width: 40px;
        height: 40px;
    }
}
/* ========================================================
   FIX: Audio Player & Play Icon Visibility in Chat Bubbles
   ======================================================== */

/* ۱. مطمئن شدن از این که حباب پیام صوتی فضای کافی دارد */
.message-bubble-wrapper:has(.message-audio),
.message-bubble:has(.message-audio) {
    min-width: 260px !important;
    width: 100% !important;
    max-width: 85% !important;
}

/* ۲. تنظیم ابعاد و چیدمان کانتینر پلیر */
.message-audio {
    width: 100% !important;
    min-width: 240px !important;
    padding: 4px 0 !important;
}

.audio-player {
    display: flex !important;
    align-items: center !important;
    width: 100% !important;
    min-width: 240px !important;
    gap: 8px !important;
    box-sizing: border-box !important;
}

.audio-wrapper {
    flex: 1 1 auto !important;
    min-width: 200px !important;
    display: flex !important;
    align-items: center !important;
}

/* ۳. رفع فشرده شدن تگ audio و نمایش دکمه پلی */
.audio-wrapper audio {
    width: 100% !important;
    min-width: 200px !important;
    height: 40px !important;
    display: block !important;
}

/* ۴. اولویت دادن به دکمه Play در مرورگرهای WebKit (Chrome, Edge, Safari) */
.audio-wrapper audio::-webkit-media-controls-play-button {
    display: flex !important;
    min-width: 32px !important;
    min-height: 32px !important;
    visibility: visible !important;
    opacity: 1 !important;
}

/* در صورت کمبود فضا در موبایل، تایم‌لاین منعطف بماند اما دکمه Play حذف نشود */
@media (max-width: 480px) {
    .message-bubble-wrapper:has(.message-audio),
    .message-bubble:has(.message-audio) {
        min-width: 230px !important;
        max-width: 92% !important;
    }

    .audio-wrapper audio {
        min-width: 180px !important;
    }
}
/* ========================================================
   Toggle View Button (سوئیچ بین نامه‌های من و نامه‌های عادی)
   ======================================================== */

.toggle-view-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  background: var(--bg);
  color: var(--text);
  border: 1px solid var(--card-border);
  border-radius: 20px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: var(--shadow-1);
  user-select: none;
  direction: rtl;
}

.toggle-view-btn i {
  font-size: 14px;
  color: var(--subtext);
  transition: color 0.25s ease, transform 0.25s ease;
}

.toggle-view-btn .btn-label {
  line-height: 1;
  white-space: nowrap;
}

/* حالت Hover قبل از انتخاب */
.toggle-view-btn:hover {
  background: var(--card-bg);
  border-color: var(--primary);
  color: var(--primary);
  transform: translateY(-1px);
}

.toggle-view-btn:hover i {
  color: var(--primary);
}

/* حالت فعال (وقتی isPersonView فعال است) */
.toggle-view-btn.active-view {
  background: linear-gradient(135deg, var(--gradient-1), var(--gradient-2));
  color: #ffffff;
  border-color: transparent;
  box-shadow: 0 4px 14px rgba(108, 92, 231, 0.35);
}

.toggle-view-btn.active-view i {
  color: #ffffff;
  transform: scale(1.1);
}

.toggle-view-btn.active-view:hover {
  box-shadow: 0 6px 18px rgba(108, 92, 231, 0.45);
  transform: translateY(-2px);
}

/* افکت کلیک (Active) */
.toggle-view-btn:active {
  transform: scale(0.96);
}

/* ریسپانسیو در تبلت و موبایل */
@media (max-width: 640px) {
  .toggle-view-btn {
    width: 40px;
    height: 40px;
    padding: 0;
    border-radius: 50%;
  }

  .toggle-view-btn .btn-label {
    display: none;
  }

  .toggle-view-btn i {
    font-size: 16px;
  }
}
/* ========================================================
   نوار پیشرفت خطی بالای صفحه حین فچ اطلاعات
   ======================================================== */
.top-linear-progress-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background-color: rgba(108, 92, 231, 0.15);
  overflow: hidden;
  z-index: 9999;
}

.top-linear-progress-bar .progress-bar-indeterminate {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #6c5ce7, #a29bfe, #6c5ce7);
  animation: indeterminate-loading 1.4s infinite ease-in-out;
  transform-origin: 0% 50%;
}

@keyframes indeterminate-loading {
  0% {
    transform: translateX(-100%) scaleX(0.2);
  }
  50% {
    transform: translateX(0%) scaleX(0.7);
  }
  100% {
    transform: translateX(100%) scaleX(0.2);
  }
}

/* ========================================================
   دکمه شناور رفتن به پایین صفحه پیام‌ها
   ======================================================== */
.scroll-bottom-floating-btn {
  position: absolute;
  bottom: 85px; /* کمی بالاتر از کادر ورودی پیام */
  left: 28px;   /* در چیدمان راست‌به‌چپ سمت چپ چت قرار می‌گیرد */
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: var(--card-bg, #ffffff);
  color: var(--primary, #6c5ce7);
  border: 1px solid var(--card-border, #e2e8f0);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 40;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.scroll-bottom-floating-btn:hover {
  background: var(--primary, #6c5ce7);
  color: #ffffff;
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(108, 92, 231, 0.35);
}

.scroll-bottom-floating-btn:active {
  transform: scale(0.92);
}

.scroll-bottom-floating-btn i {
  font-size: 15px;
}

/* انیمیشن پدیدار شدن دکمه شناور */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.25s ease;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

</style>
